import { useMessageFormatter, Text, classNames, Tooltip, MdInfo, Button, MdClose, HorizontalScrollable, Popover, useThemeVariable as useThemeVariable$1, TextInput, MdSend, Modal, MdThumbUp, MdOutlineThumbUp, MdThumbDown, MdOutlineThumbDown, Note, MdSquare, MdCircle, ThemeColorValues, SkeletonText, StandaloneIcon, MdExpandMore, useResizeObserver, Pagination, Dialog, UNSAFE_Icon, MdSearch, DsxLoadingSpinner, MdCheckBoxOutlineBlank, MdIndeterminateCheckBox, MdCheckBox, useUniqueId, NumberInput } from '@dsx/react';
import { useState, useMemo, useCallback, createContext, useContext, useRef, useEffect, Fragment as Fragment$1, forwardRef } from 'react';
import { format } from 'd3-format';
import { extent, max } from 'd3-array';
import { scaleLinear, scaleBand } from 'd3-scale';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { curveLinear, curveMonotoneX, area, line } from 'd3-shape';
import { createPortal } from 'react-dom';
import { CSSTransition, Transition } from 'react-transition-group';
import { Virtuoso } from 'react-virtuoso';
import { PieChart as PieChart$1 } from 'react-minimal-pie-chart';

var close = "close";
var enUS$2 = {
	close: close,
	"{count} Selected": "{count} Selected",
	"Clear Selections": "Clear Selections"
};

const messages$4 = {
  'en-US': enUS$2
};
var messages$5 = messages$4;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$c = ".ActionBar-module_ActionBar__Y9OLJ {\n  display: flex;\n  align-items: baseline;\n  position: -webkit-sticky;\n  position: sticky;\n  bottom: var(--size-500);\n  margin: 0 var(--size-1000);\n  border-radius: var(--size-300);\n  border: 1px solid var(--dsx-gray-200);\n  background: var(--dsx-gray-0);\n  padding: var(--size-300);\n  box-shadow: 0px 3px 16px 0px rgba(41, 48, 54, 0.2);\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n}\n.ActionBar-module_ActionBar__Y9OLJ.ActionBar-module_is-open__VVeuc {\n  height: var(--size-900);\n  opacity: 1;\n  transition-delay: 0ms;\n}\n.ActionBar-module_ActionBar__Y9OLJ .ActionBar-module_ActionBar--controls__lDd5l {\n  display: flex;\n  align-items: baseline;\n  flex: 1 1 0%;\n  gap: var(--size-300);\n  white-space: nowrap;\n}\n.ActionBar-module_ActionBar__Y9OLJ .ActionBar-module_ActionBar--actions__QV0o8 {\n  display: flex;\n  align-items: baseline;\n  gap: var(--size-300);\n  flex: 0 0 auto;\n}\n@media (max-width: 620px) {\n  .ActionBar-module_ActionBar__Y9OLJ {\n    margin: 0 var(--size-200);\n  }\n}";
var styles$b = {"ActionBar":"ActionBar-module_ActionBar__Y9OLJ","is-open":"ActionBar-module_is-open__VVeuc","ActionBar--controls":"ActionBar-module_ActionBar--controls__lDd5l","ActionBar--actions":"ActionBar-module_ActionBar--actions__QV0o8"};
styleInject(css_248z$c);

const ActionBar = props => {
  const {
    children,
    selectedCount,
    tag,
    className,
    onClearSelection,
    portalFrom,
    renderCount: renderCount
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$5);
  const isOpen = selectedCount > 0;
  const countEl = renderCount ? renderCount(selectedCount) : /*#__PURE__*/jsx(Text, {
    children: formatMessage('{count} Selected', {
      count: selectedCount
    })
  });
  const [isHovering, setIsHovering] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const bar = /*#__PURE__*/jsxs("div", {
    className: classNames(styles$b['ActionBar'], isOpen && styles$b['is-open'], className),
    "data-dsx--action-bar": tag,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$b['ActionBar--controls'],
      children: [/*#__PURE__*/jsx("div", {
        onMouseEnter: () => setIsHovering(true),
        onMouseLeave: () => setIsHovering(false),
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false),
        children: /*#__PURE__*/jsx(Tooltip, {
          contents: formatMessage('Clear Selections'),
          isOpen: isHovering || isFocused,
          icon: MdInfo,
          showTip: true,
          children: /*#__PURE__*/jsx(Button, {
            variant: "ui-control",
            icon: MdClose,
            label: "deselect",
            iconOnly: true,
            onClick: onClearSelection,
            children: formatMessage('close')
          })
        })
      }), /*#__PURE__*/jsx("div", {
        children: countEl
      })]
    }), /*#__PURE__*/jsx(HorizontalScrollable, {
      className: styles$b['ActionBar--actions'],
      children: children
    })]
  });
  if (portalFrom) {
    return /*#__PURE__*/createPortal(bar, portalFrom);
  }
  return bar;
};

const invariant = (test, message) => {
  if (test) return;
  const error = new Error(message);
  error.name = 'Invariant Violation';
  throw error;
};

const TICK_LENGTH = 5;
const GROUP_PADDING = 0.3;
const LEGEND_TEXT_HEIGHT = 16;
const LEGEND_MARGIN_BOTTOM$1 = 16;

function useFormatter(_ref) {
  let {
    formatString,
    formatterOverride
  } = _ref;
  const formatter = formatterOverride !== null && formatterOverride !== void 0 ? formatterOverride : format(formatString);
  return {
    formatter
  };
}

const getXValue$1 = (obj, data) => {
  invariant(!!obj.getX || data.x != null, 'Data must either have an x defined or the dataset must have getX defined');
  return obj.getX ? obj.getX(data) : data.x;
};

const getYValue$1 = (obj, data) => {
  invariant(!!obj.getY || data.y != null, 'Data must either have a y defined or the dataset must have getY defined');
  return obj.getY ? obj.getY(data) : data.y;
};

function useGraphDomains$1(_ref) {
  let {
    datasets,
    stacked = false,
    zeroMinimum = true
  } = _ref;
  const x = useMemo(() => {
    const xValues = datasets.flatMap(dataset => dataset.data.map(datum => getXValue$1(dataset, datum)));
    const xSet = new Set(xValues);
    return [...xSet];
  }, [datasets]);
  const xSub = useMemo(() => {
    return datasets.map(dataset => dataset.label);
  }, [datasets]);
  const y = useMemo(() => {
    const yValues = stacked ? datasets.map(dataset => dataset.data.map(datum => getYValue$1(dataset, datum))).reduce((sums, values) => values.map((x, i) => x + sums[i]), []) : datasets.flatMap(dataset => dataset.data.map(datum => getYValue$1(dataset, datum)));
    if (stacked || zeroMinimum) {
      yValues.push(0);
    }
    return extent(yValues);
  }, [datasets, zeroMinimum, stacked]);
  return {
    x,
    xSub,
    y
  };
}

function getHeight(metrics) {
  return metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
}
function useTextBounds(fontFamily) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const getTextBounds = useCallback(function (text, fontSize) {
    let {
      ignoreSpaces = true,
      ignoreKerning = true
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!context) {
      return {
        width: 0,
        height: 0
      };
    }
    context.font = "".concat(fontSize, "px ").concat(fontFamily);
    if (ignoreSpaces) {
      text = text.replace(/\s/g, '');
    }
    const width = ignoreKerning ? [...text].map(char => context.measureText(char).width).reduce((a, b) => a + b, 0) : context.measureText(text).width;
    const height = getHeight(context.measureText(text));
    return {
      width,
      height
    };
  }, [context, fontFamily]);
  return {
    getTextBounds
  };
}

function adjustBounds(size) {
  // Allocate extra space for text width calculations because the result from `getTextBounds` is not exact;
  // error is larger with longer texts, so we use a multiplier.
  const MULTIPLIER = 1.1;
  return {
    width: size.width * MULTIPLIER,
    height: size.height
  };
}
function useGraphOffsets$1(_ref) {
  let {
    axisEpsilon,
    domains,
    fontFamily,
    formatter,
    labelEpsilon,
    labelFontSize,
    legendHeight,
    skewLabels,
    tickLength,
    ticks,
    yLabel,
    xLabel
  } = _ref;
  const {
    getTextBounds
  } = useTextBounds(fontFamily);

  /* Bounds of a skewed box have width and height = (w + h)/√(2)
   *  ┌──────┐ ┐
   *  │ ╱╲   │ │
   *  │╱  ╲w │ │ w / √(2)
   *  │╲   ╲ │ │
   *  │ ╲   ╲│ ┘
   *  │  ╲  ╱│ ┐
   *  │   ╲╱h│ │ h / √(2)
   *  └──────┘ ┘
   */
  const xTickLabelBounds = domains.x.map(x => adjustBounds(getTextBounds(x, labelFontSize)));
  const skewedXTickLabelSizes = xTickLabelBounds.map(size => (size.width + size.height) / Math.SQRT2);
  const xTickLabelHeightLargest = skewLabels ? max(skewedXTickLabelSizes) : labelFontSize;
  const xTickLabelWidthFirst = skewLabels ? 0 : xTickLabelBounds[0].width / 2;
  const xTickLabelWidthLast = skewLabels ? skewedXTickLabelSizes.at(-1) : xTickLabelBounds.at(-1).width / 2;
  const yTickLabels = scaleLinear().domain(domains.y).nice(ticks).ticks(ticks).map(tick => formatter(tick));
  const yLabelBounds = yTickLabels.map(y => adjustBounds(getTextBounds(y, labelFontSize)));
  const yTickLabelWidthLargest = max(yLabelBounds.map(size => size.width));
  const topOffset = legendHeight + LEGEND_MARGIN_BOTTOM$1;
  const rightOffset = xTickLabelWidthLast;
  const bottomOffset = xTickLabelHeightLargest + tickLength + labelEpsilon + (xLabel ? labelFontSize : 0);
  const leftOffset = Math.max(yTickLabelWidthLargest + tickLength + axisEpsilon + (yLabel ? labelFontSize : 0), xTickLabelWidthFirst);
  return {
    top: topOffset,
    right: rightOffset,
    bottom: bottomOffset,
    left: leftOffset
  };
}

function useGraphRanges$1(_ref) {
  let {
    width,
    height,
    offsets
  } = _ref;
  // Create ranges - the points the graph will be plotted in
  const x = [offsets.left, width - offsets.right];
  const y = [height - offsets.bottom, offsets.top];
  return {
    x,
    y
  };
}

function useGraphScales$1(_ref) {
  let {
    domains,
    ranges,
    ticks
  } = _ref;
  // Create scales that allow mapping between data and SVG coordinates
  const x = scaleBand().domain(domains.x).range(ranges.x).padding(GROUP_PADDING);
  const xSub = scaleBand().domain(domains.xSub).range([0, x.bandwidth()]);
  const y = scaleLinear().domain(domains.y).nice(ticks).range(ranges.y);
  return {
    x,
    xSub,
    y
  };
}

const HoverContext = /*#__PURE__*/createContext(null);
function useHover() {
  const ctx = useContext(HoverContext);
  if (ctx == null) {
    throw new Error('A `<HoverProvider /> component must be included in the component tree.');
  }
  return ctx;
}
function HoverProvider(_ref) {
  let {
    children,
    onHover
  } = _ref;
  const [hoverRef, setHoverRef] = useState(null);
  const [hoverContent, setHoverContent] = useState(null);
  const [focusRef, setFocusRef] = useState(null);
  const [focusContent, setFocusContent] = useState(null);
  const activeRef = hoverRef !== null && hoverRef !== void 0 ? hoverRef : focusRef;
  const activeContent = hoverRef != null ? hoverContent : focusContent;
  const ctx = {
    onMouseOverDatapoint(_ref2) {
      let {
        ref,
        ...props
      } = _ref2;
      setHoverRef(ref);
      setHoverContent(onHover === null || onHover === void 0 ? void 0 : onHover(props));
    },
    onFocusDatapoint(_ref3) {
      let {
        ref,
        ...props
      } = _ref3;
      setFocusRef(ref);
      setFocusContent(onHover === null || onHover === void 0 ? void 0 : onHover(props));
      setHoverRef(null);
      setHoverContent(null);
    },
    onMouseOutDatapoint() {
      setHoverRef(null);
      setHoverContent(null);
    },
    onBlurDatapoint() {
      setFocusRef(null);
      setFocusContent(null);
    },
    focusRef,
    activeRef,
    activeContent
  };
  return /*#__PURE__*/jsx(HoverContext.Provider, {
    value: ctx,
    children: children
  });
}

// Gap between the shape and the text
const ICON_TEXT_GAP$1 = 8;
function LegendElement$1(_ref) {
  var _dataset$color, _dataset$color2;
  let {
    dataset,
    textHeight,
    iconWidth: iconSize,
    size,
    defaultStrokeAndFillColor
  } = _ref;
  const stroke = (_dataset$color = dataset.color) !== null && _dataset$color !== void 0 ? _dataset$color : defaultStrokeAndFillColor;
  const fill = (_dataset$color2 = dataset.color) !== null && _dataset$color2 !== void 0 ? _dataset$color2 : defaultStrokeAndFillColor;
  const iconYPos = textHeight * 0.6;
  const textX = iconSize + ICON_TEXT_GAP$1;
  const textWidth = size - textX;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("circle", {
      cx: iconSize / 2,
      cy: iconYPos,
      r: iconSize / 2,
      stroke: stroke,
      fill: fill,
      opacity: 1
    }), /*#__PURE__*/jsx("text", {
      x: textX,
      y: textHeight,
      textLength: textWidth,
      lengthAdjust: "spacingAndGlyphs",
      children: dataset.label
    })]
  });
}

const LINE_SPACING$1 = 1.4;

// Minimum amount of space between consecutive legend items
const MIN_PADDING$1 = 16;
// Lays out a single line, like flexbox with space-around
// Returns an array of x-values
function layoutSingleLine$1(width, sizes) {
  const totalWidth = sizes.reduce((acc, size) => acc + size, 0);
  const totalPadding = width - totalWidth;
  const padding = totalPadding / (sizes.length + 1);
  let totalX = padding;
  const positions = [];
  for (const size of sizes) {
    const elementX = totalX;
    totalX += size + padding;
    positions.push({
      x: elementX,
      size
    });
  }
  return positions;
}

// Lays out multiple lines, wrapping when each line fills up
function layoutLines$1(textHeight, width, sizes) {
  sizes = sizes.map(size => Math.min(size, width - MIN_PADDING$1));
  function generateLine(lastIndex) {
    const firstIndex = items.length;
    const line = layoutSingleLine$1(width, sizes.slice(firstIndex, lastIndex));
    items.push(...line.map(layout => ({
      ...layout,
      y: currentLineYValue
    })));
  }
  const items = [];
  let currentLineYValue = 0;
  let currentLineWidth = 0;
  for (let i = 0; i < sizes.length; i++) {
    const datasetWidth = sizes[i] + MIN_PADDING$1;
    if (currentLineWidth + datasetWidth > width) {
      generateLine(i);
      currentLineWidth = 0;
      currentLineYValue += textHeight * LINE_SPACING$1;
    }
    currentLineWidth += datasetWidth;
  }
  if (items.length !== sizes.length) {
    generateLine(sizes.length);
  }
  return {
    layout: items,
    height: currentLineYValue + textHeight
  };
}
function useLegendLayout$1(datasets, textHeight, width, fontFamily) {
  const {
    getTextBounds
  } = useTextBounds(fontFamily);
  return useMemo(() => {
    const sizes = datasets.map(dataset => {
      const iconScale = 0.5;
      const iconWidth = textHeight * iconScale;
      const {
        width: textWidth
      } = getTextBounds(dataset.label, textHeight, {
        ignoreSpaces: false,
        ignoreKerning: false
      });
      const size = iconWidth + ICON_TEXT_GAP$1 + textWidth;
      return {
        iconWidth,
        size
      };
    });
    const {
      layout,
      height
    } = layoutLines$1(textHeight, width, sizes.map(_ref => {
      let {
        size
      } = _ref;
      return size;
    }));
    return {
      layout: layout.map((layout, index) => ({
        ...layout,
        iconWidth: sizes[index].iconWidth,
        dataset: datasets[index]
      })),
      height
    };
  }, [getTextBounds, datasets, textHeight, width]);
}

var css_248z$b = ".BarChart-module_graph__gWFr5 {\n  pointer-events: none;\n}\n.BarChart-module_graph__gWFr5 .BarChart-module_axisLine__Xmuml {\n  stroke: var(--color-neutral);\n}\n.BarChart-module_graph__gWFr5 .BarChart-module_gridLine__TAqoB {\n  stroke: var(--color-gray-700);\n  opacity: 0.2;\n  stroke-dasharray: 2;\n  animation: BarChart-module_drawIn__0KonU 10s linear forwards;\n}\n.BarChart-module_graph__gWFr5 path {\n  animation: BarChart-module_drawIn__0KonU 10s linear forwards;\n}\n.BarChart-module_graph__gWFr5 .BarChart-module_legend__4iJLo {\n  animation: BarChart-module_fadeIn__tZuZj 300ms linear forwards;\n}\n.BarChart-module_graph__gWFr5 circle {\n  animation: BarChart-module_fadeIn__tZuZj 300ms linear forwards;\n}\n\n.BarChart-module_chartContainer__EwDCq {\n  position: relative;\n  font-size: var(--size-400);\n}\n\n.BarChart-module_hoverContentContainer__Teg-3 {\n  box-shadow: 0 2px 7px -2px rgba(0, 0, 0, 0.16);\n  z-index: 200;\n  position: absolute;\n  border-radius: var(--border-radius-default);\n  margin: 0 0 var(--size-400) var(--size-400);\n}\n\n.BarChart-module_hoverPortal__IwJHJ {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.BarChart-module_hoverFadeInStart__B9DHS {\n  opacity: 0;\n}\n\n.BarChart-module_hoverFadeInActive__Z1MZ3 {\n  opacity: 1;\n  transition: opacity 300ms linear;\n}\n\n.BarChart-module_hoverFadeOutEnter__qcEsb {\n  opacity: 1;\n}\n\n.BarChart-module_hoverFadeOutActive__G7IB- {\n  opacity: 0;\n  transition: opacity 300ms linear;\n}\n\n@keyframes BarChart-module_fadeIn__tZuZj {\n  from {\n    opacity: 0;\n  }\n}";
var styles$a = {"motion-duration-response":"300ms","graph":"BarChart-module_graph__gWFr5","axisLine":"BarChart-module_axisLine__Xmuml","gridLine":"BarChart-module_gridLine__TAqoB","drawIn":"BarChart-module_drawIn__0KonU","legend":"BarChart-module_legend__4iJLo","fadeIn":"BarChart-module_fadeIn__tZuZj","chartContainer":"BarChart-module_chartContainer__EwDCq","hoverContentContainer":"BarChart-module_hoverContentContainer__Teg-3","hoverPortal":"BarChart-module_hoverPortal__IwJHJ","hoverFadeInStart":"BarChart-module_hoverFadeInStart__B9DHS","hoverFadeInActive":"BarChart-module_hoverFadeInActive__Z1MZ3","hoverFadeOutEnter":"BarChart-module_hoverFadeOutEnter__qcEsb","hoverFadeOutActive":"BarChart-module_hoverFadeOutActive__G7IB-"};
styleInject(css_248z$b);

var css_248z$a = ".Bar-module_hover-target__ngLYp {\n  height: 100%;\n  width: 100%;\n  pointer-events: auto;\n}\n\n.Bar-module_hover__NL8-H {\n  opacity: 0.7;\n}\n\n.Bar-module_focus__hr7d7 {\n  opacity: 0.7;\n}\n\n[data-dsx--popover--anchor=\"bar-chart-hover\"] {\n  display: inline !important;\n  display: initial !important;\n}\n\n.Bar-module_popover__FloWH > * {\n  padding: 0 !important;\n}";
var styles$9 = {"hover-target":"Bar-module_hover-target__ngLYp","hover":"Bar-module_hover__NL8-H","focus":"Bar-module_focus__hr7d7","popover":"Bar-module_popover__FloWH"};
styleInject(css_248z$a);

function Bar(_ref) {
  let {
    data,
    x,
    y0,
    y1,
    width,
    label,
    xValue,
    yValue,
    fill
  } = _ref;
  const height = y1 - y0;
  const ref = useRef(null);
  const {
    onMouseOverDatapoint,
    onFocusDatapoint,
    onMouseOutDatapoint,
    onBlurDatapoint,
    focusRef,
    activeRef,
    activeContent
  } = useHover();
  function handleMouseOver() {
    onMouseOverDatapoint({
      data,
      label,
      x: xValue,
      y: yValue,
      ref: ref.current
    });
  }
  function handleFocus() {
    onFocusDatapoint({
      data,
      label,
      x: xValue,
      y: yValue,
      ref: ref.current
    });
  }
  const isActive = ref.current != null && ref.current === activeRef && activeContent != null;
  const isFocused = ref.current != null && ref.current === focusRef;
  const className = classNames(isActive && styles$9['hover'], isFocused && styles$9['focus']);
  return /*#__PURE__*/jsxs("g", {
    ref: ref,
    children: [/*#__PURE__*/jsx("foreignObject", {
      x: x,
      y: y0,
      width: width,
      height: height,
      children: /*#__PURE__*/jsx(Popover, {
        className: styles$9['popover'],
        contents: activeContent,
        isOpen: isActive,
        placement: "right",
        tag: "bar-chart-hover",
        showTip: true,
        children: /*#__PURE__*/jsx("div", {
          className: styles$9['hover-target'],
          onMouseOver: handleMouseOver,
          onMouseOut: onMouseOutDatapoint,
          onFocus: handleFocus,
          onBlur: onBlurDatapoint,
          tabIndex: 0
        })
      })
    }), /*#__PURE__*/jsx("rect", {
      className: className,
      x: x,
      y: y0,
      height: height,
      width: width,
      fill: fill
    })]
  });
}

function BarGroup(_ref) {
  let {
    barStrokeAndFill,
    datasets,
    ranges,
    scales,
    xValue
  } = _ref;
  const groupX = scales.x(xValue);
  return /*#__PURE__*/jsx("g", {
    transform: "translate(".concat(groupX, ")"),
    children: datasets.map(dataset => {
      var _dataset$color;
      const data = dataset.data.find(data => getXValue$1(dataset, data) === xValue);
      if (!data) return;
      const x = scales.xSub(dataset.label);
      const width = scales.xSub.bandwidth();
      const yValue = getYValue$1(dataset, data);
      const y0 = scales.y(yValue);
      const y1 = ranges.y[0];
      return /*#__PURE__*/jsx(Bar, {
        data: data,
        x: x,
        y0: y0,
        y1: y1,
        width: width,
        label: dataset.label,
        xValue: xValue,
        yValue: yValue,
        fill: (_dataset$color = dataset.color) !== null && _dataset$color !== void 0 ? _dataset$color : barStrokeAndFill
      }, dataset.label);
    })
  }, xValue);
}

function BarStack(_ref) {
  let {
    barStrokeAndFill,
    datasets,
    ranges,
    scales,
    xValue
  } = _ref;
  const groupX = scales.x(xValue);
  let yOffset = 0;
  return /*#__PURE__*/jsx("g", {
    transform: "translate(".concat(groupX, ")"),
    children: datasets.map(dataset => {
      var _dataset$color;
      const data = dataset.data.find(data => getXValue$1(dataset, data) === xValue);
      if (!data) return;
      const width = scales.x.bandwidth();
      const yValue = getYValue$1(dataset, data);
      const y0 = scales.y(yValue) - yOffset;
      const y1 = ranges.y[0] - yOffset;
      yOffset += y1 - y0;
      return /*#__PURE__*/jsx(Bar, {
        data: data,
        x: 0,
        y0: y0,
        y1: y1,
        width: width,
        label: dataset.label,
        xValue: xValue,
        yValue: yValue,
        fill: (_dataset$color = dataset.color) !== null && _dataset$color !== void 0 ? _dataset$color : barStrokeAndFill
      }, dataset.label);
    })
  }, xValue);
}

function BottomAxis$1(_ref) {
  let {
    offset,
    scale,
    range,
    data,
    tickLength,
    height,
    skewLabels,
    labelEpsilon,
    textHeight,
    fillColor,
    xLabel
  } = _ref;
  const y = height - offset;
  const adjustedY = y + tickLength + labelEpsilon;
  const tickOffset = scale.bandwidth() / 2;
  const getCenterBand = d => {
    var _scale;
    return ((_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0) + tickOffset;
  };
  const textProps = datum => skewLabels ? {
    transform: "translate(".concat(getCenterBand(datum), " ").concat(adjustedY, ") rotate(45)"),
    textAnchor: 'start',
    alignmentBaseline: 'central'
  } : {
    x: getCenterBand(datum),
    y: adjustedY + textHeight / 2,
    textAnchor: 'middle'
  };
  return /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("line", {
      x1: range[0],
      x2: range[1],
      y1: y,
      y2: y,
      className: styles$a.axisLine
    }), xLabel && /*#__PURE__*/jsx("text", {
      x: (range[0] - range[1]) / 2 + range[1],
      y: height,
      textAnchor: "middle",
      children: xLabel
    }), data.map(datum => /*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsx("line", {
        x1: getCenterBand(datum),
        x2: getCenterBand(datum),
        y1: y,
        y2: y + tickLength,
        className: styles$a.axisLine
      }), /*#__PURE__*/jsx("text", {
        fill: fillColor,
        ...textProps(datum),
        fontSize: textHeight,
        children: datum
      })]
    }, datum))]
  });
}

function DebugView(_ref) {
  let {
    width,
    height,
    offsets
  } = _ref;
  return /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("line", {
      x1: 0,
      x2: width,
      y1: offsets.top,
      y2: offsets.top,
      stroke: "red"
    }), /*#__PURE__*/jsx("line", {
      x1: 0,
      x2: width,
      y1: height - offsets.bottom,
      y2: height - offsets.bottom,
      stroke: "red"
    }), /*#__PURE__*/jsx("line", {
      x1: offsets.left,
      x2: offsets.left,
      y1: 0,
      y2: height,
      stroke: "red"
    }), /*#__PURE__*/jsx("line", {
      x1: width - offsets.right,
      x2: width - offsets.right,
      y1: 0,
      y2: height,
      stroke: "red"
    }), /*#__PURE__*/jsx("rect", {
      x: 0,
      y: 0,
      width: width,
      height: height,
      stroke: "black",
      fill: "transparent"
    })]
  });
}

function LeftAxis$1(_ref) {
  let {
    width,
    scale,
    offset,
    range,
    tickLength,
    formatter,
    ticks,
    hideYAxis,
    axisEpsilon,
    textHeight,
    yLabel
  } = _ref;
  const scaleTicks = scale.ticks(ticks);
  return /*#__PURE__*/jsxs("g", {
    children: [yLabel && /*#__PURE__*/jsx("text", {
      transform: "translate(0, ".concat((range[0] - range[1]) / 2 + range[1], ") rotate(-90)"),
      dominantBaseline: "hanging",
      textAnchor: "middle",
      children: yLabel
    }), !hideYAxis && /*#__PURE__*/jsx("line", {
      x1: offset,
      x2: offset,
      y1: range[0],
      y2: range[1],
      className: styles$a.axisLine
    }), scaleTicks.map(tick => {
      const y = scale(tick);
      return /*#__PURE__*/jsxs("g", {
        children: [!hideYAxis && /*#__PURE__*/jsx("line", {
          x1: offset - tickLength * 1.25,
          x2: offset,
          y1: y,
          y2: y,
          className: styles$a.axisLine
        }), /*#__PURE__*/jsx("line", {
          x1: offset,
          x2: width,
          y1: y,
          y2: y,
          className: styles$a.gridLine
        }), /*#__PURE__*/jsx("text", {
          x: offset - axisEpsilon - tickLength * 1.25,
          y: y,
          dominantBaseline: "middle",
          textAnchor: "end",
          fontSize: textHeight,
          children: formatter(tick)
        })]
      }, tick);
    })]
  });
}

function Legend$1(_ref) {
  let {
    layout,
    textHeight,
    defaultStrokeAndFill
  } = _ref;
  return /*#__PURE__*/jsx("g", {
    className: styles$a.legend,
    children: layout.map(layout => /*#__PURE__*/jsx("g", {
      transform: "translate(".concat(layout.x, ",").concat(layout.y, ")"),
      children: /*#__PURE__*/jsx(LegendElement$1, {
        dataset: layout.dataset,
        iconWidth: layout.iconWidth,
        size: layout.size,
        textHeight: textHeight,
        defaultStrokeAndFillColor: defaultStrokeAndFill
      })
    }, layout.dataset.label))
  });
}

function Chart$1(_ref) {
  let {
    axisEpsilon,
    barStrokeAndFill,
    bottomAxisFill,
    datasets,
    debug,
    domains,
    formatter,
    height,
    hideYAxis,
    labelEpsilon,
    labelFontSize,
    legendDefaultStrokeAndFill,
    legendLayout,
    legendTextHeight,
    offsets,
    ranges,
    scales,
    skewLabels,
    stacked,
    tickLength,
    ticks,
    width,
    yLabel,
    xLabel
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: styles$a.chartContainer,
    style: {
      height,
      width
    },
    children: /*#__PURE__*/jsxs("svg", {
      height: height,
      width: width,
      className: styles$a.graph,
      children: [/*#__PURE__*/jsx(Legend$1, {
        layout: legendLayout,
        textHeight: legendTextHeight,
        defaultStrokeAndFill: legendDefaultStrokeAndFill
      }), domains.x.map(xValue => stacked ? /*#__PURE__*/jsx(BarStack, {
        barStrokeAndFill: barStrokeAndFill,
        datasets: datasets,
        ranges: ranges,
        scales: scales,
        xValue: xValue
      }, xValue) : /*#__PURE__*/jsx(BarGroup, {
        barStrokeAndFill: barStrokeAndFill,
        datasets: datasets,
        ranges: ranges,
        scales: scales,
        xValue: xValue
      }, xValue)), /*#__PURE__*/jsx(LeftAxis$1, {
        offset: offsets.left,
        scale: scales.y,
        range: ranges.y,
        width: ranges.x[1],
        tickLength: tickLength,
        formatter: formatter,
        ticks: ticks,
        hideYAxis: hideYAxis,
        axisEpsilon: axisEpsilon,
        textHeight: labelFontSize,
        yLabel: yLabel
      }), /*#__PURE__*/jsx(BottomAxis$1, {
        offset: offsets.bottom,
        scale: scales.x,
        range: ranges.x,
        data: domains.x,
        tickLength: tickLength,
        height: height,
        skewLabels: skewLabels,
        labelEpsilon: labelEpsilon,
        textHeight: labelFontSize,
        fillColor: bottomAxisFill,
        xLabel: xLabel
      }), debug && /*#__PURE__*/jsx(DebugView, {
        width: width,
        height: height,
        offsets: offsets
      })]
    })
  });
}

function BarChart(_ref) {
  let {
    height = 320,
    width = 640,
    formatString = '.2s',
    formatterOverride,
    axisEpsilon = 0,
    ticks = 10,
    datasets,
    zeroMinimum = true,
    onHover,
    hideYAxis = false,
    skewLabels = false,
    labelEpsilon = 8,
    labelFontSize = 16,
    stacked = false,
    tag,
    yLabel,
    xLabel,
    UNSAFE_debug: debug = false
  } = _ref;
  invariant(new Set(datasets.map(_ref2 => {
    let {
      label
    } = _ref2;
    return label;
  })).size === datasets.length, 'Datasets must all have unique labels');
  const legendTextHeight = LEGEND_TEXT_HEIGHT;
  const tickLength = TICK_LENGTH;
  const graphRef = useRef(null);
  const fontFamily = useThemeVariable$1('font-stack-primary', graphRef);
  const bottomAxisFill = useThemeVariable$1('color-gray-800', graphRef);
  const legendDefaultStrokeAndFill = useThemeVariable$1('color-default', graphRef);
  const barStrokeAndFill = useThemeVariable$1('color-gray-200', graphRef);
  const legendDatasets = useMemo(() => [...datasets].sort((a, b) => {
    if (a.legendOrder === b.legendOrder) {
      return 0;
    } else if (b.legendOrder === undefined) {
      return -1;
    } else if (a.legendOrder === undefined) {
      return 1;
    } else {
      return a.legendOrder - b.legendOrder;
    }
  }), [datasets]);
  const legendLayout = useLegendLayout$1(legendDatasets, legendTextHeight, width, fontFamily);
  const domains = useGraphDomains$1({
    datasets,
    stacked,
    zeroMinimum
  });
  const {
    formatter
  } = useFormatter({
    formatString,
    formatterOverride
  });
  const offsets = useGraphOffsets$1({
    axisEpsilon,
    domains,
    fontFamily,
    formatter,
    labelEpsilon,
    labelFontSize,
    legendHeight: legendLayout.height,
    skewLabels,
    tickLength,
    ticks,
    yLabel,
    xLabel
  });
  const ranges = useGraphRanges$1({
    width,
    height,
    offsets
  });
  const scales = useGraphScales$1({
    ticks,
    domains,
    ranges
  });
  return /*#__PURE__*/jsx("div", {
    className: "c-bar-chart",
    ref: graphRef,
    "data-dsx-contrib--bar-chart": tag,
    children: /*#__PURE__*/jsx(HoverProvider, {
      onHover: onHover,
      children: /*#__PURE__*/jsx(Chart$1, {
        axisEpsilon: axisEpsilon,
        barStrokeAndFill: barStrokeAndFill,
        bottomAxisFill: bottomAxisFill,
        datasets: datasets,
        debug: debug,
        domains: domains,
        formatter: formatter,
        height: height,
        hideYAxis: hideYAxis,
        labelEpsilon: labelEpsilon,
        labelFontSize: labelFontSize,
        legendDefaultStrokeAndFill: legendDefaultStrokeAndFill,
        legendLayout: legendLayout.layout,
        legendTextHeight: legendTextHeight,
        offsets: offsets,
        ranges: ranges,
        scales: scales,
        skewLabels: skewLabels,
        stacked: stacked,
        tickLength: tickLength,
        ticks: ticks,
        width: width,
        yLabel: yLabel,
        xLabel: xLabel
      })
    })
  });
}

const FeedbackOpenContext = /*#__PURE__*/createContext({
  isFeedbackOpen: false,
  onFeedbackOpenChange: () => {}
});
function FeedbackOpenContextProvider(_ref) {
  let {
    children
  } = _ref;
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const context = useMemo(() => ({
    isFeedbackOpen,
    onFeedbackOpenChange: setIsFeedbackOpen
  }), [isFeedbackOpen, setIsFeedbackOpen]);
  return /*#__PURE__*/jsx(FeedbackOpenContext.Provider, {
    value: context,
    children: children
  });
}

var css_248z$9 = ".ChatInterface-module_dialog__-aXnJ {\n  background-color: var(--color-gray-50);\n  padding: 0;\n  border: none;\n  width: 70rem;\n  height: 95vh;\n  border-radius: var(--border-radius-default);\n  pointer-events: none;\n}\n.ChatInterface-module_dialog__-aXnJ::backdrop {\n  background-color: rgba(var(--color-gray-1000-rgb), 0.65);\n  pointer-events: auto;\n}\n\n.ChatInterface-module_message-container__CU58w {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: var(--size-100);\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n\n.ChatInterface-module_message-text__cl1Lc {\n  background-color: var(--color-neutral-0);\n  border-radius: var(--size-300);\n  padding: var(--size-300);\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-400);\n}\n.ChatInterface-module_message-text__cl1Lc.ChatInterface-module_user-message__vJYr3 {\n  border: 1px solid var(--color-gray-300);\n}\n.ChatInterface-module_message-text__cl1Lc.ChatInterface-module_ask-message__dFJbo {\n  border: 1px solid var(--color-green-300);\n  max-width: 45rem;\n}\n.ChatInterface-module_message-text__cl1Lc.ChatInterface-module_loading-message__Ojkdw {\n  height: 3.25rem;\n  width: 6.25rem;\n  padding: var(--size-400);\n}\n.ChatInterface-module_message-text__cl1Lc.ChatInterface-module_suggested-question__2A9lz {\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  font-style: italic;\n}\n\n.ChatInterface-module_message-container__CU58w .ChatInterface-module_message-text__cl1Lc.ChatInterface-module_ask-message__dFJbo {\n  overflow-x: auto;\n}\n\n.ChatInterface-module_table-pagination__jIX7i {\n  justify-content: flex-end;\n}\n\n.ChatInterface-module_suggested-question-list__iFLqE {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-200);\n  margin-top: var(--size-300);\n  padding-left: var(--size-500);\n  padding-right: var(--size-500);\n}\n.ChatInterface-module_suggested-question-list__iFLqE .ChatInterface-module_suggested-question-text__MrfrY {\n  white-space: normal;\n  text-align: left;\n  color: var(--color-default-500);\n}\n.ChatInterface-module_suggested-question-list__iFLqE .ChatInterface-module_suggested-question-list-header__Op13H,\n.ChatInterface-module_suggested-question-list__iFLqE .ChatInterface-module_suggested-question-text__MrfrY,\n.ChatInterface-module_suggested-question-list__iFLqE .ChatInterface-module_send-button__wrQ4N {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_suggested-question-list-header__Op13H,\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_suggested-question-text__MrfrY,\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_send-button__wrQ4N {\n  transition: opacity 300ms ease-out;\n}\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_suggested-question-list-header__Op13H,\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_send-button__wrQ4N {\n  opacity: 0.25;\n}\n.ChatInterface-module_suggested-question-list__iFLqE.ChatInterface-module_loading__jZuCQ .ChatInterface-module_suggested-question-text__MrfrY {\n  opacity: 0;\n}\n\n.ChatInterface-module_legal-disclaimer__3xREr {\n  padding-left: var(--size-500);\n  padding-right: var(--size-500);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ChatInterface-module_user-message-container__CLCzU,\n.ChatInterface-module_ask-message-container__AsIge,\n.ChatInterface-module_loading-message-container__hnXop {\n  display: flex;\n  flex-direction: column;\n}\n\n.ChatInterface-module_user-message-container__CLCzU,\n.ChatInterface-module_loading-message-container__hnXop {\n  transform: translateY(0);\n}\n.ChatInterface-module_user-message-container__CLCzU.ChatInterface-module_appear__G9vy3,\n.ChatInterface-module_loading-message-container__hnXop.ChatInterface-module_appear__G9vy3 {\n  transform: translateY(100%);\n}\n.ChatInterface-module_user-message-container__CLCzU.ChatInterface-module_appear-active__iPHt4,\n.ChatInterface-module_loading-message-container__hnXop.ChatInterface-module_appear-active__iPHt4 {\n  transform: translateY(0);\n  transition: transform 300ms ease-in-out;\n}\n\n.ChatInterface-module_user-message-container__CLCzU {\n  align-items: flex-end;\n}\n\n.ChatInterface-module_ask-message-container__AsIge,\n.ChatInterface-module_loading-message-container__hnXop {\n  align-items: flex-start;\n  justify-content: center;\n  gap: var(--size-100);\n}\n\n.ChatInterface-module_scroll-container__p3kDT {\n  padding: 0 var(--size-500);\n}\n\n.ChatInterface-module_chat-outer-container__3Wkh9 {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  pointer-events: auto;\n}\n\n.ChatInterface-module_upper-button-container__td3Jg {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.ChatInterface-module_clear-button__h5wKO {\n  display: flex;\n  align-self: flex-end;\n  align-items: center;\n  margin-left: var(--size-300);\n  height: var(--size-900);\n}\n\n.ChatInterface-module_close-button__BVq6s {\n  display: flex;\n  align-self: flex-end;\n  align-items: center;\n  margin-right: var(--size-300);\n  height: var(--size-900);\n}\n\n.ChatInterface-module_chat-container__0npqZ {\n  --loading-message-height: 3.25rem;\n  --loading-message-width: 6.25rem;\n  height: calc(100% - var(--size-900));\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-300);\n  padding-bottom: var(--size-500);\n}\n\n.ChatInterface-module_question-input-container__22Zyd {\n  flex: none;\n  align-self: stretch;\n  display: flex;\n  gap: var(--size-300);\n  align-items: center;\n  padding-left: var(--size-500);\n  padding-right: var(--size-500);\n}\n\n.ChatInterface-module_send-button__wrQ4N {\n  color: var(--color-primary-500);\n}\n.ChatInterface-module_send-button__wrQ4N:hover:enabled, .ChatInterface-module_send-button__wrQ4N:focus:enabled {\n  color: var(--color-primary-600);\n}\n\n.ChatInterface-module_launch-button__DG1gv {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--color-neutral-0);\n  color: var(--color-neutral-800);\n  border-radius: var(--border-radius-default);\n  border: 1px solid var(--color-gray-400);\n  padding: 0.625rem;\n  height: 2.875rem;\n  width: 100%;\n  max-width: 42rem;\n  transition: 30ms ease border;\n}\n.ChatInterface-module_launch-button__DG1gv:hover {\n  border-color: var(--color-gray-500);\n  cursor: text;\n}\n.ChatInterface-module_launch-button__DG1gv .ChatInterface-module_launch-text__YYmYR {\n  color: var(--color-default-500);\n  font-size: 16px;\n  letter-spacing: var(--letter-spacing-16);\n}\n\n.ChatInterface-module_feedback-container__T0nBq {\n  height: 2.25rem;\n}\n\n.ChatInterface-module_loading-message-container__hnXop {\n  margin-bottom: 2.25rem;\n  padding-left: var(--size-500);\n}\n\n.ChatInterface-module_feedback-icon-positive__kq4TZ {\n  color: var(--color-green-300);\n}\n.ChatInterface-module_feedback-icon-positive__kq4TZ:hover:enabled, .ChatInterface-module_feedback-icon-positive__kq4TZ:focus:enabled {\n  color: var(--color-green-400);\n}\n.ChatInterface-module_feedback-icon-positive__kq4TZ.ChatInterface-module_selected__jP2ap {\n  color: var(--color-green-500);\n  pointer-events: none;\n}\n.ChatInterface-module_feedback-icon-positive__kq4TZ.ChatInterface-module_unselected__qVdPn {\n  color: rgba(var(--color-green-300-rgb), 0.4);\n}\n\n.ChatInterface-module_feedback-icon-negative__RRz10 {\n  color: var(--color-red-300);\n}\n.ChatInterface-module_feedback-icon-negative__RRz10:hover:enabled, .ChatInterface-module_feedback-icon-negative__RRz10:focus:enabled {\n  color: var(--color-red-500);\n}\n.ChatInterface-module_feedback-icon-negative__RRz10.ChatInterface-module_selected__jP2ap {\n  color: var(--color-red-500);\n  pointer-events: none;\n}\n.ChatInterface-module_feedback-icon-negative__RRz10.ChatInterface-module_unselected__qVdPn {\n  color: rgba(var(--color-red-300-rgb), 0.4);\n}\n\n.ChatInterface-module_feedback-modal-body__2JWJN {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-300);\n  width: 30rem;\n}\n\n.ChatInterface-module_feedback-modal-footer__X7072 {\n  display: flex;\n  gap: var(--size-300);\n}\n\n.ChatInterface-module_loading-indicator-container__q5KTZ {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: var(--size-200);\n}\n.ChatInterface-module_loading-indicator-container__q5KTZ .ChatInterface-module_indicator__VkFEP {\n  width: var(--size-400);\n  height: var(--size-400);\n  border-radius: var(--border-radius-full);\n  background-color: var(--color-gray);\n  color: var(--color-gray);\n  animation: ChatInterface-module_flashing__rgvAI 0.8s infinite linear alternate;\n}\n.ChatInterface-module_loading-indicator-container__q5KTZ .ChatInterface-module_indicator__VkFEP.ChatInterface-module_left__RGJ75 {\n  animation-delay: 0s;\n}\n.ChatInterface-module_loading-indicator-container__q5KTZ .ChatInterface-module_indicator__VkFEP.ChatInterface-module_center__K25yd {\n  animation-delay: 0.4s;\n}\n.ChatInterface-module_loading-indicator-container__q5KTZ .ChatInterface-module_indicator__VkFEP.ChatInterface-module_right__6wZ8M {\n  animation-delay: 0.8s;\n}\n@keyframes ChatInterface-module_flashing__rgvAI {\n  0% {\n    background-color: var(--color-gray);\n  }\n  50%, 100% {\n    background-color: rgba(var(--color-gray-rgb), 0.2);\n  }\n}";
var styles$8 = {"dialog":"ChatInterface-module_dialog__-aXnJ","message-container":"ChatInterface-module_message-container__CU58w","message-text":"ChatInterface-module_message-text__cl1Lc","user-message":"ChatInterface-module_user-message__vJYr3","ask-message":"ChatInterface-module_ask-message__dFJbo","loading-message":"ChatInterface-module_loading-message__Ojkdw","suggested-question":"ChatInterface-module_suggested-question__2A9lz","table-pagination":"ChatInterface-module_table-pagination__jIX7i","suggested-question-list":"ChatInterface-module_suggested-question-list__iFLqE","suggested-question-text":"ChatInterface-module_suggested-question-text__MrfrY","suggested-question-list-header":"ChatInterface-module_suggested-question-list-header__Op13H","send-button":"ChatInterface-module_send-button__wrQ4N","loading":"ChatInterface-module_loading__jZuCQ","legal-disclaimer":"ChatInterface-module_legal-disclaimer__3xREr","user-message-container":"ChatInterface-module_user-message-container__CLCzU","ask-message-container":"ChatInterface-module_ask-message-container__AsIge","loading-message-container":"ChatInterface-module_loading-message-container__hnXop","appear":"ChatInterface-module_appear__G9vy3","appear-active":"ChatInterface-module_appear-active__iPHt4","scroll-container":"ChatInterface-module_scroll-container__p3kDT","chat-outer-container":"ChatInterface-module_chat-outer-container__3Wkh9","upper-button-container":"ChatInterface-module_upper-button-container__td3Jg","clear-button":"ChatInterface-module_clear-button__h5wKO","close-button":"ChatInterface-module_close-button__BVq6s","chat-container":"ChatInterface-module_chat-container__0npqZ","question-input-container":"ChatInterface-module_question-input-container__22Zyd","launch-button":"ChatInterface-module_launch-button__DG1gv","launch-text":"ChatInterface-module_launch-text__YYmYR","feedback-container":"ChatInterface-module_feedback-container__T0nBq","feedback-icon-positive":"ChatInterface-module_feedback-icon-positive__kq4TZ","selected":"ChatInterface-module_selected__jP2ap","unselected":"ChatInterface-module_unselected__qVdPn","feedback-icon-negative":"ChatInterface-module_feedback-icon-negative__RRz10","feedback-modal-body":"ChatInterface-module_feedback-modal-body__2JWJN","feedback-modal-footer":"ChatInterface-module_feedback-modal-footer__X7072","loading-indicator-container":"ChatInterface-module_loading-indicator-container__q5KTZ","indicator":"ChatInterface-module_indicator__VkFEP","flashing":"ChatInterface-module_flashing__rgvAI","left":"ChatInterface-module_left__RGJ75","center":"ChatInterface-module_center__K25yd","right":"ChatInterface-module_right__6wZ8M"};
styleInject(css_248z$9);

var cancel = "Cancel";
var submit = "Submit";
var enUS$1 = {
	"close-button": "Close",
	"positive-feedback": "Leave Positive Feedback",
	"negative-feedback": "Leave Negative Feedback",
	"suggested-questions-label": "Here are some suggested questions",
	cancel: cancel,
	submit: submit,
	"positive-feedback-prompt": "What did you like about this response",
	"negative-feedback-prompt": "How can we improve this response"
};

const messages$2 = {
  'en-US': enUS$1
};
var messages$3 = messages$2;

const MeasurementContext = /*#__PURE__*/createContext({
  loadingMessageHeight: '0',
  loadingMessageWidth: '0'
});
function MeasurementsContextProvider(_ref) {
  var _useThemeVariable, _useThemeVariable2;
  let {
    containerRef,
    children
  } = _ref;
  const loadingMessageHeight = (_useThemeVariable = useThemeVariable$1('loading-message-height', containerRef)) !== null && _useThemeVariable !== void 0 ? _useThemeVariable : '0';
  const loadingMessageWidth = (_useThemeVariable2 = useThemeVariable$1('loading-message-width', containerRef)) !== null && _useThemeVariable2 !== void 0 ? _useThemeVariable2 : '0';
  return /*#__PURE__*/jsx(MeasurementContext.Provider, {
    value: {
      loadingMessageHeight,
      loadingMessageWidth
    },
    children: children
  });
}

const useMessageInput = _ref => {
  let {
    onSubmit
  } = _ref;
  const [message, setMessage] = useState('');
  const handleChange = event => {
    setMessage(event.target.value);
  };
  const handleSubmit = () => {
    if (!message.trim()) return;
    onSubmit(message);
    setMessage('');
  };
  return {
    handleChange,
    handleSubmit,
    message
  };
};

function InputField(_ref) {
  let {
    disabled,
    onSubmit,
    autoFocus,
    tag
  } = _ref;
  const inputRef = useRef(null);
  const {
    handleChange,
    handleSubmit,
    message
  } = useMessageInput({
    onSubmit
  });
  const handleFormSubmit = event => {
    event.preventDefault();
  };
  useEffect(() => {
    var _inputRef$current;
    if (disabled) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, [disabled]);
  return /*#__PURE__*/jsxs("form", {
    className: styles$8['question-input-container'],
    onSubmit: handleFormSubmit,
    "data-dsx-contrib--chat-interface--input-form": tag,
    children: [/*#__PURE__*/jsx(TextInput, {
      ref: inputRef,
      disabled: disabled,
      value: message,
      onChange: handleChange,
      autoFocus: autoFocus,
      placeholder: "What would you like to know?",
      "data-dsx-contrib--chat-interface--input": tag
    }), /*#__PURE__*/jsx(Button, {
      disabled: disabled,
      className: styles$8['send-button'],
      onClick: handleSubmit,
      variant: "ui-control",
      type: "submit",
      icon: MdSend,
      size: "large",
      "data-dsx-contrib--chat-interface--input-submit": tag,
      children: "Submit"
    })]
  });
}

function LoadingIndicator() {
  return /*#__PURE__*/jsxs("div", {
    className: styles$8['loading-indicator-container'],
    children: [/*#__PURE__*/jsx("div", {
      className: classNames(styles$8['indicator'], styles$8['left'])
    }), /*#__PURE__*/jsx("div", {
      className: classNames(styles$8['indicator'], styles$8['center'])
    }), /*#__PURE__*/jsx("div", {
      className: classNames(styles$8['indicator'], styles$8['right'])
    })]
  });
}

function MessageTransition(_ref) {
  let {
    nodeRef,
    children,
    onMessageEntered,
    runAnimation = true
  } = _ref;
  return /*#__PURE__*/jsx(CSSTransition, {
    timeout: 600,
    classNames: {
      appear: styles$8['appear'],
      appearActive: styles$8['appear-active'],
      enter: styles$8['appear'],
      enterActive: styles$8['appear-active']
    },
    nodeRef: nodeRef,
    onEntered: onMessageEntered,
    in: runAnimation,
    appear: true,
    children: children
  });
}

function LoadingMessage(_ref) {
  let {
    askOrigin
  } = _ref;
  const containerRef = useRef(null);
  const contentClassName = classNames(styles$8['message-text'], styles$8['ask-message'], styles$8['loading-message']);
  return /*#__PURE__*/jsx(MessageTransition, {
    nodeRef: containerRef,
    children: /*#__PURE__*/jsx("div", {
      className: styles$8['loading-message-container'],
      ref: containerRef,
      children: /*#__PURE__*/jsxs("div", {
        className: styles$8['message-container'],
        children: [/*#__PURE__*/jsx(Text, {
          variant: "helper",
          children: askOrigin
        }), /*#__PURE__*/jsx("div", {
          className: contentClassName,
          children: /*#__PURE__*/jsx(LoadingIndicator, {})
        })]
      })
    })
  });
}

function SuggestedQuestion(_ref) {
  let {
    loading,
    text,
    tag,
    onSubmit
  } = _ref;
  const contentClassName = classNames(styles$8['message-text'], styles$8['suggested-question']);
  const handleClick = () => {
    onSubmit(text);
  };
  return /*#__PURE__*/jsx(Button, {
    label: "Suggested question",
    className: contentClassName,
    disabled: loading,
    tag: "suggested-question--".concat(tag),
    onClick: handleClick,
    actionIndicator: "MdSend",
    variant: "subtle",
    children: /*#__PURE__*/jsx(Text, {
      className: styles$8['suggested-question-text'],
      children: text
    })
  });
}

function SuggestedQuestionList(_ref) {
  let {
    loading,
    suggestedQuestions,
    tag,
    onSuggestedQuestionClick
  } = _ref;
  const {
    formatMessage
  } = useMessageFormatter(messages$3);
  if (!(suggestedQuestions !== null && suggestedQuestions !== void 0 && suggestedQuestions.length)) {
    return null;
  }
  const containerClassName = classNames(styles$8['suggested-question-list'], loading && styles$8['loading']);
  return /*#__PURE__*/jsxs("div", {
    className: containerClassName,
    children: [/*#__PURE__*/jsx(Text, {
      variant: "helper",
      className: styles$8['suggested-question-list-header'],
      children: "".concat(formatMessage('suggested-questions-label'), ":")
    }), suggestedQuestions === null || suggestedQuestions === void 0 ? void 0 : suggestedQuestions.map((question, index) => /*#__PURE__*/jsx(SuggestedQuestion, {
      loading: loading,
      text: question,
      tag: "suggested-question--".concat(tag, "--").concat(index),
      onSubmit: onSuggestedQuestionClick
    }, index))]
  });
}

const initialState = new Map();
const AnimationStateContext = /*#__PURE__*/createContext({
  hasAnimationRan: () => false,
  updateAnimationState: () => {}
});
function AnimationStateProvider(props) {
  const [animationState, setAnimationState] = useState(initialState);
  const hasAnimationRan = id => {
    var _animationState$get;
    return (_animationState$get = animationState.get(id)) !== null && _animationState$get !== void 0 ? _animationState$get : false;
  };
  const updateAnimationState = (id, value) => {
    setAnimationState(prevState => new Map(prevState).set(id, value));
  };
  return /*#__PURE__*/jsx(AnimationStateContext.Provider, {
    value: {
      hasAnimationRan,
      updateAnimationState
    },
    children: props.children
  });
}

let VisualizationType;
(function (VisualizationType) {
  VisualizationType["Text"] = "text";
  VisualizationType["Table"] = "table";
  VisualizationType["Bar"] = "bar";
  VisualizationType["Line"] = "line";
  VisualizationType["Pie"] = "pie";
})(VisualizationType || (VisualizationType = {}));
let MessageDataType;
(function (MessageDataType) {
  MessageDataType["Text"] = "text";
  MessageDataType["Number"] = "number";
  MessageDataType["Boolean"] = "boolean";
  MessageDataType["Date"] = "date";
  MessageDataType["Currency"] = "currency";
  MessageDataType["Percentage"] = "percentage";
})(MessageDataType || (MessageDataType = {}));
let MessageOrigin;
(function (MessageOrigin) {
  MessageOrigin["User"] = "user";
  MessageOrigin["Ask"] = "ask";
})(MessageOrigin || (MessageOrigin = {}));
let Feedback$1;
(function (Feedback) {
  Feedback["Positive"] = "positive";
  Feedback["Negative"] = "negative";
})(Feedback$1 || (Feedback$1 = {}));
function palette(n) {
  const colors = ['var(--color-blue-300)', 'var(--color-green-300)', 'var(--color-yellow-300)', 'var(--color-orange-300)', 'var(--color-red-300)', 'var(--color-purple-300)', 'var(--color-lime-300)', 'var(--color-cyan-300)'];
  return colors[n % colors.length];
}
const MAX_LABEL_LENGTH = 25;
function formatLabelLength(label) {
  if (label.length <= MAX_LABEL_LENGTH) return label;
  return "".concat(label.slice(0, MAX_LABEL_LENGTH - 3), "...");
}

var css_248z$8 = ".DimensionTransition-module_transition-element-container__PjXbJ {\n  --min-height: 0;\n  --min-width: 0;\n  --transition-duration: 250ms;\n  overflow: hidden;\n  transition: height var(--transition-duration) cubic-bezier(0.23, 1, 0.32, 1), width var(--transition-duration) cubic-bezier(0.23, 1, 0.32, 1);\n}\n.DimensionTransition-module_transition-element-container__PjXbJ.DimensionTransition-module_collapsed__NrdJ7 {\n  height: var(--min-height);\n  width: var(--min-width);\n}\n.DimensionTransition-module_transition-element-container__PjXbJ.DimensionTransition-module_expanded__FeUZW {\n  height: auto;\n  width: auto;\n  overflow: visible;\n}";
var styles$7 = {"transition-duration":"250ms","transition-element-container":"DimensionTransition-module_transition-element-container__PjXbJ","collapsed":"DimensionTransition-module_collapsed__NrdJ7","expanded":"DimensionTransition-module_expanded__FeUZW"};
styleInject(css_248z$8);

function isDimensionZero(dim) {
  return typeof dim === 'number' ? dim === 0 : parseInt(dim, 10) === 0;
}

const MIN_HEIGHT_PROP_NAME = 'min-height';
const MIN_WIDTH_PROP_NAME = 'min-width';
const TRANSITION_DURATION = 'transition-duration';
function DimensionTransition(props) {
  const {
    appear,
    className,
    collapsed,
    minHeight = '0',
    minWidth = '0',
    transitionDuration,
    variant,
    onEntered,
    children,
    ...restProps
  } = props;
  const transitionContainerClassName = classNames(styles$7['transition-element-container'], collapsed ? styles$7['collapsed'] : styles$7['expanded'], className);
  const containerRef = useRef(null);
  const containerOpenHeightRef = useRef(0);
  const containerOpenWidthRef = useRef(0);
  const cssTransitionDuration = useThemeVariable$1(TRANSITION_DURATION, containerRef);
  const handleExpandStart = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    container.style.overflow = 'hidden';
    containerOpenHeightRef.current = container.clientHeight;
    containerOpenWidthRef.current = container.clientWidth;
    container.style.visibility = 'visible';
    if (variant === 'height' || variant === 'both') {
      container.style.height = minHeight;
    }
    if (variant === 'width' || variant === 'both') {
      container.style.width = minWidth;
    }
    container.clientHeight; // Force repaint at minimum height value
  }, [minHeight, minWidth, variant]);
  const handleExpanding = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    if (variant === 'height') {
      container.style.height = "".concat(containerOpenHeightRef.current, "px");
    }
    if (variant === 'width' || variant === 'both') {
      container.style.width = "".concat(containerOpenWidthRef.current, "px");
      container.style.height = "".concat(containerOpenHeightRef.current, "px");
    }
  }, [variant]);
  const handleExpandEnd = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    container.style.height = '';
    container.style.width = '';
    container.style.overflow = '';
    onEntered === null || onEntered === void 0 ? void 0 : onEntered();
  }, [onEntered]);
  const handleCollapseStart = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    if (variant === 'width' || variant === 'both') {
      container.style.width = 'auto';
      container.style.width = "".concat(container.clientWidth, "px");
    }
    if (variant === 'height' || variant === 'both') {
      container.style.height = 'auto';
      container.style.height = "".concat(container.clientHeight, "px");
    }
    container.clientHeight; // Force repaint at the new absolute height value
  }, [variant]);
  const handleCollapsing = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    if (variant === 'height') {
      container.style.height = minHeight;
    }
    if (variant === 'width') {
      container.style.height = "".concat(containerOpenHeightRef.current, "px");
      container.style.width = minWidth;
    }
    if (variant === 'both') {
      container.style.height = minHeight;
      container.style.width = minWidth;
    }
  }, [minHeight, minWidth, variant]);
  const handleCollapseEnd = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    container.style.height = '';
    container.style.width = '';
    if (variant === 'height') {
      if (isDimensionZero(minHeight)) {
        container.style.visibility = 'hidden';
      }
    }
    if (variant === 'width') {
      container.style.height = "".concat(containerOpenHeightRef.current, "px");
      if (isDimensionZero(minWidth)) {
        container.style.visibility = 'hidden';
      }
    }
    if (variant === 'both') {
      if (isDimensionZero(minHeight) || isDimensionZero(minWidth)) {
        container.style.visibility = 'hidden';
      }
    }
  }, [minHeight, minWidth, variant]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const minHeightPropName = "--".concat(MIN_HEIGHT_PROP_NAME);
    const minWidthPropName = "--".concat(MIN_WIDTH_PROP_NAME);
    const transitionDurationPropName = "--".concat(TRANSITION_DURATION);
    if (transitionDuration !== undefined) {
      container.style.setProperty(transitionDurationPropName, "".concat(transitionDuration, "ms"));
    }
    if (variant === 'height') {
      container.style.setProperty(minHeightPropName, minHeight);
      container.style.setProperty(minWidthPropName, 'auto');
    }
    if (variant === 'width') {
      container.style.setProperty(minHeightPropName, 'auto');
      container.style.setProperty(minWidthPropName, minWidth);
    }
    if (variant === 'both') {
      container.style.setProperty(minHeightPropName, minHeight);
      container.style.setProperty(minWidthPropName, minWidth);
    }
  }, [minHeight, minWidth, transitionDuration, variant]);
  return /*#__PURE__*/jsx(Transition, {
    nodeRef: containerRef,
    appear: appear,
    in: !collapsed,
    timeout: transitionDuration !== null && transitionDuration !== void 0 ? transitionDuration : parseInt(cssTransitionDuration !== null && cssTransitionDuration !== void 0 ? cssTransitionDuration : '0', 10),
    onEnter: handleExpandStart,
    onEntered: handleExpandEnd,
    onEntering: handleExpanding,
    onExit: handleCollapseStart,
    onExited: handleCollapseEnd,
    onExiting: handleCollapsing,
    children: /*#__PURE__*/jsx("div", {
      ref: containerRef,
      className: transitionContainerClassName,
      ...restProps,
      children: children
    })
  });
}

const useFeedback = _ref => {
  let {
    responseId,
    onFeedback
  } = _ref;
  const [feedback, setFeedback] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const {
    onFeedbackOpenChange
  } = useContext(FeedbackOpenContext);
  const toggleModalOpen = isOpen => {
    setModalOpen(isOpen);
    onFeedbackOpenChange(isOpen);
  };
  const handleFeedback = updatedFeedback => {
    if (updatedFeedback === feedback) return;
    setFeedback(updatedFeedback);
    toggleModalOpen(true);
  };
  const handleFeedbackSubmit = feedbackMessage => {
    onFeedback({
      isPositive: feedback === Feedback$1.Positive,
      feedback: feedbackMessage,
      responseId
    });
    toggleModalOpen(false);
  };
  const handleFeedbackCancel = () => {
    toggleModalOpen(false);
    setFeedback(undefined);
  };
  return {
    handleFeedback,
    handleFeedbackSubmit,
    handleFeedbackCancel,
    modalOpen,
    feedback
  };
};

const useFeedbackModal = _ref => {
  let {
    onCancel,
    feedback,
    onFeedbackSubmit
  } = _ref;
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const {
    formatMessage
  } = useMessageFormatter(messages$3);
  const handleInputChange = event => {
    setFeedbackMessage(event.target.value);
  };
  const handleSubmit = () => {
    onFeedbackSubmit(feedbackMessage);
    setFeedbackMessage('');
  };
  const handleClose = () => {
    setFeedbackMessage('');
    onCancel();
  };
  const feedbackPrompt = feedback === Feedback$1.Positive ? formatMessage('positive-feedback-prompt') : formatMessage('negative-feedback-prompt');
  return {
    feedbackMessage,
    handleInputChange,
    handleSubmit,
    handleClose,
    feedbackPrompt: "".concat(feedbackPrompt, "?")
  };
};

function FeedbackModal(_ref) {
  let {
    isOpen,
    onFeedbackSubmit,
    onCancel,
    feedback,
    tag
  } = _ref;
  const {
    formatMessage
  } = useMessageFormatter(messages$3);
  const {
    feedbackMessage,
    handleInputChange,
    handleSubmit,
    handleClose,
    feedbackPrompt
  } = useFeedbackModal({
    onFeedbackSubmit,
    onCancel,
    feedback
  });
  const onFormSubmit = event => {
    event.preventDefault();
    handleSubmit();
  };
  const footer = /*#__PURE__*/jsxs("div", {
    className: styles$8['feedback-modal-footer'],
    children: [/*#__PURE__*/jsx(Button, {
      label: "Cancel",
      onClick: onCancel,
      "data-dsx-contrib--chat-interface--feedback-cancel": tag,
      children: formatMessage('cancel')
    }), /*#__PURE__*/jsx(Button, {
      variant: "primary",
      label: "Submit",
      onClick: handleSubmit,
      type: "submit",
      "data-dsx-contrib--chat-interface--feedback-submit": tag,
      children: formatMessage('submit')
    })]
  });
  return /*#__PURE__*/jsx(Modal, {
    label: "FeedbackModal",
    header: "Give Feedback",
    isOpen: isOpen,
    footer: footer,
    onClose: handleClose,
    mode: "blocking",
    children: /*#__PURE__*/jsxs("form", {
      className: styles$8['feedback-modal-body'],
      onSubmit: onFormSubmit,
      children: [/*#__PURE__*/jsx(Text, {
        variant: "label",
        children: feedbackPrompt
      }), /*#__PURE__*/jsx(TextInput, {
        value: feedbackMessage,
        onChange: handleInputChange,
        autoFocus: isOpen,
        "data-dsx-contrib--chat-interface--feedback-input": tag
      })]
    })
  });
}

function Feedback(_ref) {
  let {
    onFeedback,
    responseId,
    tag
  } = _ref;
  const {
    formatMessage
  } = useMessageFormatter(messages$3);
  const {
    handleFeedback,
    handleFeedbackCancel,
    handleFeedbackSubmit,
    modalOpen,
    feedback
  } = useFeedback({
    responseId,
    onFeedback
  });
  const positiveIcon = feedback === Feedback$1.Positive ? MdThumbUp : MdOutlineThumbUp;
  const negativeIcon = feedback === Feedback$1.Negative ? MdThumbDown : MdOutlineThumbDown;
  const positiveClassname = classNames(styles$8['feedback-icon-positive'], feedback === Feedback$1.Negative && styles$8['unselected'], feedback === Feedback$1.Positive && styles$8['selected']);
  const negativeClassname = classNames(styles$8['feedback-icon-negative'], feedback === Feedback$1.Positive && styles$8['unselected'], feedback === Feedback$1.Negative && styles$8['selected']);
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(Button, {
      className: positiveClassname,
      variant: "ui-control",
      label: "Positive Feedback",
      onClick: () => handleFeedback(Feedback$1.Positive),
      icon: positiveIcon,
      iconOnly: true,
      size: "small",
      "data-dsx-contrib--chat-interface--feedback-positive": tag,
      children: formatMessage('positive-feedback')
    }), /*#__PURE__*/jsx(Button, {
      className: negativeClassname,
      variant: "ui-control",
      label: "Negative Feedback",
      onClick: () => handleFeedback(Feedback$1.Negative),
      icon: negativeIcon,
      iconOnly: true,
      size: "small",
      "data-dsx-contrib--chat-interface--feedback-negative": tag,
      children: formatMessage('negative-feedback')
    }), /*#__PURE__*/jsx(FeedbackModal, {
      isOpen: modalOpen,
      onFeedbackSubmit: handleFeedbackSubmit,
      onCancel: handleFeedbackCancel,
      feedback: feedback,
      tag: tag
    })]
  });
}

const MAX_SERIES_COUNT = 5;
const useChartDatasets = _ref => {
  let {
    data,
    title,
    xAxis,
    yAxis,
    series
  } = _ref;
  const shouldUseSeries = !!series && series !== xAxis;
  const uniqueSeries = (shouldUseSeries ? [...new Set(data.map(row => row[series]).filter(Boolean))] : [title]).filter((_, index) => index < MAX_SERIES_COUNT);
  const datasets = uniqueSeries.map((column, seriesIndex) => {
    const values = data.filter(row => !shouldUseSeries || row[series] === column).map(row => {
      var _row$xAxis, _row$yAxis;
      return {
        x: formatLabelLength(((_row$xAxis = row[xAxis]) !== null && _row$xAxis !== void 0 ? _row$xAxis : 'N/A').toString()),
        y: (_row$yAxis = row[yAxis]) !== null && _row$yAxis !== void 0 ? _row$yAxis : 0
      };
    });
    return {
      label: column,
      data: values,
      color: palette(seriesIndex)
    };
  });
  return datasets;
};

function useChartDataValidation(_ref) {
  let {
    data,
    xAxis,
    yAxis,
    series
  } = _ref;
  const shouldUseSeries = !!series && series !== xAxis;
  return {
    isValid: data.every(row => (!shouldUseSeries || row[series] !== null) && row[yAxis] !== null && row[xAxis] !== null)
  };
}

const CHART_ITEM_WIDTH = 2;
const CHART_ITEM_MARGIN = 5;
const CHART_MIN_WIDTH = 40;
const REM_TO_PX = 16;
function useChartWidth(data, series) {
  return useMemo(() => {
    const seriesCount = new Set(data.map(item => item[series]));
    const items = data.length / seriesCount.size;
    const width = items * CHART_ITEM_WIDTH + CHART_ITEM_MARGIN;
    return Math.max(width, CHART_MIN_WIDTH) * REM_TO_PX;
  }, [data, series]);
}

function BarMessage(_ref) {
  let {
    message,
    data,
    title,
    xAxis,
    xLabel,
    yAxis,
    yLabel,
    stack,
    tag,
    formatting
  } = _ref;
  const {
    isValid
  } = useChartDataValidation({
    data,
    xAxis,
    yAxis,
    series: stack
  });
  const datasets = useChartDatasets({
    data,
    title,
    xAxis,
    yAxis,
    series: stack
  });
  const chartWidth = useChartWidth(data, stack);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      children: message
    }), isValid ? /*#__PURE__*/jsx(BarChart, {
      datasets: datasets,
      tag: tag,
      skewLabels: true,
      height: 480,
      width: chartWidth,
      ticks: 5,
      formatString: formatting === null || formatting === void 0 ? void 0 : formatting.formatString,
      formatterOverride: formatting === null || formatting === void 0 ? void 0 : formatting.formatterOverride,
      xLabel: xLabel,
      yLabel: yLabel
    }) : /*#__PURE__*/jsx(Note, {
      variant: "default",
      children: "Unable to show bar chart"
    })]
  });
}

var CurveType;
(function (CurveType) {
  CurveType["Linear"] = "linear";
  CurveType["MonotoneX"] = "monotone-x";
})(CurveType || (CurveType = {}));
var CurveType$1 = CurveType;

var GraphAlign;
(function (GraphAlign) {
  GraphAlign["LEFT"] = "left";
  GraphAlign["CENTER"] = "center";
})(GraphAlign || (GraphAlign = {}));
var GraphAlign$1 = GraphAlign;

var HighlightAmount;
(function (HighlightAmount) {
  HighlightAmount["Default"] = "none";
  HighlightAmount["Low"] = "low";
  HighlightAmount["High"] = "high";
})(HighlightAmount || (HighlightAmount = {}));
var HighlightAmount$1 = HighlightAmount;

var LineDataType;
(function (LineDataType) {
  LineDataType["Primary"] = "primary";
  LineDataType["Secondary"] = "secondary";
  LineDataType["Compare"] = "compare";
})(LineDataType || (LineDataType = {}));
var LineDataType$1 = LineDataType;

var StrokeType;
(function (StrokeType) {
  StrokeType["Default"] = "default";
  StrokeType["Dashed"] = "dashed";
  StrokeType["None"] = "none";
})(StrokeType || (StrokeType = {}));
var StrokeType$1 = StrokeType;

function useFormatters(_ref) {
  let {
    formatString,
    secondaryFormatString,
    formatterOverride,
    secondaryFormatterOverride
  } = _ref;
  const formatter = formatterOverride !== null && formatterOverride !== void 0 ? formatterOverride : format(formatString);
  const secondaryFormatter = secondaryFormatterOverride !== null && secondaryFormatterOverride !== void 0 ? secondaryFormatterOverride : secondaryFormatString ? format(secondaryFormatString) : undefined;
  return {
    formatter,
    secondaryFormatter
  };
}

const getMaxYValue = (obj, data) => {
  invariant(!!obj.getMaxY || data.maxY != null, 'Compare data must either have a maxY defined or the dataset must have getMaxY defined');
  return obj.getMaxY ? obj.getMaxY(data) : data.maxY;
};

const getMinYValue = (obj, data) => {
  invariant(!!obj.getMinY || data.maxY != null, 'Compare data must either have a minY defined or the dataset must have getMinY defined');
  return obj.getMinY ? obj.getMinY(data) : data.minY;
};

const getXValue = (obj, data) => {
  invariant(!!obj.getX || data.x != null, 'Data must either have an x defined or the dataset must have getX defined');
  return obj.getX ? obj.getX(data) : data.x;
};

const getYValue = (obj, data) => {
  invariant(!!obj.getY || data.y != null, 'Data must either have a y defined or the dataset must have getY defined');
  return obj.getY ? obj.getY(data) : data.y;
};

function useGraphDomains(_ref) {
  let {
    datasets,
    secondaryDataset,
    compareRegionDataset,
    multiBands,
    zeroMinimum: isZeroMinimum = false,
    secondaryZeroMinimum: isSecondaryZeroMinimum = false
  } = _ref;
  const xDomain = useMemo(() => {
    if (multiBands !== null && multiBands !== void 0 && multiBands.length) return multiBands;
    const xSet = datasets.reduce((set, dataset) => {
      dataset.data.forEach(data => {
        const xValue = getXValue(dataset, data);
        set.add(xValue);
      });
      return set;
    }, new Set());
    return [...xSet];
  }, [datasets, multiBands]);
  const yDomain = useMemo(() => {
    const yData = datasets.reduce((sets, dataset) => {
      sets.push(...dataset.data.map(data => getYValue(dataset, data)));
      return sets;
    }, []);
    compareRegionDataset === null || compareRegionDataset === void 0 ? void 0 : compareRegionDataset.data.forEach(datum => {
      yData.push(getMinYValue(compareRegionDataset, datum));
      yData.push(getMaxYValue(compareRegionDataset, datum));
    });
    isZeroMinimum && yData.push(0);
    return extent(yData);
  }, [compareRegionDataset, datasets, isZeroMinimum]);
  const secondaryYDomain = useMemo(() => {
    if (!secondaryDataset) {
      return undefined;
    }
    const yData = secondaryDataset.data.map(datum => getYValue(secondaryDataset, datum));
    if (isSecondaryZeroMinimum) {
      yData.push(0);
    }
    return extent(yData);
  }, [secondaryDataset, isSecondaryZeroMinimum]);
  return {
    xDomain,
    yDomain,
    secondaryYDomain
  };
}

const LABEL_TEXT_HEIGHT = 16;

const useTextWidth = fontFamily => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const getTextWidth = useCallback(function (text, fontSize) {
    let {
      ignoreSpaces = true,
      ignoreKerning = true
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!context) return 0;
    context.font = "".concat(fontSize !== null && fontSize !== void 0 ? fontSize : LABEL_TEXT_HEIGHT, "px ").concat(fontFamily);
    if (ignoreSpaces) {
      text = text.replace(/\s/g, '');
    }
    if (ignoreKerning) {
      return [...text].reduce((sum, currentChar) => {
        const metrics = context.measureText(currentChar);
        return sum + metrics.width;
      }, 0);
    } else {
      return context.measureText(text).width;
    }
  }, [context, fontFamily]);
  return {
    getTextWidth
  };
};

const LEGEND_MARGIN_BOTTOM = 16;
function useGraphOffsets(_ref) {
  var _xDomain$at, _max, _max2;
  let {
    secondaryEpsilon,
    tickLength,
    formatter,
    secondaryFormatter,
    axisEpsilon,
    yDomain,
    secondaryYDomain,
    ticks,
    xDomain,
    skewLabels,
    width,
    labelEpsilon,
    labelFontSize,
    legendHeight,
    fontFamily,
    xLabel,
    yLabel,
    secondaryYLabel
  } = _ref;
  const {
    getTextWidth
  } = useTextWidth(fontFamily);
  const largestWidth = Math.max(...xDomain.map(x => getTextWidth(x, labelFontSize)));
  const xWidth = xDomain.reduce((a, b) => a + 1.25 * getTextWidth(b, labelFontSize) / Math.SQRT2, 0);
  const bottomHeight = skewLabels ? 1.5 * largestWidth / Math.SQRT2 : labelFontSize;
  const bottomOffset = bottomHeight + tickLength + labelEpsilon + (xLabel ? labelFontSize : 0);
  const lastSkewedWidth = skewLabels ? 1.25 * getTextWidth((_xDomain$at = xDomain.at(-1)) !== null && _xDomain$at !== void 0 ? _xDomain$at : '', labelFontSize) / Math.SQRT2 : 0;

  // Need to find the largest formatted tick length
  const yTicks = scaleLinear().domain(yDomain).nice(ticks).ticks(ticks);
  const leftOffset = ((_max = max(yTicks.map(t => getTextWidth(formatter(t))))) !== null && _max !== void 0 ? _max : 0) + tickLength + axisEpsilon + (yLabel ? labelFontSize : 0);
  const secondaryYTicks = secondaryYDomain ? scaleLinear().domain(secondaryYDomain).nice(ticks).ticks(ticks) : [];
  let rightOffset = secondaryYDomain ? ((_max2 = max(secondaryYTicks.map(t => getTextWidth((secondaryFormatter !== null && secondaryFormatter !== void 0 ? secondaryFormatter : formatter)(t))))) !== null && _max2 !== void 0 ? _max2 : 0) + tickLength + secondaryEpsilon + (secondaryYLabel ? labelFontSize : 0) : 0;
  if (xWidth > width && lastSkewedWidth > rightOffset) {
    rightOffset = lastSkewedWidth;
  }
  const topOffset = legendHeight + LEGEND_MARGIN_BOTTOM;
  return {
    leftOffset,
    rightOffset,
    topOffset,
    bottomOffset
  };
}

function useGraphRanges(_ref) {
  let {
    height,
    width,
    leftOffset,
    rightOffset,
    topOffset,
    bottomOffset
  } = _ref;
  // Create ranges - the points the graph will be plotted in
  const xRange = [leftOffset, width - rightOffset];
  const yRange = [topOffset, height - bottomOffset];
  return {
    xRange,
    yRange
  };
}

function useGraphScales(_ref) {
  let {
    xDomain,
    yDomain,
    xRange,
    yRange,
    ticks,
    secondaryYDomain
  } = _ref;
  // Create scales that allow mapping between data and SVG coordinates
  const xScale = scaleBand().domain(xDomain).range(xRange);
  const yScale = scaleLinear().domain(yDomain).nice(ticks).range(yRange);
  const secondaryScale = secondaryYDomain ? scaleLinear().domain(secondaryYDomain).nice(ticks).range(yRange) : undefined;
  return {
    xScale,
    yScale,
    secondaryScale
  };
}

const LARGE_DATAPOINT_SIZE = 24;
const MEDIUM_DATAPOINT_SIZE = 17.3;
const SMALL_DATAPOINT_SIZE = 10.6;
const getIconSize = highlightAmount => {
  switch (highlightAmount) {
    case HighlightAmount$1.High:
      return LARGE_DATAPOINT_SIZE;
    case HighlightAmount$1.Low:
      return MEDIUM_DATAPOINT_SIZE;
    case HighlightAmount$1.Default:
      return SMALL_DATAPOINT_SIZE;
    default:
      return SMALL_DATAPOINT_SIZE;
  }
};

const isDefaultAreaDataType = data => data.maxY != null;
const isAreaDataSet = dataset => {
  const {
    data
  } = dataset;
  if (!data.length) return false;
  const [firstDatum] = data;
  return isDefaultAreaDataType(firstDatum) || dataset.getMaxY != null;
};

// Gap between the shape and the text
const ICON_TEXT_GAP = 6;
function LegendElement(_ref) {
  var _dataset$color;
  let {
    dataset,
    textHeight,
    iconSize: iconSize,
    size,
    defaultStrokeAndFillColor
  } = _ref;
  const color = (_dataset$color = dataset.color) !== null && _dataset$color !== void 0 ? _dataset$color : defaultStrokeAndFillColor;
  const shape = useMemo(() => {
    var _dataset$datapointSha;
    const Icon = isAreaDataSet(dataset) ? MdSquare : (_dataset$datapointSha = dataset.datapointShape) !== null && _dataset$datapointSha !== void 0 ? _dataset$datapointSha : MdCircle;
    const iconYPos = textHeight * 0.6;
    return /*#__PURE__*/jsx(Icon, {
      y: iconYPos - iconSize / 2,
      color: color,
      size: iconSize
    });
  }, [color, dataset, textHeight, iconSize]);
  const textX = iconSize + ICON_TEXT_GAP;
  const textWidth = size - textX;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [shape, /*#__PURE__*/jsx("text", {
      x: textX,
      y: textHeight,
      textLength: textWidth,
      lengthAdjust: "spacingAndGlyphs",
      children: dataset.label
    })]
  });
}

const LINE_SPACING = 1.4;
// Minimum amount of space between consecutive legend items
const MIN_PADDING = 16;
// Lays out a single line, like flexbox with space-around
// Returns an array of x-values
function layoutSingleLine(width, sizes) {
  const totalWidth = sizes.reduce((acc, size) => acc + size, 0);
  const totalPadding = width - totalWidth;
  const padding = totalPadding / (sizes.length + 1);
  let totalX = padding;
  const positions = [];
  for (const size of sizes) {
    const elementX = totalX;
    totalX += size + padding;
    positions.push({
      x: elementX,
      size
    });
  }
  return positions;
}

// Lays out multiple lines, wrapping when each line fills up
function layoutLines(textHeight, width, sizes) {
  sizes = sizes.map(size => Math.min(size, width - MIN_PADDING));
  function generateLine(lastIndex) {
    const firstIndex = items.length;
    const line = layoutSingleLine(width, sizes.slice(firstIndex, lastIndex));
    items.push(...line.map(layout => ({
      ...layout,
      y: currentLineYValue
    })));
  }
  const items = [];
  let currentLineYValue = 0;
  let currentLineWidth = 0;
  for (let i = 0; i < sizes.length; i++) {
    const datasetWidth = sizes[i] + MIN_PADDING;
    if (currentLineWidth + datasetWidth > width) {
      generateLine(i);
      currentLineWidth = 0;
      currentLineYValue += textHeight * LINE_SPACING;
    }
    currentLineWidth += datasetWidth;
  }
  if (items.length !== sizes.length) {
    generateLine(sizes.length);
  }
  return {
    layout: items,
    height: currentLineYValue + textHeight
  };
}
function useLegendLayout(datasets, textHeight, width, fontFamily) {
  const {
    getTextWidth
  } = useTextWidth(fontFamily);
  return useMemo(() => {
    const sizes = datasets.map(dataset => {
      var _dataset$highlightAmo;
      const iconSize = isAreaDataSet(dataset) ? getIconSize(HighlightAmount$1.Low) : getIconSize((_dataset$highlightAmo = dataset.highlightAmount) !== null && _dataset$highlightAmo !== void 0 ? _dataset$highlightAmo : HighlightAmount$1.Default);
      const textWidth = getTextWidth(dataset.label, textHeight, {
        ignoreSpaces: false,
        ignoreKerning: false
      });
      const size = iconSize + ICON_TEXT_GAP + textWidth;
      return {
        iconSize,
        size
      };
    });
    const {
      layout,
      height
    } = layoutLines(textHeight, width, sizes.map(_ref => {
      let {
        size
      } = _ref;
      return size;
    }));
    return {
      layout: layout.map((layout, index) => ({
        ...layout,
        iconSize: sizes[index].iconSize,
        dataset: datasets[index]
      })),
      height
    };
  }, [getTextWidth, datasets, textHeight, width]);
}

function generateDatasetKey(dataset) {
  if (!dataset.data.length) return dataset.label;
  return "".concat(dataset.label, "~~").concat(getXValue(dataset, dataset.data[0]));
}

const getMedianYValue = (obj, data) => obj.getMedianY ? obj.getMedianY(data) : data.medianY;

const chunkDisjointedDatasets = (dataset, xDomain) => {
  if (!dataset.allowDisjointed || !dataset.data.length) return [dataset];
  let domainIndex = xDomain.indexOf(getXValue(dataset, dataset.data[0]));
  let dataIndex = 0;
  const chunkedData = [];
  dataset.data.forEach(data => {
    if (getXValue(dataset, data) !== xDomain[domainIndex]) {
      domainIndex = xDomain.indexOf(getXValue(dataset, data));
      dataIndex++;
    }
    if (!chunkedData[dataIndex]) chunkedData[dataIndex] = [];
    chunkedData[dataIndex].push(data);
    domainIndex++;
  });
  return chunkedData.map(disjointedData => ({
    ...dataset,
    data: disjointedData
  }));
};
function useDisjointDatasets(_ref) {
  let {
    xDomain,
    primary,
    secondary
  } = _ref;
  const chunkedPrimaryDatasets = useMemo(() => primary.flatMap(dataset => chunkDisjointedDatasets(dataset, xDomain)), [primary, xDomain]);
  const chunkedSecondaryDatasets = useMemo(() => secondary && chunkDisjointedDatasets(secondary, xDomain), [secondary, xDomain]);
  return {
    primary: chunkedPrimaryDatasets,
    secondary: chunkedSecondaryDatasets
  };
}

var css_248z$7 = "[data-dsx--popover--anchor=\"line-graph-hover\"] {\n  display: inline !important;\n  display: initial !important;\n}\n.LineGraph-module_popoverContainer__-Dy3F > * {\n  padding: 0 !important;\n}\n.LineGraph-module_graph__j00-t {\n  pointer-events: none;\n}\n.LineGraph-module_graph__j00-t .LineGraph-module_axisLine__zxzZx {\n  stroke: var(--color-neutral-800);\n}\n.LineGraph-module_graph__j00-t .LineGraph-module_gridLine__mEfur {\n  stroke: var(--color-gray-700);\n  opacity: 0.2;\n  stroke-dasharray: 2;\n  animation: LineGraph-module_drawIn__6rii8 10s linear forwards;\n}\n.LineGraph-module_graph__j00-t path {\n  animation: LineGraph-module_drawIn__6rii8 10s linear forwards;\n}\n.LineGraph-module_graph__j00-t .LineGraph-module_legend__HILQz {\n  animation: LineGraph-module_fadeIn__tzcYk 300ms linear forwards;\n}\n.LineGraph-module_graph__j00-t circle {\n  animation: LineGraph-module_fadeIn__tzcYk 300ms linear forwards;\n}\n.LineGraph-module_chartContainer__8KTfO {\n  position: relative;\n  font-size: var(--size-400);\n}\n.LineGraph-module_hoverContentContainer__it6Al {\n  box-shadow: 0 2px 7px -2px rgba(0, 0, 0, 0.16);\n  z-index: 200;\n  position: absolute;\n  border-radius: var(--border-radius-default);\n  margin: 0 0 var(--size-400) var(--size-400);\n}\n.LineGraph-module_datapointHoverTarget__y-lfU {\n  height: 100%;\n  width: 100%;\n  pointer-events: auto;\n}\n.LineGraph-module_hoverPortal__5D54n {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.LineGraph-module_hoverFadeInStart__5KX7r {\n  opacity: 0;\n}\n.LineGraph-module_hoverFadeInActive__u-9KI {\n  opacity: 1;\n  transition: opacity 300ms linear;\n}\n.LineGraph-module_hoverFadeOutEnter__Aebyj {\n  opacity: 1;\n}\n.LineGraph-module_hoverFadeOutActive__ec5o1 {\n  opacity: 0;\n  transition: opacity 300ms linear;\n}\n@keyframes LineGraph-module_fadeIn__tzcYk {\n  from {\n    opacity: 0;\n  }\n}";
var styles$6 = {"motion-duration-response":"300ms","popoverContainer":"LineGraph-module_popoverContainer__-Dy3F","graph":"LineGraph-module_graph__j00-t","axisLine":"LineGraph-module_axisLine__zxzZx","gridLine":"LineGraph-module_gridLine__mEfur","drawIn":"LineGraph-module_drawIn__6rii8","legend":"LineGraph-module_legend__HILQz","fadeIn":"LineGraph-module_fadeIn__tzcYk","chartContainer":"LineGraph-module_chartContainer__8KTfO","hoverContentContainer":"LineGraph-module_hoverContentContainer__it6Al","datapointHoverTarget":"LineGraph-module_datapointHoverTarget__y-lfU","hoverPortal":"LineGraph-module_hoverPortal__5D54n","hoverFadeInStart":"LineGraph-module_hoverFadeInStart__5KX7r","hoverFadeInActive":"LineGraph-module_hoverFadeInActive__u-9KI","hoverFadeOutEnter":"LineGraph-module_hoverFadeOutEnter__Aebyj","hoverFadeOutActive":"LineGraph-module_hoverFadeOutActive__ec5o1"};
styleInject(css_248z$7);

function BottomAxis(_ref) {
  let {
    bottomOffset,
    scale,
    range,
    data,
    tickLength,
    height,
    graphAlign,
    emphasized = true,
    skewLabels,
    labelEpsilon,
    textHeight,
    emphasizedFillColor,
    baseFillColor,
    xLabel
  } = _ref;
  const y = height - bottomOffset;
  const adjustedY = y + tickLength + labelEpsilon;
  const tickOffset = graphAlign === GraphAlign$1.CENTER ? scale.bandwidth() / 2 : 0;
  const getCenterBand = d => {
    var _scale;
    return ((_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0) + tickOffset;
  };
  const fillColor = emphasized ? emphasizedFillColor : baseFillColor;
  const textProps = datum => skewLabels ? {
    transform: "translate(".concat(getCenterBand(datum), " ").concat(adjustedY, ") rotate(45)"),
    textAnchor: 'start',
    alignmentBaseline: 'central'
  } : {
    x: getCenterBand(datum),
    y: adjustedY + textHeight / 2,
    textAnchor: 'middle'
  };
  return /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("line", {
      x1: range[0],
      x2: range[1],
      y1: y,
      y2: y,
      className: styles$6.axisLine
    }), xLabel && /*#__PURE__*/jsx("text", {
      x: (range[0] - range[1]) / 2 + range[1],
      y: height,
      textAnchor: "middle",
      children: xLabel
    }), data.map(datum => /*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsx("line", {
        x1: getCenterBand(datum),
        x2: getCenterBand(datum),
        y1: y,
        y2: y + tickLength,
        className: styles$6.axisLine
      }), /*#__PURE__*/jsx("text", {
        fill: fillColor,
        ...textProps(datum),
        fontSize: textHeight,
        children: datum
      })]
    }, datum))]
  });
}

const curveFactoryLookup = {
  [CurveType$1.Linear]: curveLinear,
  [CurveType$1.MonotoneX]: curveMonotoneX
};
const getCurveFactory = curveType => curveFactoryLookup[curveType];

function CompareRegion(_ref) {
  var _area, _medianLine;
  let {
    data,
    xScale,
    yScale,
    yRange,
    getX,
    getMinY,
    getMaxY,
    getMedianY,
    areaColor,
    color,
    curve = CurveType$1.Linear,
    graphAlign,
    defaultFillAndStroke
  } = _ref;
  const centerBand = graphAlign === GraphAlign$1.CENTER ? xScale.bandwidth() / 2 : 0;
  const curveFactory = getCurveFactory(curve);
  const area$1 = area().curve(curveFactory).x(d => {
    var _xScale;
    return ((_xScale = xScale(getX(d))) !== null && _xScale !== void 0 ? _xScale : 0) + centerBand;
  }).y0(d => yRange[0] + yRange[1] - yScale(getMinY(d))).y1(d => yRange[0] + yRange[1] - yScale(getMaxY(d)));
  const medianLine = line().curve(curveFactory).x(d => {
    var _xScale2;
    return ((_xScale2 = xScale(getX(d))) !== null && _xScale2 !== void 0 ? _xScale2 : 0) + centerBand;
  }).y(d => yRange[0] + yRange[1] - yScale(getMedianY(d)));
  const fill = areaColor !== null && areaColor !== void 0 ? areaColor : defaultFillAndStroke;
  const stroke = color !== null && color !== void 0 ? color : defaultFillAndStroke;
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs("g", {
      children: [/*#__PURE__*/jsx("path", {
        d: (_area = area$1(data)) !== null && _area !== void 0 ? _area : undefined,
        fill: fill,
        opacity: 0.2
      }), /*#__PURE__*/jsx("path", {
        d: (_medianLine = medianLine(data)) !== null && _medianLine !== void 0 ? _medianLine : undefined,
        stroke: stroke,
        fill: "none",
        strokeWidth: 2,
        strokeDasharray: "1,5",
        strokeLinecap: "round"
      })]
    })
  });
}

function LeftAxis(_ref) {
  let {
    width,
    scale,
    leftOffset,
    range,
    tickLength,
    formatter,
    ticks,
    hideYAxis,
    axisEpsilon,
    yLabel
  } = _ref;
  const scaleTicks = scale.ticks(ticks);
  return /*#__PURE__*/jsxs("g", {
    children: [yLabel && /*#__PURE__*/jsx("text", {
      transform: "translate(0, ".concat((range[0] - range[1]) / 2 + range[1], ") rotate(-90)"),
      dominantBaseline: "hanging",
      textAnchor: "middle",
      children: yLabel
    }), !hideYAxis && /*#__PURE__*/jsx("line", {
      x1: leftOffset,
      x2: leftOffset,
      y1: range[0],
      y2: range[1],
      className: styles$6.axisLine
    }), scaleTicks.map(tick => {
      const y = range[0] + range[1] - scale(tick);
      return /*#__PURE__*/jsxs("g", {
        children: [!hideYAxis && /*#__PURE__*/jsx("line", {
          x1: leftOffset - tickLength * 1.25,
          x2: leftOffset,
          y1: y,
          y2: y,
          className: styles$6.axisLine
        }), /*#__PURE__*/jsx("line", {
          x1: leftOffset,
          x2: width,
          y1: y,
          y2: y,
          className: styles$6.gridLine
        }), /*#__PURE__*/jsx("text", {
          x: leftOffset - axisEpsilon - tickLength * 1.25,
          y: y,
          dominantBaseline: "middle",
          textAnchor: "end",
          children: formatter(tick)
        })]
      }, tick);
    })]
  });
}

function Legend(_ref) {
  let {
    layout,
    textHeight,
    defaultStrokeAndFill
  } = _ref;
  return /*#__PURE__*/jsx("g", {
    className: styles$6.legend,
    children: layout.map(layout => /*#__PURE__*/jsx("g", {
      transform: "translate(".concat(layout.x, ",").concat(layout.y, ")"),
      children: /*#__PURE__*/jsx(LegendElement, {
        dataset: layout.dataset,
        iconSize: layout.iconSize,
        size: layout.size,
        textHeight: textHeight,
        defaultStrokeAndFillColor: defaultStrokeAndFill
      })
    }, layout.dataset.label))
  });
}

const SMALL_STROKE_WIDTH = 1;
const MEDIUM_STROKE_WIDTH = 2.5;
const LARGE_STROKE_WIDTH = 3.5;
const getStrokeWidth = highlightAmount => {
  switch (highlightAmount) {
    case HighlightAmount$1.High:
      return LARGE_STROKE_WIDTH;
    case HighlightAmount$1.Low:
      return MEDIUM_STROKE_WIDTH;
    case HighlightAmount$1.Default:
      return SMALL_STROKE_WIDTH;
    default:
      return SMALL_STROKE_WIDTH;
  }
};

function useHoverContent(_ref) {
  let {
    primaryDatasets,
    secondaryDataset,
    compareRegionDataset,
    onHover
  } = _ref;
  const [focusedPoint, setFocusedPoint] = useState();
  const [hoverContent, setHoverContent] = useState();
  const [hasHoverContent, setHasHoverContent] = useState(true);
  const graphDataPointsLookup = useMemo(() => {
    const lookup = {
      primary: {},
      compare: {},
      secondary: {}
    };
    primaryDatasets.forEach(dataset => {
      dataset.data.forEach(datum => {
        const xValue = getXValue(dataset, datum);
        const yValue = getYValue(dataset, datum);
        if (!lookup.primary[xValue]) lookup.primary[xValue] = {
          labels: [],
          lookup: {}
        };
        lookup.primary[xValue].labels.push(dataset.label);
        lookup.primary[xValue].lookup[dataset.label] = {
          label: dataset.label,
          yValue: yValue,
          data: datum
        };
      });
    });
    secondaryDataset === null || secondaryDataset === void 0 ? void 0 : secondaryDataset.data.forEach(datum => {
      const xValue = getXValue(secondaryDataset, datum);
      const yValue = getYValue(secondaryDataset, datum);
      lookup.secondary[xValue] = {
        label: secondaryDataset.label,
        yValue,
        data: datum
      };
    });
    compareRegionDataset === null || compareRegionDataset === void 0 ? void 0 : compareRegionDataset.data.forEach(datum => {
      const xValue = getXValue(compareRegionDataset, datum);
      const minYValue = getMinYValue(compareRegionDataset, datum);
      const maxYValue = getMaxYValue(compareRegionDataset, datum);
      const medianYValue = getMedianYValue(compareRegionDataset, datum);
      lookup.compare[xValue] = {
        label: compareRegionDataset.label,
        minYValue,
        maxYValue,
        medianYValue,
        data: datum
      };
    });
    return lookup;
  }, [compareRegionDataset, primaryDatasets, secondaryDataset]);
  const getGraphDataPoints = useCallback(xValue => {
    var _graphDataPointsLooku, _graphDataPointsLooku2;
    const primaryLabels = graphDataPointsLookup.primary[xValue].labels;
    const primaryLookup = primaryLabels.reduce((lookup, label) => {
      const {
        yValue,
        data
      } = graphDataPointsLookup.primary[xValue].lookup[label];
      lookup[label] = {
        x: xValue,
        y: yValue,
        label,
        data
      };
      return lookup;
    }, {});
    const primary = {
      labels: primaryLabels,
      lookup: primaryLookup
    };
    const secondary = (_graphDataPointsLooku = graphDataPointsLookup.secondary) !== null && _graphDataPointsLooku !== void 0 && _graphDataPointsLooku[xValue] ? {
      x: xValue,
      y: graphDataPointsLookup.secondary[xValue].yValue,
      label: graphDataPointsLookup.secondary[xValue].label,
      data: graphDataPointsLookup.secondary[xValue].data
    } : undefined;
    const compare = (_graphDataPointsLooku2 = graphDataPointsLookup.compare) !== null && _graphDataPointsLooku2 !== void 0 && _graphDataPointsLooku2[xValue] ? {
      x: xValue,
      yMin: graphDataPointsLookup.compare[xValue].minYValue,
      yMax: graphDataPointsLookup.compare[xValue].maxYValue,
      yMedian: graphDataPointsLookup.compare[xValue].medianYValue,
      label: graphDataPointsLookup.compare[xValue].label,
      data: graphDataPointsLookup.compare[xValue].data
    } : undefined;
    return {
      primary,
      secondary,
      compare
    };
  }, [graphDataPointsLookup.compare, graphDataPointsLookup.primary, graphDataPointsLookup.secondary]);
  const onDatapointHover = useCallback(_ref2 => {
    let {
      x,
      label,
      type
    } = _ref2;
    if (!onHover || x === (focusedPoint === null || focusedPoint === void 0 ? void 0 : focusedPoint.x) && label === (focusedPoint === null || focusedPoint === void 0 ? void 0 : focusedPoint.label)) return;
    setFocusedPoint({
      x,
      label,
      type
    });
    const dataPoints = getGraphDataPoints(x);
    const content = onHover(type, label, dataPoints);
    setHoverContent(content);
    setHasHoverContent(content != null);
  }, [focusedPoint === null || focusedPoint === void 0 ? void 0 : focusedPoint.label, focusedPoint === null || focusedPoint === void 0 ? void 0 : focusedPoint.x, getGraphDataPoints, onHover]);
  const clearHoverContent = useCallback(() => {
    setFocusedPoint(undefined);
    setHoverContent(undefined);
    setHasHoverContent(true);
  }, []);
  return {
    onDatapointHover,
    clearHoverContent,
    hoverContent,
    disableHover: !onHover,
    hasHoverContent
  };
}

const initialHoverContentContext = {
  clearHoverContent: () => {},
  onDatapointHover: () => {},
  hasHoverContent: false,
  disableHover: true
};
const HoverContentContext = /*#__PURE__*/createContext(initialHoverContentContext);
function HoverContentContextProvider(props) {
  const hoverContentContext = useHoverContent(props);
  return /*#__PURE__*/jsx(HoverContentContext.Provider, {
    value: hoverContentContext,
    children: props.children
  });
}

const HOVER_OPACITY = 0.7;
const HOVER_TARGET_SIZE = 25;
function Datapoint(_ref) {
  var _xScale;
  let {
    datum,
    xScale,
    getX,
    yRange,
    yScale,
    getY,
    pointOffset,
    fill,
    lineLabel,
    lineType,
    datapointShape,
    highlightAmount = HighlightAmount$1.Default
  } = _ref;
  const xValue = getX(datum);
  const [opacity, setOpacity] = useState(1);
  const scaledSize = getIconSize(highlightAmount);
  const {
    onDatapointHover,
    clearHoverContent,
    hasHoverContent,
    disableHover,
    hoverContent
  } = useContext(HoverContentContext);
  const [showHover, setShowHover] = useState();
  const cx = ((_xScale = xScale(getX(datum))) !== null && _xScale !== void 0 ? _xScale : 0) + pointOffset;
  const cy = yRange[0] + yRange[1] - yScale(getY(datum));
  const hoverX = cx - HOVER_TARGET_SIZE / 2;
  const hoverY = cy - HOVER_TARGET_SIZE / 2;
  const Icon = datapointShape;
  const hoverEnable = useCallback(() => {
    setOpacity(HOVER_OPACITY);
    onDatapointHover({
      label: lineLabel,
      type: lineType,
      x: xValue
    });
    setShowHover(true);
  }, [lineLabel, lineType, onDatapointHover, xValue]);
  const hoverDisable = useCallback(() => {
    clearHoverContent();
    setOpacity(1);
    setShowHover(undefined);
  }, [clearHoverContent]);
  useEffect(() => {
    !hasHoverContent && setOpacity(1);
  }, [hasHoverContent]);
  return /*#__PURE__*/jsxs("g", {
    children: [!disableHover && /*#__PURE__*/jsx("foreignObject", {
      x: hoverX,
      y: hoverY,
      width: HOVER_TARGET_SIZE,
      height: HOVER_TARGET_SIZE,
      children: /*#__PURE__*/jsx(Popover, {
        className: styles$6.popoverContainer,
        contents: hoverContent,
        isOpen: showHover,
        placement: "right",
        tag: "line-graph-hover",
        showTip: true,
        children: /*#__PURE__*/jsx("div", {
          className: styles$6.datapointHoverTarget,
          onMouseOver: hoverEnable,
          onMouseOut: hoverDisable,
          onFocus: hoverEnable,
          onBlur: hoverDisable,
          tabIndex: 0
        })
      })
    }), /*#__PURE__*/jsx(Icon, {
      opacity: opacity,
      x: cx - scaledSize / 2,
      y: cy - scaledSize / 2,
      size: scaledSize,
      color: fill
    })]
  });
}

function Line(_ref) {
  var _line;
  let {
    yRange,
    xScale,
    yScale,
    getX,
    getY,
    data,
    name = 'line',
    color,
    curve = CurveType$1.Linear,
    stroke = StrokeType$1.Default,
    lineDataType,
    graphAlign,
    datapointShape = MdCircle,
    highlightAmount = HighlightAmount$1.Default,
    hideDatapoints = false,
    defaultStrokeAndFill
  } = _ref;
  const centerBand = graphAlign === GraphAlign$1.CENTER ? xScale.bandwidth() / 2 : 0;
  const curveFactory = getCurveFactory(curve);
  const line$1 = line().curve(curveFactory).x(d => {
    var _xScale;
    return ((_xScale = xScale(getX(d))) !== null && _xScale !== void 0 ? _xScale : 0) + centerBand;
  }).y(d => yRange[0] + yRange[1] - yScale(getY(d)));
  const strokeAndFill = color !== null && color !== void 0 ? color : defaultStrokeAndFill;
  const strokeWidth = getStrokeWidth(highlightAmount);
  const dashArray = stroke === StrokeType$1.Dashed ? '4,6' : undefined;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [stroke !== StrokeType$1.None && /*#__PURE__*/jsx("path", {
      d: (_line = line$1(data)) !== null && _line !== void 0 ? _line : undefined,
      stroke: strokeAndFill,
      fill: "none",
      strokeWidth: strokeWidth,
      strokeDasharray: dashArray
    }), !hideDatapoints && /*#__PURE__*/jsx("g", {
      children: data.map(datum => /*#__PURE__*/jsx(Datapoint, {
        pointOffset: centerBand,
        xScale: xScale,
        yScale: yScale,
        getX: getX,
        getY: getY,
        datum: datum,
        yRange: yRange,
        fill: strokeAndFill,
        lineLabel: name,
        lineType: lineDataType,
        datapointShape: datapointShape,
        highlightAmount: highlightAmount
      }, "".concat(name, "-").concat(getX(datum))))
    })]
  });
}

function PartitionedBottomAxis(_ref) {
  let {
    emphasisPartition,
    data,
    ...axisProps
  } = _ref;
  const paritionIndex = data.indexOf(emphasisPartition.partitionX);
  const leftData = data.slice(0, paritionIndex);
  const rightData = data.slice(paritionIndex + 1);
  return /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx(BottomAxis, {
      ...axisProps,
      data: emphasisPartition.emphasisDirection === 'left' ? rightData : leftData,
      emphasized: false
    }), /*#__PURE__*/jsx(BottomAxis, {
      ...axisProps,
      data: [data[paritionIndex]],
      emphasized: true
    }), /*#__PURE__*/jsx(BottomAxis, {
      ...axisProps,
      data: emphasisPartition.emphasisDirection === 'left' ? leftData : rightData,
      emphasized: true
    })]
  });
}

function PartitionedLine(_ref) {
  let {
    color,
    deEmphasisColor,
    emphasisPartition,
    data,
    xDomain,
    ...lineProps
  } = _ref;
  const partitionIndex = xDomain.findIndex(xLabel => xLabel === emphasisPartition.partitionX);
  const {
    getX
  } = lineProps;
  const {
    left: leftData,
    right: rightData
  } = useMemo(() => data.reduce((partitions, datum) => {
    const datumIndex = xDomain.findIndex(xLabel => xLabel === getX(datum));
    const partitionKey = datumIndex < partitionIndex ? 'left' : 'right';
    partitions[partitionKey].push(datum);
    if (datumIndex === partitionIndex) partitions.left.push(datum);
    return partitions;
  }, {
    left: [],
    right: []
  }), [partitionIndex, data, xDomain, getX]);
  return /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx(Line, {
      ...lineProps,
      color: deEmphasisColor,
      data: emphasisPartition.emphasisDirection === 'left' ? rightData : leftData,
      hideDatapoints: true
    }), /*#__PURE__*/jsx(Line, {
      ...lineProps,
      color: color,
      data: emphasisPartition.emphasisDirection === 'left' ? leftData : rightData
    })]
  });
}

function RightAxis(_ref) {
  let {
    width,
    scale,
    rightOffset,
    range,
    tickLength,
    formatter,
    ticks,
    hideYAxis,
    axisEpsilon,
    yLabel
  } = _ref;
  const scaleTicks = scale.ticks(ticks);
  const offset = width - rightOffset;
  return /*#__PURE__*/jsxs("g", {
    children: [yLabel && /*#__PURE__*/jsx("text", {
      transform: "translate(".concat(width, ", ").concat((range[0] - range[1]) / 2 + range[1], ") rotate(-90)"),
      textAnchor: "middle",
      children: yLabel
    }), !hideYAxis && /*#__PURE__*/jsx("line", {
      x1: offset,
      x2: offset,
      y1: range[0],
      y2: range[1],
      className: styles$6.axisLine
    }), scaleTicks.map(tick => {
      const y = range[0] + range[1] - scale(tick);
      return /*#__PURE__*/jsxs("g", {
        children: [!hideYAxis && /*#__PURE__*/jsx("line", {
          x1: offset,
          x2: offset + tickLength,
          y1: y,
          y2: y,
          className: styles$6.axisLine
        }), /*#__PURE__*/jsx("text", {
          x: offset + tickLength + axisEpsilon,
          y: y,
          dominantBaseline: "middle",
          children: formatter(tick)
        })]
      }, tick);
    })]
  });
}

function Chart(_ref) {
  let {
    height,
    width,
    textHeight,
    leftOffset,
    bottomOffset,
    rightOffset,
    xScale,
    yScale,
    secondaryYScale,
    xRange,
    yRange,
    xDomain,
    ticks,
    secondaryTicks,
    tickLength,
    formatter,
    secondaryFormatter,
    datasets,
    secondaryDataset,
    compareRegionDataset,
    graphAlign,
    hideYAxis,
    emphasisPartition,
    axisEpsilon,
    secondaryEpsilon,
    skewLabels,
    labelEpsilon,
    labelFontSize,
    legendLayout,
    bottomAxisEmphasisFill,
    bottomAxisBaseFill,
    compareRegionFill,
    legendDefaultStrokeAndFill,
    lineStrokeAndFill,
    yLabel,
    xLabel,
    secondaryYLabel
  } = _ref;
  const drawSortedPrimaryDatasets = useMemo(() => [...datasets].sort((a, b) => {
    if (a.drawOrder === b.drawOrder) return 0;
    if (b.drawOrder === undefined) return -1;
    if (a.drawOrder === undefined) return 1;
    return a.drawOrder - b.drawOrder;
  }), [datasets]);
  const {
    primary: primaryChunkedDatasets,
    secondary: secondaryChunkedDatasets
  } = useDisjointDatasets({
    xDomain,
    primary: drawSortedPrimaryDatasets,
    secondary: secondaryDataset
  });
  return /*#__PURE__*/jsx("div", {
    className: styles$6.chartContainer,
    style: {
      height,
      width
    },
    children: /*#__PURE__*/jsxs("svg", {
      height: height,
      width: width,
      className: styles$6.graph,
      children: [/*#__PURE__*/jsx(Legend, {
        layout: legendLayout,
        textHeight: textHeight,
        defaultStrokeAndFill: legendDefaultStrokeAndFill
      }), /*#__PURE__*/jsx(LeftAxis, {
        leftOffset: leftOffset,
        scale: yScale,
        range: yRange,
        width: xRange[1],
        tickLength: tickLength,
        formatter: formatter,
        ticks: ticks,
        hideYAxis: hideYAxis,
        axisEpsilon: axisEpsilon,
        yLabel: yLabel
      }), emphasisPartition ? /*#__PURE__*/jsx(PartitionedBottomAxis, {
        bottomOffset: bottomOffset,
        scale: xScale,
        range: xRange,
        data: xDomain,
        tickLength: tickLength,
        height: height,
        graphAlign: graphAlign,
        emphasisPartition: emphasisPartition,
        skewLabels: skewLabels,
        labelEpsilon: labelEpsilon,
        textHeight: labelFontSize,
        emphasizedFillColor: bottomAxisEmphasisFill,
        baseFillColor: bottomAxisBaseFill
      }) : /*#__PURE__*/jsx(BottomAxis, {
        bottomOffset: bottomOffset,
        scale: xScale,
        range: xRange,
        data: xDomain,
        tickLength: tickLength,
        height: height,
        graphAlign: graphAlign,
        skewLabels: skewLabels,
        labelEpsilon: labelEpsilon,
        textHeight: labelFontSize,
        emphasizedFillColor: bottomAxisEmphasisFill,
        baseFillColor: bottomAxisBaseFill,
        xLabel: xLabel
      }), secondaryChunkedDatasets && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(RightAxis, {
          width: width,
          rightOffset: rightOffset,
          scale: secondaryYScale !== null && secondaryYScale !== void 0 ? secondaryYScale : yScale,
          range: yRange,
          tickLength: tickLength,
          formatter: secondaryFormatter !== null && secondaryFormatter !== void 0 ? secondaryFormatter : formatter,
          ticks: secondaryTicks,
          hideYAxis: hideYAxis,
          axisEpsilon: secondaryEpsilon,
          yLabel: secondaryYLabel
        }), secondaryChunkedDatasets.map(secondaryDataset => /*#__PURE__*/jsx(Line, {
          xScale: xScale,
          yScale: secondaryYScale !== null && secondaryYScale !== void 0 ? secondaryYScale : yScale,
          data: secondaryDataset.data,
          lineDataType: LineDataType$1.Secondary,
          getX: datum => getXValue(secondaryDataset, datum),
          getY: datum => getYValue(secondaryDataset, datum),
          yRange: yRange,
          name: secondaryDataset.label,
          color: secondaryDataset.color,
          curve: secondaryDataset.curveType,
          graphAlign: graphAlign,
          datapointShape: secondaryDataset.datapointShape,
          stroke: secondaryDataset.strokeType,
          hideDatapoints: secondaryDataset.hideDatapoints
        }, generateDatasetKey(secondaryDataset)))]
      }), primaryChunkedDatasets.map(dataset => emphasisPartition ? /*#__PURE__*/jsx(PartitionedLine, {
        xScale: xScale,
        yScale: yScale,
        data: dataset.data,
        lineDataType: LineDataType$1.Primary,
        getX: datum => getXValue(dataset, datum),
        getY: datum => getYValue(dataset, datum),
        yRange: yRange,
        name: dataset.label,
        color: dataset.color,
        curve: dataset.curveType,
        graphAlign: graphAlign,
        datapointShape: dataset.datapointShape,
        highlightAmount: dataset.highlightAmount,
        emphasisPartition: emphasisPartition,
        deEmphasisColor: dataset.deEmphasisColor,
        xDomain: xDomain,
        stroke: dataset.strokeType,
        defaultStrokeAndFill: lineStrokeAndFill
      }, generateDatasetKey(dataset)) : /*#__PURE__*/jsx(Line, {
        xScale: xScale,
        yScale: yScale,
        data: dataset.data,
        lineDataType: LineDataType$1.Primary,
        getX: datum => getXValue(dataset, datum),
        getY: datum => getYValue(dataset, datum),
        yRange: yRange,
        name: dataset.label,
        color: dataset.color,
        curve: dataset.curveType,
        graphAlign: graphAlign,
        datapointShape: dataset.datapointShape,
        highlightAmount: dataset.highlightAmount,
        stroke: dataset.strokeType,
        hideDatapoints: dataset.hideDatapoints,
        defaultStrokeAndFill: lineStrokeAndFill
      }, generateDatasetKey(dataset))), compareRegionDataset && /*#__PURE__*/jsx(CompareRegion, {
        xScale: xScale,
        yScale: yScale,
        data: compareRegionDataset.data,
        getX: datum => getXValue(compareRegionDataset, datum),
        getMinY: datum => getMinYValue(compareRegionDataset, datum),
        getMaxY: datum => getMaxYValue(compareRegionDataset, datum),
        getMedianY: datum => getMedianYValue(compareRegionDataset, datum),
        yRange: yRange,
        color: compareRegionDataset.color,
        curve: compareRegionDataset.curveType,
        areaColor: compareRegionDataset.areaColor,
        graphAlign: graphAlign,
        defaultFillAndStroke: compareRegionFill
      })]
    })
  });
}

function LineGraph(_ref) {
  let {
    height = 320,
    width = 640,
    formatString = '.2s',
    formatterOverride,
    axisEpsilon = 0,
    secondaryEpsilon = 0,
    ticks = 10,
    secondaryTicks = 10,
    datasets,
    compareRegionDataset,
    multiBands,
    secondaryDataset,
    secondaryFormatString,
    secondaryFormatterOverride,
    zeroMinimum,
    secondaryZeroMinimum,
    graphAlign = GraphAlign$1.CENTER,
    onHover,
    hideYAxis = false,
    emphasisPartition,
    skewLabels = false,
    labelEpsilon = 8,
    labelFontSize = 16,
    tag,
    xLabel,
    yLabel,
    secondaryYLabel
  } = _ref;
  //Invariants
  invariant(new Set(datasets.map(_ref2 => {
    let {
      label
    } = _ref2;
    return label;
  })).size === datasets.length, 'Primary datasets must all have unique labels');

  // Constants
  const textHeight = 16;
  const tickLength = 5;
  const graphRef = useRef(null);
  const fontFamily = useThemeVariable$1('font-stack-primary', graphRef);
  const bottomAxisEmphasisFill = useThemeVariable$1('color-gray-800', graphRef);
  const bottomAxisBaseFill = useThemeVariable$1('color-gray-500', graphRef);
  const compareRegionFill = bottomAxisBaseFill;
  const legendDefaultStrokeAndFill = useThemeVariable$1('color-default', graphRef);
  const lineStrokeAndFill = useThemeVariable$1('color-gray-200', graphRef);
  const legendDatasets = useMemo(() => {
    const legendPrimaryDatasets = [...datasets].sort((a, b) => {
      if (a.legendOrder === b.legendOrder) {
        return 0;
      } else if (b.legendOrder === undefined) {
        return -1;
      } else if (a.legendOrder === undefined) {
        return 1;
      } else {
        return a.legendOrder - b.legendOrder;
      }
    });
    return [...legendPrimaryDatasets, secondaryDataset, compareRegionDataset].filter(Boolean);
  }, [compareRegionDataset, datasets, secondaryDataset]);
  const legendLayout = useLegendLayout(legendDatasets, textHeight, width, fontFamily);
  const {
    xDomain,
    yDomain,
    secondaryYDomain
  } = useGraphDomains({
    datasets,
    secondaryDataset,
    zeroMinimum,
    secondaryZeroMinimum,
    multiBands,
    compareRegionDataset
  });
  const {
    formatter,
    secondaryFormatter
  } = useFormatters({
    formatString,
    secondaryFormatString,
    formatterOverride,
    secondaryFormatterOverride
  });
  const {
    leftOffset,
    rightOffset,
    topOffset,
    bottomOffset
  } = useGraphOffsets({
    yDomain,
    secondaryYDomain,
    labelFontSize,
    tickLength,
    formatter,
    secondaryFormatter,
    axisEpsilon,
    secondaryEpsilon,
    ticks,
    xDomain,
    skewLabels,
    width,
    labelEpsilon,
    legendHeight: legendLayout.height,
    fontFamily,
    xLabel,
    yLabel,
    secondaryYLabel
  });
  const {
    xRange,
    yRange
  } = useGraphRanges({
    width,
    leftOffset,
    rightOffset,
    topOffset,
    bottomOffset,
    height
  });
  const {
    xScale,
    yScale,
    secondaryScale
  } = useGraphScales({
    xRange,
    yRange,
    xDomain,
    yDomain,
    ticks,
    secondaryYDomain
  });
  return /*#__PURE__*/jsx("div", {
    className: "c-line-graph",
    ref: graphRef,
    "data-dsx-contrib--line-graph": tag,
    children: /*#__PURE__*/jsx(HoverContentContextProvider, {
      primaryDatasets: datasets,
      compareRegionDataset: compareRegionDataset,
      secondaryDataset: secondaryDataset,
      onHover: onHover,
      children: /*#__PURE__*/jsx(Chart, {
        axisEpsilon: axisEpsilon,
        secondaryEpsilon: secondaryEpsilon,
        height: height,
        width: width,
        textHeight: textHeight,
        leftOffset: leftOffset,
        bottomOffset: bottomOffset,
        rightOffset: rightOffset,
        xScale: xScale,
        yScale: yScale,
        secondaryYScale: secondaryScale,
        yRange: yRange,
        xRange: xRange,
        xDomain: xDomain,
        ticks: ticks,
        secondaryTicks: secondaryTicks,
        tickLength: tickLength,
        formatter: formatter,
        secondaryFormatter: secondaryFormatter,
        datasets: datasets,
        secondaryDataset: secondaryDataset,
        compareRegionDataset: compareRegionDataset,
        graphAlign: graphAlign,
        hideYAxis: hideYAxis,
        emphasisPartition: emphasisPartition,
        skewLabels: skewLabels,
        labelEpsilon: labelEpsilon,
        labelFontSize: labelFontSize,
        legendLayout: legendLayout.layout,
        bottomAxisEmphasisFill: bottomAxisEmphasisFill,
        bottomAxisBaseFill: bottomAxisBaseFill,
        compareRegionFill: compareRegionFill,
        legendDefaultStrokeAndFill: legendDefaultStrokeAndFill,
        lineStrokeAndFill: lineStrokeAndFill,
        xLabel: xLabel,
        yLabel: yLabel,
        secondaryYLabel: secondaryYLabel
      })
    })
  });
}

function LineMessage(_ref) {
  let {
    message,
    data,
    title,
    xAxis,
    xLabel,
    yAxis,
    yLabel,
    series,
    tag,
    formatting,
    secondaryFormatting
  } = _ref;
  const {
    isValid
  } = useChartDataValidation({
    data,
    xAxis,
    yAxis,
    series
  });
  const datasets = useChartDatasets({
    data,
    title,
    xAxis,
    yAxis,
    series
  });
  const graphWidth = useChartWidth(data, series);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      children: message
    }), isValid ? /*#__PURE__*/jsx(LineGraph, {
      datasets: datasets,
      tag: tag,
      skewLabels: true,
      height: 480,
      width: graphWidth,
      ticks: 5,
      formatString: formatting === null || formatting === void 0 ? void 0 : formatting.formatString,
      formatterOverride: formatting === null || formatting === void 0 ? void 0 : formatting.formatterOverride,
      secondaryFormatString: secondaryFormatting === null || secondaryFormatting === void 0 ? void 0 : secondaryFormatting.formatString,
      secondaryFormatterOverride: secondaryFormatting === null || secondaryFormatting === void 0 ? void 0 : secondaryFormatting.formatterOverride,
      xLabel: xLabel,
      yLabel: yLabel
    }) : /*#__PURE__*/jsx(Note, {
      variant: "default",
      children: "Unable to show line graph"
    })]
  });
}

const isThemeColor = color => ThemeColorValues.includes(color);

const useSegmentColors = (data, ref) => {
  const dsxThemeColors = useMemo(() => data.map(_ref => {
    let {
      color
    } = _ref;
    return color;
  }).filter(isThemeColor), [data]);
  const themeColorLookup = useThemeVariable$1(dsxThemeColors, ref);
  const getSegmentColor = useCallback(colorOrThemeVariable => {
    if (!isThemeColor(colorOrThemeVariable)) return colorOrThemeVariable;
    return themeColorLookup[colorOrThemeVariable];
  }, [themeColorLookup]);
  return {
    getSegmentColor
  };
};

const mapPieChartData = (inputData, getColor) => {
  var _inputData$title;
  return {
    color: getColor(inputData.color),
    value: inputData.percentage,
    title: (_inputData$title = inputData.title) !== null && _inputData$title !== void 0 ? _inputData$title : inputData.label,
    label: inputData.label
  };
};

var css_248z$6 = ".PieChart-module_container__u2-pF {\n  height: 100%;\n  width: 100%;\n}";
var styles$5 = {"container":"PieChart-module_container__u2-pF"};
styleInject(css_248z$6);

function PieChart(_ref) {
  let {
    data,
    viewBoxSize = [180, 180],
    center = [90, 65],
    tag
  } = _ref;
  const pieRef = useRef(null);
  const {
    getSegmentColor
  } = useSegmentColors(data, pieRef);
  const pieChartMappedData = data.map(datum => mapPieChartData(datum, getSegmentColor));
  return /*#__PURE__*/jsx("div", {
    className: styles$5['container'],
    ref: pieRef,
    "data-dsx-contrib--pie-chart": tag,
    children: /*#__PURE__*/jsx(PieChart$1, {
      data: pieChartMappedData,
      label: _ref2 => {
        let {
          dataEntry: {
            label
          }
        } = _ref2;
        return label;
      },
      labelStyle: {
        fontSize: '0.3em'
      },
      labelPosition: 110,
      startAngle: 0,
      segmentsShift: 0.75,
      viewBoxSize: viewBoxSize,
      center: center
    })
  });
}

const MAX_PIE_SLICES = 10;

function usePieChartDataset(_ref) {
  let {
    data,
    labels: labelsMapping,
    values: valuesMapping
  } = _ref;
  const values = data.filter(row => typeof row[valuesMapping] === 'number').map(row => row[valuesMapping]);
  const total = values.reduce((acc, val) => acc + val, 0);
  const pieChartData = useMemo(() => {
    const chartData = [];
    let remainingPercentage = 1;
    const sortedData = values.slice().sort();
    sortedData.slice(0, MAX_PIE_SLICES - 1).forEach((val, index) => {
      var _data$index$labelsMap;
      const percentage = val / (total || 1);
      remainingPercentage -= percentage;
      chartData.push({
        title: Intl.NumberFormat(navigator.language, {
          style: 'percent'
        }).format(percentage),
        label: formatLabelLength(((_data$index$labelsMap = data[index][labelsMapping]) !== null && _data$index$labelsMap !== void 0 ? _data$index$labelsMap : 'N/A').toString()),
        percentage,
        color: palette(index)
      });
    });
    if (remainingPercentage > 0) {
      chartData.unshift({
        title: Intl.NumberFormat(navigator.language, {
          style: 'percent'
        }).format(remainingPercentage),
        label: 'Other',
        percentage: remainingPercentage,
        color: 'var(--color-gray-500)'
      });
    }
    return chartData;
  }, [data, values, labelsMapping, total]);
  return {
    data: pieChartData
  };
}

const THRESHOLD = 0.02;
function usePieChartDataValidation(_ref) {
  let {
    data,
    labels,
    values
  } = _ref;
  const dataIsCorrectType = data.every(datum => datum[labels] !== null && datum[values] !== null && typeof datum[values] === 'number');
  const sortedValues = data.map(datum => datum[values]).sort();
  const total = sortedValues.reduce((sum, value) => sum + value, 0) || 1;
  const topVals = sortedValues.slice(0, MAX_PIE_SLICES);
  const windowedPairs = topVals.map((_, i, arr) => arr.slice(i, i + 2)).filter(arr => arr.length === 2);
  const meetsThreshold = windowedPairs.every(_ref2 => {
    let [first, second] = _ref2;
    return first / total > THRESHOLD && second / total > THRESHOLD;
  });
  return {
    isValid: dataIsCorrectType && meetsThreshold
  };
}

function PieMessage(_ref) {
  let {
    message,
    data,
    labels,
    values,
    tag
  } = _ref;
  const {
    isValid
  } = usePieChartDataValidation({
    data,
    labels,
    values
  });
  const {
    data: pieChartData
  } = usePieChartDataset({
    data,
    labels,
    values
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      children: message
    }), isValid ? /*#__PURE__*/jsx(PieChart, {
      data: pieChartData,
      viewBoxSize: [230, 130],
      tag: tag,
      center: [95, 57]
    }) : /*#__PURE__*/jsx(Note, {
      variant: "default",
      children: "Unable to show pie graph"
    })]
  });
}

var css_248z$5 = ".DataTable-module_collapsible-element-container__jBMX7 {\n  overflow: hidden;\n  transition: height 250ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.DataTable-module_collapsible-element-container__jBMX7.DataTable-module_collapsed__wjhQ5 {\n  height: 0;\n}\n.DataTable-module_collapsible-element-container__jBMX7.DataTable-module_expanded__A7Q6x {\n  height: auto;\n  overflow: visible;\n}\n\n.DataTable-module_dl__V6FbQ {\n  display: grid;\n  grid-template-columns: -webkit-min-content auto;\n  grid-template-columns: min-content auto;\n}\n\n.DataTable-module_dt__ArgqD {\n  margin: 0;\n  padding: var(--size-300);\n  white-space: nowrap;\n  font-weight: bold;\n}\n\n.DataTable-module_dd__KeAbs {\n  margin: 0;\n  padding: var(--size-300);\n}\n\n.DataTable-module_dl__V6FbQ + .DataTable-module_dl__V6FbQ {\n  border-top: 2px solid var(--color-gray-100);\n}\n\n.DataTable-module_table-wrapper__RFLEq {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  isolation: isolate;\n}\n.DataTable-module_table-wrapper__RFLEq::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: var(--scrollable-left);\n  margin-left: -2px;\n  content: \"\";\n  z-index: 3;\n  pointer-events: none;\n  background: linear-gradient(to right, rgba(var(--color-gray-800-rgb), 0) 0%, rgba(var(--color-gray-800-rgb), 0) 0.375rem), linear-gradient(to left, rgba(var(--color-gray-800-rgb), 0) 0%, rgba(var(--color-gray-800-rgb), 0) 0.375rem);\n  background: linear-gradient(to right, rgba(var(--color-gray-800-rgb), var(--scrollable-left-opacity, 0)) 0%, rgba(var(--color-gray-800-rgb), 0) 0.375rem), linear-gradient(to left, rgba(var(--color-gray-800-rgb), var(--scrollable-right-opacity, 0)) 0%, rgba(var(--color-gray-800-rgb), 0) 0.375rem);\n}\n\n.DataTable-module_table-scroller__D6Uno {\n  overflow: auto;\n  position: relative;\n}\n.DataTable-module_table-scroller__D6Uno.DataTable-module_expandable__WwBex {\n  /* Else all expandable tables would have\n  scroll bars when they are collapsed.*/\n  overflow: visible;\n}\n\n.DataTable-module_table__CctLB {\n  width: 100%;\n  /* Required to make row borders for sticky columns visible */\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.DataTable-module_table__CctLB .DataTable-module_td__XtZoA {\n  background-color: var(--color-neutral-0);\n}\n.DataTable-module_table__CctLB.DataTable-module_nested__V21of .DataTable-module_td__XtZoA {\n  background-color: var(--color-gray-50);\n}\n\n.DataTable-module_row__MJAGD:not(:first-child) .DataTable-module_td__XtZoA {\n  border-top: 1px solid var(--color-gray-100);\n}\n.DataTable-module_sticky-top__4EViL .DataTable-module_row__MJAGD:last-child .DataTable-module_td__XtZoA {\n  border-bottom: 3px solid var(--color-gray-100);\n}\n.DataTable-module_row__MJAGD.DataTable-module_zebra__wsso8 .DataTable-module_td__XtZoA {\n  background-color: var(--color-gray-50);\n}\n.DataTable-module_row__MJAGD.DataTable-module_highlight__JClz- .DataTable-module_td__XtZoA {\n  background-color: var(--color-primary-50);\n}\n.DataTable-module_row__MJAGD.DataTable-module_expandable__WwBex:hover {\n  cursor: pointer;\n}\n.DataTable-module_row__MJAGD.DataTable-module_expandable__WwBex:hover .DataTable-module_td__XtZoA {\n  background-color: var(--color-primary-50);\n}\n.DataTable-module_row__MJAGD.DataTable-module_clickable__HpTl-:hover {\n  cursor: pointer;\n}\n.DataTable-module_row__MJAGD.DataTable-module_clickable__HpTl-:hover .DataTable-module_td__XtZoA {\n  background-color: var(--color-primary-50);\n}\n.DataTable-module_row__MJAGD.DataTable-module_expanded__A7Q6x .DataTable-module_td__XtZoA {\n  border-bottom: 3px solid var(--color-gray-100);\n}\n.DataTable-module_row__MJAGD.DataTable-module_nested__V21of:first-child {\n  box-shadow: inset 0 1px 0 var(--color-gray-100);\n}\n\n.DataTable-module_column-inner-wrapper__Cm00Z {\n  display: flex;\n  align-items: center;\n}\n.DataTable-module_column-inner-wrapper__Cm00Z .DataTable-module_cell-wrapper__Q9395 {\n  flex: 1 1 0%;\n}\n\n.DataTable-module_thead__3WrlY {\n  border: hidden;\n}\n\n.DataTable-module_frozen__wuCCB {\n  position: -webkit-sticky;\n  position: sticky;\n  left: 0;\n  left: var(--sticky-left, 0);\n  z-index: 1;\n}\n\n.DataTable-module_sticky-top__4EViL {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  top: var(--sticky-top, 0);\n  z-index: 2;\n}\n\n.DataTable-module_th__jO-4w {\n  padding: var(--size-300);\n  background-color: var(--color-gray-100);\n  background-clip: padding-box;\n}\n\n.DataTable-module_aggregate-header__6OQQF {\n  padding: var(--size-100);\n}\n.DataTable-module_aggregate-header__6OQQF:not(:last-child) {\n  border-right: 2px solid var(--color-gray-200);\n}\n\n.DataTable-module_aggregate-header-defined__Yn0aH {\n  border-bottom: 2px solid var(--color-gray-200);\n}\n\n.DataTable-module_last-aggregate-column__DASRD:not(:last-child) {\n  border-right: 2px solid var(--color-gray-200);\n}\n\n.DataTable-module_td__XtZoA {\n  padding: var(--size-300);\n}\n\n.DataTable-module_align-start__kUTco {\n  text-align: left;\n}\n\n.DataTable-module_align-center__akv-r {\n  text-align: center;\n}\n\n.DataTable-module_align-end__23myq {\n  text-align: right;\n}\n\n.DataTable-module_valign-start__8sMmR {\n  vertical-align: top;\n}\n\n.DataTable-module_valign-center__iLHYr {\n  vertical-align: middle;\n}\n\n.DataTable-module_valign-end__nF-0d {\n  vertical-align: bottom;\n}\n\n.DataTable-module_collapsed-content__kB-Dk {\n  visibility: visible;\n}\n.DataTable-module_collapsed-content__kB-Dk.DataTable-module_collapsed__wjhQ5 {\n  visibility: collapse;\n  transition: visibility 250ms;\n}\n\n.DataTable-module_collapsed-content-column__rsZ3g {\n  padding: 0;\n}\n\n.DataTable-module_collapse-icon-container__Gd8fb {\n  display: flex;\n  align-items: flex-start;\n  margin-right: var(--size-500);\n}\n.DataTable-module_collapse-icon-container__Gd8fb svg {\n  transform: rotate(-90deg);\n  transition: transform 250ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.DataTable-module_collapse-icon-container__Gd8fb.DataTable-module_expanded__A7Q6x svg {\n  transform: rotate(0);\n  transition: transform 250ms cubic-bezier(0.23, 1, 0.32, 1);\n}";
var styles$4 = {"transition-duration":"250ms","base-table-cell-left-padding":"var(--size-300)","expand-icon-box-width":"var(--size-700)","collapsible-element-container":"DataTable-module_collapsible-element-container__jBMX7","collapsed":"DataTable-module_collapsed__wjhQ5","expanded":"DataTable-module_expanded__A7Q6x","dl":"DataTable-module_dl__V6FbQ","dt":"DataTable-module_dt__ArgqD","dd":"DataTable-module_dd__KeAbs","table-wrapper":"DataTable-module_table-wrapper__RFLEq","table-scroller":"DataTable-module_table-scroller__D6Uno","expandable":"DataTable-module_expandable__WwBex","table":"DataTable-module_table__CctLB","td":"DataTable-module_td__XtZoA","nested":"DataTable-module_nested__V21of","row":"DataTable-module_row__MJAGD","sticky-top":"DataTable-module_sticky-top__4EViL","zebra":"DataTable-module_zebra__wsso8","highlight":"DataTable-module_highlight__JClz-","clickable":"DataTable-module_clickable__HpTl-","column-inner-wrapper":"DataTable-module_column-inner-wrapper__Cm00Z","cell-wrapper":"DataTable-module_cell-wrapper__Q9395","thead":"DataTable-module_thead__3WrlY","frozen":"DataTable-module_frozen__wuCCB","th":"DataTable-module_th__jO-4w","aggregate-header":"DataTable-module_aggregate-header__6OQQF","aggregate-header-defined":"DataTable-module_aggregate-header-defined__Yn0aH","last-aggregate-column":"DataTable-module_last-aggregate-column__DASRD","align-start":"DataTable-module_align-start__kUTco","align-center":"DataTable-module_align-center__akv-r","align-end":"DataTable-module_align-end__23myq","valign-start":"DataTable-module_valign-start__8sMmR","valign-center":"DataTable-module_valign-center__iLHYr","valign-end":"DataTable-module_valign-end__nF-0d","collapsed-content":"DataTable-module_collapsed-content__kB-Dk","collapsed-content-column":"DataTable-module_collapsed-content-column__rsZ3g","collapse-icon-container":"DataTable-module_collapse-icon-container__Gd8fb"};
styleInject(css_248z$5);

function Cell(props) {
  const {
    col,
    row,
    isLoading
  } = props;
  return /*#__PURE__*/jsx(Fragment, {
    children: isLoading ? col.renderLoading ? col.renderLoading(row) : /*#__PURE__*/jsx(SkeletonText, {}) : col.render ? col.render(row) : col.key in row ? row[col.key] : null
  });
}

var css_248z$4 = ".CollapsibleElement-module_collapsible-element-container__5I-Lg {\n  overflow: hidden;\n  transition: height 250ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.CollapsibleElement-module_collapsible-element-container__5I-Lg.CollapsibleElement-module_collapsed__qNe63 {\n  height: 0;\n}\n.CollapsibleElement-module_collapsible-element-container__5I-Lg.CollapsibleElement-module_expanded__Q7-k6 {\n  height: auto;\n  overflow: visible;\n}";
var styles$3 = {"transition-duration":"250ms","collapsible-element-container":"CollapsibleElement-module_collapsible-element-container__5I-Lg","collapsed":"CollapsibleElement-module_collapsed__qNe63","expanded":"CollapsibleElement-module_expanded__Q7-k6"};
styleInject(css_248z$4);

function CollapsibleElement(props) {
  const {
    collapsed,
    className,
    children
  } = props;
  const collapsibleContainerClassName = classNames(styles$3['collapsible-element-container'], collapsed ? styles$3['collapsed'] : styles$3['expanded'], className);
  const collapsibleContainerRef = useRef(null);
  const containerOpenHeightRef = useRef(0);
  const handleEnter = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.overflow = 'hidden';
    containerOpenHeightRef.current = container.clientHeight;
    container.style.height = '0';
    container.style.visibility = 'visible';
    container.clientHeight; // Force repaint at 0
  }, []);
  const handleEntering = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.height = "".concat(containerOpenHeightRef.current, "px");
  }, []);
  const handleEntered = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.height = '';
    container.style.overflow = '';
  }, []);
  const handleExit = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.height = 'auto';
    container.style.height = "".concat(container.clientHeight, "px");
    container.clientHeight; // Force repaint at the new absolute height value
  }, []);
  const handleExiting = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.height = '0';
  }, []);
  const handleExited = useCallback(() => {
    const container = collapsibleContainerRef.current;
    if (!container) return;
    container.style.height = '';
    container.style.visibility = 'hidden';
  }, []);
  return /*#__PURE__*/jsx(Transition, {
    nodeRef: collapsibleContainerRef,
    in: !collapsed,
    timeout: parseInt(styles$3['transition-duration'], 10),
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    children: /*#__PURE__*/jsx("div", {
      className: collapsibleContainerClassName,
      ref: collapsibleContainerRef,
      "aria-hidden": collapsed,
      children: children
    })
  });
}

function ExpandableContent(props) {
  const {
    children,
    isExpanded,
    tag,
    colspan
  } = props;
  const shouldLoadRef = useRef(isExpanded);
  const containerRef = useRef(null);

  // Aids in lazy rendering children.
  // Will only render children once they are expanded for the first time
  // Will not unmount them once they are expanded once
  shouldLoadRef.current || (shouldLoadRef.current = isExpanded);
  const collapsableRowClassName = classNames(styles$4['collapsed-content'], !isExpanded && styles$4['collapsed']);
  return /*#__PURE__*/jsx("tr", {
    "data-dsx-table-expandable-content": tag,
    className: collapsableRowClassName,
    ref: containerRef,
    children: /*#__PURE__*/jsx("td", {
      colSpan: colspan,
      className: styles$4['collapsed-content-column'],
      children: /*#__PURE__*/jsx(CollapsibleElement, {
        collapsed: !isExpanded,
        children: shouldLoadRef.current && children
      })
    })
  });
}

function Row(props) {
  var _highlightRow;
  const {
    isLoading,
    rowTag,
    columns,
    stickyLeftPositions,
    row,
    className,
    renderExpandableContent,
    nestedLevel,
    onRowClick,
    highlightRow
  } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const expandableContent = renderExpandableContent === null || renderExpandableContent === void 0 ? void 0 : renderExpandableContent(row);
  const hasExpandableContent = !!expandableContent;
  const shouldHighlightRow = (_highlightRow = highlightRow === null || highlightRow === void 0 ? void 0 : highlightRow(row)) !== null && _highlightRow !== void 0 ? _highlightRow : false;
  const handleRowClick = useCallback(() => {
    if (hasExpandableContent) {
      setIsExpanded(p => !p);
    }
    if (onRowClick) {
      onRowClick(row);
    }
  }, [hasExpandableContent, onRowClick, row]);
  const handleOnKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      setIsExpanded(p => !p);
    }
  };
  const rowClassName = classNames(styles$4['row'], hasExpandableContent && styles$4['expandable'], isExpanded && styles$4['expanded'], nestedLevel > 0 && styles$4['nested'], onRowClick && styles$4['clickable'], shouldHighlightRow && styles$4['highlight'], className);
  const tds = columns.map((col, index) => {
    const {
      key,
      textAlign = 'start',
      verticalAlign = 'center',
      width: colWidth
    } = col;
    const showExpandableIcon = index === 0 && hasExpandableContent && !isLoading;
    const applyPadding = index === 0 && nestedLevel > 0;
    const frozen = stickyLeftPositions[index] != null;
    const tdClassName = classNames(styles$4['td'], styles$4["align-".concat(textAlign)], styles$4["valign-".concat(verticalAlign)], frozen && styles$4['frozen']);
    const expandIconClassName = classNames(styles$4['collapse-icon-container'], isExpanded && styles$4['expanded']);
    const paddingLeft = applyPadding ? "calc(".concat(styles$4['base-table-cell-left-padding'], " + calc(").concat(styles$4['expand-icon-box-width'], " * ").concat(nestedLevel, "))") : undefined;
    const tdStyle = {
      paddingLeft,
      width: colWidth,
      ['--sticky-left']: frozen ? "".concat(stickyLeftPositions[index], "px") : undefined
    };
    return /*#__PURE__*/jsx("td", {
      "data-dsx-contrib--data-table--value": key,
      className: tdClassName,
      style: tdStyle,
      children: /*#__PURE__*/jsxs("div", {
        className: styles$4['column-inner-wrapper'],
        children: [showExpandableIcon && /*#__PURE__*/jsx("span", {
          className: expandIconClassName,
          "data-dsx-contrib--data-table--expand": key,
          children: /*#__PURE__*/jsx(StandaloneIcon, {
            icon: MdExpandMore,
            title: "Expand Row"
          })
        }), /*#__PURE__*/jsx("span", {
          className: styles$4['cell-wrapper'],
          children: /*#__PURE__*/jsx(Cell, {
            row: row,
            col: col,
            isLoading: isLoading
          })
        })]
      })
    }, key);
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("tr", {
      "data-dsx-contrib--data-table--row": rowTag,
      className: rowClassName,
      onClick: hasExpandableContent || onRowClick ? handleRowClick : undefined,
      onKeyDown: handleOnKeyDown,
      tabIndex: hasExpandableContent ? 0 : undefined,
      children: tds
    }), hasExpandableContent && /*#__PURE__*/jsx(ExpandableContent, {
      isExpanded: isExpanded,
      tag: rowTag,
      colspan: columns.length,
      children: expandableContent
    })]
  });
}

/**
 * A table component with more complex interactions than the vanilla @dsx-react/table component.
 */
function DataTable(props) {
  const {
    layout = 'table'
  } = props;
  return layout === 'table' ? /*#__PURE__*/jsx(TableFull, {
    ...props
  }) : /*#__PURE__*/jsx(TableDataList, {
    ...props
  });
}
function TableDataList(props) {
  const {
    rows,
    rowKey,
    columns,
    loadingState,
    skeletonRows = 3,
    tag
  } = props;
  const isLoading = loadingState === 'loading';
  const usePlaceholderRows = !rows.length && isLoading;
  const rowsOrPlaceholders = usePlaceholderRows ? [...Array(skeletonRows)] : rows;
  const rowEls = rowsOrPlaceholders.map((row, i) => {
    const keyForRow = usePlaceholderRows ? i : rowKey(row);
    const tagForRow = usePlaceholderRows ? null : keyForRow;
    const colEls = columns.map(col => {
      var _col$heading;
      return /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx("dt", {
          className: styles$4['dt'],
          "data-dsx-contrib--data-table--heading": col.key,
          children: (_col$heading = col.heading) !== null && _col$heading !== void 0 ? _col$heading : "".concat(col.key)
        }), /*#__PURE__*/jsx("dd", {
          className: styles$4['dd'],
          "data-dsx-contrib--data-table--value": col.key,
          children: /*#__PURE__*/jsx(Cell, {
            row: row,
            col: col,
            isLoading: isLoading
          })
        })]
      }, col.key);
    });
    return /*#__PURE__*/jsx("dl", {
      className: styles$4['dl'],
      "aria-live": "polite",
      "aria-atomic": "true",
      "data-dsx-contrib--data-table--row": tagForRow,
      children: colEls
    }, keyForRow);
  });
  return /*#__PURE__*/jsx("section", {
    "data-dsx-contrib--data-table": tag,
    children: rowEls
  });
}
function useTableDimensions(tableRef, groupedColumns) {
  const [theadHeight, setTHeadHeight] = useState(0);
  const [columnWidths, setColumnWidths] = useState(groupedColumns.flatMap(group => group.columns.map(() => 0)));
  const updateDimensions = useCallback(element => {
    const theadEl = element.querySelector('thead');
    const height = theadEl == null ? 0 : parseFloat(getComputedStyle(theadEl).height);
    setTHeadHeight(height);
    const columnEls = element.querySelectorAll('tbody:first-of-type tr:first-of-type td');
    const widths = Array.from(columnEls).map(el => parseFloat(getComputedStyle(el).width));
    setColumnWidths(widths);
  }, [setColumnWidths]);
  useEffect(() => {
    if (!tableRef.current) {
      return;
    }
    updateDimensions(tableRef.current);
  }, [tableRef, updateDimensions]);
  useResizeObserver({
    ref: tableRef,
    onResize: () => {
      if (!tableRef.current) {
        return;
      }
      updateDimensions(tableRef.current);
    }
  });
  const [stickyLeftPositions, stickyTotalWidth] = useMemo(() => {
    let offset = 0;
    const result = [];
    groupedColumns.forEach(group => {
      group.columns.forEach((column, index) => {
        if (group.freeze || column.freeze) {
          result[group.startIndex + index] = offset;
          offset += columnWidths[group.startIndex + index];
        }
      });
    });
    return [result, offset];
  }, [groupedColumns, columnWidths]);
  return {
    stickyTopPosition: theadHeight,
    columnWidths,
    stickyLeftPositions,
    stickyTotalWidth
  };
}
function useHorizontalScrollAffordance(scrollRef, columnWidths, stickyLeftPositions, stickyTotalWidth) {
  const [scrollAffordanceLeftWeight, setScrollAffordanceLeftWeight] = useState(0);
  const [scrollAffordanceRightWeight, setScrollAffordanceRightWeight] = useState(0);
  const updateScrollAffordance = useCallback(el => {
    // The point at which the left affordance starts to fade in is when every sticky column
    // has stuck -- i.e. once you have scrolled a distance equal to the sum of widths of every
    // non-sticky column prior to the final sticky column

    // `findLastIndex` is only included with Typescript 5+
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const index = stickyLeftPositions.findLastIndex(x => x != null);
    const leftBreakpoint = index == -1 ? 0 : columnWidths.slice(0, index).filter((_, i) => stickyLeftPositions[i] == null).reduce((a, b) => a + b, 0);
    const left = Math.max(0, el.scrollLeft - leftBreakpoint);
    const right = el.scrollWidth - (el.scrollLeft + el.clientWidth);

    // Gradually increase weight of each affordance as you scroll further past their breakpoints
    const scrollFadeLength = 8;
    const leftWeight = Math.min(1, left / scrollFadeLength);
    const rightWeight = Math.min(1, right / scrollFadeLength);
    setScrollAffordanceLeftWeight(leftWeight);
    setScrollAffordanceRightWeight(rightWeight);
  }, [stickyLeftPositions, columnWidths, setScrollAffordanceLeftWeight, setScrollAffordanceRightWeight]);
  useEffect(() => {
    if (scrollRef.current !== null) {
      updateScrollAffordance(scrollRef.current);
    }
  }, [scrollRef, updateScrollAffordance]);
  useResizeObserver({
    ref: scrollRef,
    onResize: () => {
      if (!scrollRef.current) {
        return;
      }
      updateScrollAffordance(scrollRef.current);
    }
  });
  const onScroll = useCallback(e => updateScrollAffordance(e.currentTarget), [updateScrollAffordance]);
  const wrapperStyles = useMemo(() => ({
    ['--scrollable-left']: "".concat(stickyTotalWidth, "px"),
    ['--scrollable-left-opacity']: 0.1 * scrollAffordanceLeftWeight,
    ['--scrollable-right-opacity']: 0.1 * scrollAffordanceRightWeight
  }), [stickyTotalWidth, scrollAffordanceLeftWeight, scrollAffordanceRightWeight]);
  return {
    onScroll,
    wrapperStyles
  };
}
function TableFull(props) {
  const {
    rows,
    rowKey,
    columns,
    tag,
    loadingState,
    freezeRows = 0,
    skeletonRows = 5,
    rowVariation = 'zebra',
    className,
    renderExpandableContent,
    tableNestedLevel = 0,
    onRowClick,
    rowClassName,
    highlightRow
  } = props;
  const isLoading = loadingState === 'loading';
  const showHeader = tableNestedLevel === 0;
  const hasAggregateHeader = columns.some(col => col.aggregateHeading);
  const groupedColumns = useMemo(() => {
    if (!hasAggregateHeader) {
      return [{
        columns,
        startIndex: 0,
        endIndex: columns.length,
        freeze: false
      }];
    }
    const groups = [];
    columns.forEach((column, index) => {
      const currentGroup = groups.at(-1);
      if (!currentGroup || !column.aggregateHeading || column.aggregateHeading !== currentGroup.heading) {
        groups.push({
          columns: [column],
          heading: column.aggregateHeading,
          startIndex: index,
          endIndex: index,
          freeze: !!column.freeze
        });
      } else {
        currentGroup.columns.push(column);
        currentGroup.endIndex = index;
        currentGroup.freeze || (currentGroup.freeze = !!column.freeze);
      }
    });
    return groups;
  }, [columns, hasAggregateHeader]);
  const tableRef = useRef(null);
  const {
    stickyTopPosition,
    columnWidths,
    stickyLeftPositions,
    stickyTotalWidth
  } = useTableDimensions(tableRef, groupedColumns);
  const scrollerRef = useRef(null);
  const {
    onScroll,
    wrapperStyles
  } = useHorizontalScrollAffordance(scrollerRef, columnWidths, stickyLeftPositions, stickyTotalWidth);
  const aggregateHeaders = hasAggregateHeader && showHeader && groupedColumns.map((group, index) => {
    const className = classNames(styles$4['th'], styles$4['aggregate-header'], group.heading != null && styles$4['aggregate-header-defined'], group.freeze && styles$4['frozen']);
    const style = {
      ['--sticky-left']: group.freeze ? "".concat(stickyLeftPositions[group.startIndex], "px") : undefined
    };
    return /*#__PURE__*/jsx("th", {
      className: className,
      style: style,
      colSpan: group.columns.length,
      "data-dsx-contrib--data-table--aggregate-heading": group.heading,
      children: group.heading
    }, index);
  });
  const headers = showHeader && columns.map((col, index) => {
    const {
      key,
      heading,
      textAlign = 'start',
      width: colWidth
    } = col;
    const group = groupedColumns.find(group => index >= group.startIndex && index <= group.endIndex);
    const isLastAggregateColumn = index === group.endIndex;
    const freeze = stickyLeftPositions[index] != null;
    const className = classNames(styles$4['th'], styles$4["align-".concat(textAlign)], isLastAggregateColumn && styles$4['last-aggregate-column'], freeze && styles$4['frozen']);
    const style = {
      width: colWidth,
      ['--sticky-left']: freeze ? "".concat(stickyLeftPositions[index], "px") : undefined
    };
    return /*#__PURE__*/jsx("th", {
      "data-dsx-contrib--data-table--heading": key,
      className: className,
      style: style,
      children: heading !== null && heading !== void 0 ? heading : key
    }, key);
  });
  const usePlaceholderRows = !rows.length && isLoading;
  const rowsOrPlaceholders = usePlaceholderRows ? [...Array(skeletonRows)] : rows;
  const tableRows = rowsOrPlaceholders.map((row, i) => {
    const keyForRow = usePlaceholderRows ? i : rowKey(row);
    const tagForRow = usePlaceholderRows ? null : "".concat(keyForRow);
    const rowClasses = classNames(i % 2 !== 0 && rowVariation === 'zebra' && styles$4['zebra'], rowClassName ? rowClassName(row) : '');
    return /*#__PURE__*/jsx(Row, {
      isLoading: isLoading,
      columns: columns,
      stickyLeftPositions: stickyLeftPositions,
      row: row,
      rowTag: tagForRow,
      className: rowClasses,
      renderExpandableContent: renderExpandableContent,
      nestedLevel: tableNestedLevel,
      onRowClick: onRowClick,
      highlightRow: highlightRow
    }, keyForRow);
  });
  const tableWrapperClassName = classNames(styles$4['table-wrapper'], className);
  const tableScrollerClassName = classNames(styles$4['table-scroller'], !!renderExpandableContent && styles$4['expandable']);
  const tableClassName = classNames(styles$4['table'], tableNestedLevel > 0 && styles$4['nested']);
  return /*#__PURE__*/jsx("div", {
    className: tableWrapperClassName,
    style: wrapperStyles,
    children: /*#__PURE__*/jsx("div", {
      className: tableScrollerClassName,
      ref: scrollerRef,
      onScroll: onScroll,
      children: /*#__PURE__*/jsxs("table", {
        className: tableClassName,
        "data-dsx-contrib--data-table": tag,
        ref: tableRef,
        children: [showHeader && /*#__PURE__*/jsxs("thead", {
          className: classNames(styles$4['sticky-top'], styles$4['thead']),
          "data-dsx-contrib--data-table--thead": tag,
          children: [hasAggregateHeader && /*#__PURE__*/jsx("tr", {
            children: aggregateHeaders
          }), /*#__PURE__*/jsx("tr", {
            children: headers
          })]
        }), freezeRows > 0 && /*#__PURE__*/jsx("tbody", {
          className: styles$4['sticky-top'],
          "data-dsx-contrib--data-table--tbody-frozen": tag,
          "aria-live": "polite",
          "aria-atomic": "true",
          style: {
            ['--sticky-top']: "".concat(stickyTopPosition, "px")
          },
          children: tableRows.slice(0, freezeRows)
        }), /*#__PURE__*/jsx("tbody", {
          "data-dsx-contrib--data-table--tbody": tag,
          "aria-live": "polite",
          "aria-atomic": "true",
          children: tableRows.slice(freezeRows)
        })]
      })
    })
  });
}

const PAGE_SIZE = 10;
function TableMessage(_ref) {
  let {
    message,
    columns,
    data,
    tag,
    formatting = {
      boolean: {
        trueText: 'True',
        falseText: 'False'
      }
    }
  } = _ref;
  const [page, setPage] = useState(0);
  const tableRows = useMemo(() => {
    return data.map((row, index) => ({
      ...row,
      table_index: index
    }));
  }, [data]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [message && /*#__PURE__*/jsx(Text, {
      children: message
    }), /*#__PURE__*/jsx(DataTable, {
      columns: columns.map(column => ({
        key: column.fieldName,
        heading: column.displayName,
        render: row => {
          var _formatting$boolean, _formatting$boolean2;
          const data = row[column.fieldName];
          if (data === null) {
            return /*#__PURE__*/jsx(Text, {
              children: "N/A"
            });
          }
          switch (column.type) {
            case MessageDataType.Number:
              return /*#__PURE__*/jsx(Text, {
                children: new Intl.NumberFormat(navigator.language).format(data)
              });
            case MessageDataType.Currency:
              return /*#__PURE__*/jsx(Text, {
                children: new Intl.NumberFormat(navigator.language, {
                  style: 'currency',
                  currency: 'USD'
                }).format(data)
              });
            case MessageDataType.Percentage:
              return /*#__PURE__*/jsx(Text, {
                children: new Intl.NumberFormat(navigator.language, {
                  style: 'percent'
                }).format(data)
              });
            case MessageDataType.Boolean:
              return /*#__PURE__*/jsx(Text, {
                children: data ? formatting === null || formatting === void 0 ? void 0 : (_formatting$boolean = formatting.boolean) === null || _formatting$boolean === void 0 ? void 0 : _formatting$boolean.trueText : formatting === null || formatting === void 0 ? void 0 : (_formatting$boolean2 = formatting.boolean) === null || _formatting$boolean2 === void 0 ? void 0 : _formatting$boolean2.falseText
              });
            default:
              return /*#__PURE__*/jsx(Text, {
                children: data
              });
          }
        }
      })),
      rowKey: row => row['table_index'],
      rows: tableRows.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE),
      tag: tag
    }), data.length > PAGE_SIZE && /*#__PURE__*/jsx(Pagination, {
      className: styles$8['table-pagination'],
      variant: "default",
      totalCount: data.length,
      pageSize: PAGE_SIZE,
      page: page,
      onPageChange: page => setPage(page)
    })]
  });
}

function MessageContent(props) {
  if (props.visualization != null && props.data && props.data.length > 0) {
    const formattedData = props.fields ? props.data.map(x => formatVisualizationData(x, props.fields)) : props.data;
    switch (props.visualization.plot_type) {
      case VisualizationType.Table:
        return /*#__PURE__*/jsx(TableMessage, {
          message: props.description,
          columns: props.fields,
          data: formattedData,
          tag: props.tag,
          formatting: props.visualization.formatting
        });
      case VisualizationType.Bar:
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(BarMessage, {
            message: props.description,
            data: formattedData,
            title: props.visualization.title,
            tag: props.tag,
            formatting: props.visualization.formatting,
            ...props.visualization.data_mapping
          }), props.visualization.includeTable && /*#__PURE__*/jsx(TableMessage, {
            columns: props.fields,
            data: formattedData,
            tag: props.tag
          })]
        });
      case VisualizationType.Line:
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(LineMessage, {
            message: props.description,
            data: formattedData,
            title: props.visualization.title,
            tag: props.tag,
            formatting: props.visualization.formatting,
            secondaryFormatting: props.visualization.secondaryFormatting,
            ...props.visualization.data_mapping
          }), props.visualization.includeTable && /*#__PURE__*/jsx(TableMessage, {
            columns: props.fields,
            data: formattedData,
            tag: props.tag
          })]
        });
      case VisualizationType.Pie:
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(PieMessage, {
            message: props.description,
            data: formattedData,
            tag: props.tag,
            ...props.visualization.data_mapping
          }), props.visualization.includeTable && /*#__PURE__*/jsx(TableMessage, {
            columns: props.fields,
            data: formattedData,
            tag: props.tag
          })]
        });
    }
  }
  return /*#__PURE__*/jsx(Text, {
    children: props.description
  });
}
const formatVisualizationData = (data, fields) => {
  const formattedData = {};
  fields.forEach(field => {
    switch (field.type) {
      case MessageDataType.Date:
        {
          const datum = data[field.fieldName];
          formattedData[field.fieldName] = datum !== null ? new Date(datum.toString()).toLocaleDateString() : 'N/A';
          break;
        }
      default:
        formattedData[field.fieldName] = data[field.fieldName];
        break;
    }
  });
  return formattedData;
};

function AskMessage(_ref) {
  let {
    messageId,
    message,
    onFeedback,
    askOrigin,
    responseId,
    disableFeedback,
    data,
    fields,
    tag,
    visualization
  } = _ref;
  const {
    loadingMessageHeight,
    loadingMessageWidth
  } = useContext(MeasurementContext);
  const {
    hasAnimationRan,
    updateAnimationState
  } = useContext(AnimationStateContext);
  const contentClassName = classNames(styles$8['message-text'], styles$8['ask-message']);
  const shouldRunAnimation = !!visualization && !hasAnimationRan(messageId);
  const handleOnEntered = useCallback(() => {
    updateAnimationState(messageId, true);
  }, [messageId, updateAnimationState]);
  return /*#__PURE__*/jsxs("div", {
    className: styles$8['ask-message-container'],
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$8['message-container'],
      children: [/*#__PURE__*/jsx(Text, {
        variant: "helper",
        children: askOrigin
      }), /*#__PURE__*/jsx(DimensionTransition, {
        className: contentClassName,
        "data-dsx-contrib--chat-interface--response": tag,
        transitionDuration: 600,
        variant: "both",
        collapsed: false,
        minHeight: loadingMessageHeight,
        minWidth: loadingMessageWidth,
        appear: shouldRunAnimation,
        onEntered: handleOnEntered,
        children: /*#__PURE__*/jsx(MessageContent, {
          description: message,
          data: data,
          fields: fields,
          visualization: visualization,
          tag: tag
        })
      })]
    }), !disableFeedback && /*#__PURE__*/jsx(Feedback, {
      onFeedback: onFeedback,
      responseId: responseId,
      tag: tag
    })]
  });
}

function UserMessage(_ref) {
  let {
    messageId,
    message,
    tag,
    onMessageEntered
  } = _ref;
  const {
    hasAnimationRan,
    updateAnimationState
  } = useContext(AnimationStateContext);
  const containerRef = useRef(null);
  const contentClassName = classNames(styles$8['message-text'], styles$8['user-message']);
  const handleMessageEntered = useCallback(() => {
    updateAnimationState(messageId, true);
    onMessageEntered === null || onMessageEntered === void 0 ? void 0 : onMessageEntered();
  }, [onMessageEntered, messageId, updateAnimationState]);
  return /*#__PURE__*/jsx(MessageTransition, {
    nodeRef: containerRef,
    onMessageEntered: handleMessageEntered,
    runAnimation: !hasAnimationRan(messageId),
    children: /*#__PURE__*/jsx("div", {
      className: styles$8['user-message-container'],
      ref: containerRef,
      children: /*#__PURE__*/jsxs("div", {
        className: styles$8['message-container'],
        children: [/*#__PURE__*/jsx(Text, {
          variant: "helper",
          children: "Me"
        }), /*#__PURE__*/jsx(Text, {
          className: contentClassName,
          "data-dsx-contrib--chat-interface--request": tag,
          children: message
        })]
      })
    })
  });
}

function Message(_ref) {
  let {
    message,
    messageIndex,
    askOrigin,
    tag,
    onFeedback,
    onMessageEntered
  } = _ref;
  switch (message.origin) {
    case MessageOrigin.Ask:
      return /*#__PURE__*/jsx(AskMessage, {
        messageId: message.responseId,
        message: message.description,
        askOrigin: askOrigin,
        responseId: message.responseId,
        disableFeedback: message.disableFeedback,
        onFeedback: onFeedback,
        data: message.data,
        fields: message.fields,
        visualization: message.visualization,
        tag: "".concat(tag, "--").concat(message.responseId)
      });
    case MessageOrigin.User:
      return /*#__PURE__*/jsx(UserMessage, {
        messageId: message.messageId,
        message: message.description,
        onMessageEntered: onMessageEntered,
        tag: "".concat(tag, "--").concat(messageIndex)
      });
    default:
      return null;
  }
}

const WindowedChat = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/jsx("div", {
    ...props,
    ref: ref,
    className: styles$8['scroll-container'],
    children: props.children
  });
});

const InnerWindowedContent$1 = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    messages,
    askOrigin,
    tag,
    onFeedback,
    onMessageEntered
  } = _ref;
  //The height of a line / bar message is ~600px depending on how long the description is
  //This helps Virtuoso scroll the container without jumping around
  const DEFAULT_MESSAGE_HEIGHT = 600;
  const renderMessage = useCallback((index, message) => {
    return /*#__PURE__*/jsx(Message, {
      message: message,
      messageIndex: index,
      askOrigin: askOrigin,
      tag: tag,
      onFeedback: onFeedback,
      onMessageEntered: onMessageEntered
    }, index);
  }, [askOrigin, onFeedback, onMessageEntered, tag]);
  return /*#__PURE__*/jsx(Virtuoso, {
    alignToBottom: true,
    data: messages,
    ref: ref,
    itemContent: renderMessage,
    defaultItemHeight: DEFAULT_MESSAGE_HEIGHT,
    components: {
      List: WindowedChat
    }
  });
});
const WindowedContent$1 = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/jsx(AnimationStateProvider, {
    children: /*#__PURE__*/jsx(InnerWindowedContent$1, {
      ...props,
      ref: ref
    })
  });
});

function Chat(_ref) {
  let {
    autoFocus,
    loadingAnswer,
    messages,
    suggestedQuestions,
    askOrigin,
    tag,
    onFeedback,
    onSubmitQuestion,
    legalDisclaimer
  } = _ref;
  const chatRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [messageEnteredStatus, setMessageEnteredStatus] = useState('none');
  const [messageCount, setMessageCount] = useState(0);
  const handleMessageEntered = () => {
    setMessageEnteredStatus('entered');
  };
  const handleSubmitQuestion = question => {
    setMessageEnteredStatus('entering');
    const userMessageId = crypto.randomUUID();
    onSubmitQuestion(question, userMessageId);
  };
  const showLoadingIndicator = !!loadingAnswer && messageEnteredStatus === 'none';
  const areSuggestedQuestionsLoading = messageEnteredStatus !== 'none' || !!loadingAnswer;
  useEffect(() => {
    if (!showLoadingIndicator && messageCount === messages.length) return;
    setMessageCount(messages.length);
    setTimeout(() => {
      var _scrollContainerRef$c;
      (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.scrollToIndex({
        index: messages.length,
        align: 'end'
      });
    }, 0);
  }, [showLoadingIndicator, messages, messageCount]);
  useEffect(() => {
    if (messageEnteredStatus !== 'entered') return;
    setTimeout(() => {
      setMessageEnteredStatus('none');
    }, 300);
  }, [messageEnteredStatus]);
  return /*#__PURE__*/jsx(MeasurementsContextProvider, {
    containerRef: chatRef,
    children: /*#__PURE__*/jsxs("div", {
      className: styles$8['chat-container'],
      ref: chatRef,
      children: [/*#__PURE__*/jsx(WindowedContent$1, {
        messages: messages,
        askOrigin: askOrigin,
        ref: scrollContainerRef,
        tag: tag,
        onFeedback: onFeedback,
        onMessageEntered: handleMessageEntered
      }), showLoadingIndicator && /*#__PURE__*/jsx(LoadingMessage, {
        askOrigin: askOrigin
      }), /*#__PURE__*/jsx(SuggestedQuestionList, {
        loading: areSuggestedQuestionsLoading,
        suggestedQuestions: suggestedQuestions,
        tag: tag,
        onSuggestedQuestionClick: handleSubmitQuestion
      }), /*#__PURE__*/jsx(InputField, {
        onSubmit: handleSubmitQuestion,
        autoFocus: autoFocus,
        disabled: loadingAnswer,
        tag: tag
      }), legalDisclaimer && /*#__PURE__*/jsx(Text, {
        className: styles$8['legal-disclaimer'],
        variant: "caption-small",
        children: legalDisclaimer
      })]
    })
  });
}

function ChatDialog(_ref) {
  let {
    isOpen,
    onClose,
    tag,
    clearContext,
    ...chatProps
  } = _ref;
  const {
    formatMessage
  } = useMessageFormatter(messages$3);
  return /*#__PURE__*/jsx(Dialog, {
    isOpen: isOpen,
    className: styles$8['dialog'],
    onClose: onClose,
    modal: true,
    children: /*#__PURE__*/jsxs("div", {
      className: styles$8['chat-outer-container'],
      children: [/*#__PURE__*/jsxs("div", {
        className: styles$8['upper-button-container'],
        children: [/*#__PURE__*/jsx("div", {
          className: styles$8['clear-button'],
          children: clearContext && /*#__PURE__*/jsx(Button, {
            type: "button",
            variant: "subtle",
            onClick: clearContext.onClearContext,
            "data-dsx-contrib--chat-interface--close": tag,
            children: "".concat(clearContext.clearContextText)
          })
        }), /*#__PURE__*/jsx("div", {
          className: styles$8['close-button'],
          children: /*#__PURE__*/jsx(Button, {
            type: "button",
            variant: "ui-control",
            iconOnly: true,
            icon: MdClose,
            size: "large",
            onClick: onClose,
            "data-dsx-contrib--chat-interface--close": tag,
            children: formatMessage('close-button')
          })
        })]
      }), /*#__PURE__*/jsx(Chat, {
        ...chatProps,
        autoFocus: isOpen,
        tag: tag
      })]
    })
  });
}

function Launch(_ref) {
  let {
    tag,
    onOpen
  } = _ref;
  return /*#__PURE__*/jsxs("button", {
    className: classNames('dsx-component', styles$8['launch-button']),
    onClick: onOpen,
    "data-dsx-contrib--chat-interface--launch": tag,
    children: [/*#__PURE__*/jsx("span", {
      className: styles$8['launch-text'],
      children: "What would you like to know?"
    }), /*#__PURE__*/jsx(StandaloneIcon, {
      color: "color-primary-500",
      icon: MdSend,
      title: "Start chat",
      size: "size-600"
    })]
  });
}

function ChatInterface(_ref) {
  let {
    askOrigin,
    messages,
    suggestedQuestions,
    loadingAnswer,
    onFeedback,
    onSubmitQuestion,
    tag,
    legalDisclaimer,
    clearContext
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Launch, {
      tag: tag,
      onOpen: handleOpen
    }), /*#__PURE__*/jsx(FeedbackOpenContextProvider, {
      children: /*#__PURE__*/jsx(ChatDialog, {
        askOrigin: askOrigin,
        isOpen: isOpen,
        messages: messages,
        suggestedQuestions: suggestedQuestions,
        loadingAnswer: loadingAnswer,
        tag: tag,
        onClose: handleClose,
        onFeedback: onFeedback,
        onSubmitQuestion: onSubmitQuestion,
        legalDisclaimer: legalDisclaimer,
        clearContext: clearContext
      })
    })]
  });
}

var css_248z$3 = ".KeyValuePairs-module_key-value-pairs__PA7-- {\n  -moz-column-width: 700px;\n       column-width: 700px;\n  width: 100%;\n  -moz-column-gap: var(--size-400);\n       column-gap: var(--size-400);\n  position: relative;\n  color: var(--color-gray-800);\n}\n.KeyValuePairs-module_key-value-pairs__PA7--::before {\n  background: var(--color-gray-50);\n  top: 0;\n  left: 0;\n  width: 100%;\n  position: absolute;\n  height: 1px;\n  content: \"\";\n}\n.KeyValuePairs-module_key-value-pairs__PA7-- dl {\n  -moz-column-break-inside: avoid;\n       break-inside: avoid-column;\n  padding: 0;\n  margin: 0;\n  display: table;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid var(--color-gray-100);\n}\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dt {\n  margin: 0;\n  padding: 0.75rem;\n  width: 50%;\n  display: table-cell;\n  color: foreground-color(var(--color-gray-0));\n  font-weight: bold;\n  background: var(--color-gray-0);\n}\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd {\n  display: table-cell;\n  padding: 0.75rem;\n  width: 50%;\n  overflow: hidden;\n  vertical-align: top;\n}\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd div,\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd a {\n  text-decoration: none;\n  display: block;\n}\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd div + div,\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd div + a,\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd a + div,\n.KeyValuePairs-module_key-value-pairs__PA7-- dl dd a + a {\n  margin-top: 0.25rem;\n}";
var styles$2 = {"key-value-pairs":"KeyValuePairs-module_key-value-pairs__PA7--"};
styleInject(css_248z$3);

function renderValueNode(value) {
  let key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  key = key ? key : 'key' + Math.random().toString();
  switch (value.constructor) {
    case String:
      return /*#__PURE__*/jsx("div", {
        children: value
      }, key);
    case Array:
      return value.map((valueNode, index) => renderValueNode(valueNode, index + ''));
    case Object:
      value = value;
      if (!value.url) {
        return renderValueNode(value.value);
      } else {
        return /*#__PURE__*/jsx("a", {
          href: value.url,
          children: value.value
        }, key);
      }
    default:
      return null;
  }
}
function KeyValuePairs(_ref) {
  let {
    keyValuePairs
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: styles$2['key-value-pairs'],
    children: keyValuePairs.map((keyValuePair, index) => {
      const {
        key,
        value
      } = keyValuePair;
      let vItemProp;
      let vItemType;
      switch (key.toLowerCase()) {
        case 'width':
          vItemProp = 'width';
          vItemType = 'http://schema.org/QuantitativeValue';
          break;
        case 'height':
          vItemProp = 'height';
          vItemType = 'http://schema.org/QuantitativeValue';
          break;
        case 'depth':
          vItemProp = 'depth';
          vItemType = 'http://schema.org/QuantitativeValue';
          break;
        case 'weight':
          vItemProp = 'weight';
          vItemType = 'http://schema.org/QuantitativeValue';
          break;
        case 'color':
          vItemProp = 'color';
          vItemType = 'http://schema.org/Text';
          break;
        default:
          vItemProp = 'additionalProperty';
          vItemType = 'http://schema.org/PropertyValue';
      }
      return /*#__PURE__*/jsxs("dl", {
        itemProp: vItemProp,
        itemScope: true,
        itemType: vItemType,
        children: [/*#__PURE__*/jsx("dt", {
          itemProp: "name",
          children: key
        }), /*#__PURE__*/jsx("dd", {
          itemProp: "value",
          children: renderValueNode(value)
        })]
      }, index);
    })
  });
}

var required$1 = "requir'd";
var optional$1 = "option'l";
var today$1 = "T'day";
var Search$1 = "Sail";
var Expand$1 = "Elaborate";
var Year$1 = "Year";
var Month$1 = "Month";
var Help$1 = "SOS";
var Success$1 = "Victory";
var Warning$1 = "A fell wind";
var Upload$1 = "Board";
var Remove$1 = "Scuttle";
var Cancel$1 = "Abandon";
var enPT = {
	required: required$1,
	optional: optional$1,
	today: today$1,
	"next-month": "Followin' month",
	"previous-month": "Precedin' month",
	"No results": "There be nothin' here fer ye",
	"No results for <q>{search}</q>": "There be nothin' here fer <q>{search}</q>",
	Search: Search$1,
	Expand: Expand$1,
	"Searching...": "Sailin' the seas...",
	"Searching for <q>{search}</q>": "Sailin' the seas fer <q>{search}</q>",
	"There was a problem completing your search": "Yer vessel has capsized along th' way",
	"Try again": "Sail again",
	"{count} selected": "{count} chos'n",
	Year: Year$1,
	Month: Month$1,
	"Start year": "Beginnin' year",
	"Start month": "Beginnin' month",
	"End year": "Endin' year",
	"End month": "Endin' month",
	"Select all": "Take 'em all",
	Help: Help$1,
	Success: Success$1,
	Warning: Warning$1,
	"Error": "Mayday",
	Upload: Upload$1,
	Remove: Remove$1,
	"Choose file": "Seek file",
	"Drag and drop files here to upload or <q>browse files</q>.": "Drag 'n' drop yer files here to upload or <q>seek files elsewhere</q>.",
	"No file chosen": "Pick a document, matey",
	"Accepted formats: {list}": "Accept'd cargo: {list}",
	Cancel: Cancel$1
};

var required = "required";
var optional = "optional";
var today = "Today";
var Search = "Search";
var Expand = "Expand";
var Year = "Year";
var Month = "Month";
var Help = "Help";
var Success = "Success";
var Warning = "Warning";
var Upload = "Upload";
var Remove = "Remove";
var Cancel = "Cancel";
var enUS = {
	required: required,
	optional: optional,
	today: today,
	"next-month": "Next month",
	"previous-month": "Previous month",
	"No results": "No results",
	"No results for <q>{search}</q>": "No results for <q>{search}</q>",
	Search: Search,
	Expand: Expand,
	"Searching...": "Searching...",
	"Searching for <q>{search}</q>": "Searching for <q>{search}</q>",
	"There was a problem completing your search": "There was a problem completing your search",
	"Try again": "Try again",
	"{count} selected": "{count} selected",
	Year: Year,
	Month: Month,
	"Start year": "Start year",
	"Start month": "Start month",
	"End year": "End year",
	"End month": "End month",
	"Select all": "Select all",
	Help: Help,
	Success: Success,
	Warning: Warning,
	"Error": "Error",
	Upload: Upload,
	Remove: Remove,
	"Choose file": "Choose file",
	"Drag and drop files here to upload or <q>browse files</q>.": "Drag and drop files here to upload or <q>browse files</q>.",
	"No file chosen": "No file chosen",
	"Accepted formats: {list}": "Accepted formats: {list}",
	Cancel: Cancel
};

const messages = {
  'en-US': enUS,
  'en-PT': enPT
};
var messages$1 = messages;

var css_248z$2 = ".ListInput-module_variable-container__RsTM2 {\n  --list-padding: var(--size-300);\n  --list-max-height: 20rem;\n}\n\n.ListInput-module_list-container__Z5H1A {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-200);\n}\n\n.ListInput-module_select__ef7iY {\n  cursor: pointer;\n  gap: var(--size-200);\n}\n\n.ListInput-module_content__cKeKP {\n  flex: 1 1 0%;\n  position: relative;\n}\n\n.ListInput-module_checkbox__33SdG {\n  pointer-events: none;\n}\n\n.ListInput-module_content-label__ZxnHP {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ListInput-module_placeholder__NVK0L {\n  color: var(--color-gray-300);\n}\n\n.ListInput-module_search-input__wLIN8 {\n  border: 0;\n  padding: var(--size-200) 0;\n  margin: calc(-1 * var(--size-200)) 0;\n  width: 100%;\n  outline: none;\n  background-color: transparent;\n}\n\n.ListInput-module_end__bWATY {\n  margin-left: auto;\n}\n\n.ListInput-module_list-menu__Ro9NZ {\n  background-color: var(--color-gray-0);\n  border-radius: var(--border-radius-default);\n  max-height: var(--list-max-height);\n  overflow-y: auto;\n  box-shadow: none;\n}\n.ListInput-module_list-menu__Ro9NZ.ListInput-module_non-windowed__nQLXy {\n  padding: var(--size-300) 0;\n}\n\n.ListInput-module_windowed-list-menu__xFiCD {\n  max-height: var(--list-max-height);\n}\n\n.ListInput-module_option__5bZZD,\n.ListInput-module_no-data__dtVdv,\n.ListInput-module_section-header__phjoX {\n  padding: var(--size-200) var(--size-400);\n  color: var(--color-gray-800);\n  font-weight: 500;\n  border: 2px solid transparent;\n  letter-spacing: var(--letter-spacing-16);\n}\n\n.ListInput-module_option__5bZZD.ListInput-module_disabled__JH8C7 {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.ListInput-module_option__5bZZD:not(.ListInput-module_disabled__JH8C7) {\n  cursor: pointer;\n}\n\n.ListInput-module_option__5bZZD:not(.ListInput-module_disabled__JH8C7):hover {\n  background-color: var(--color-gray-50);\n  color: var(--color-primary-500);\n}\n\n.ListInput-module_option__5bZZD:not(.ListInput-module_disabled__JH8C7):active {\n  background-color: var(--color-gray-100);\n  color: var(--color-primary-600);\n}\n\n.ListInput-module_option__5bZZD:not(.ListInput-module_disabled__JH8C7).ListInput-module_active__lT3YO {\n  border-color: rgba(var(--color-primary-400-rgb), 0.4);\n}\n\n.ListInput-module_option__5bZZD.ListInput-module_selected__Ja-cC {\n  background-color: var(--color-primary-50);\n  color: var(--color-primary-600);\n}\n\n.ListInput-module_option-wrapper__Xx5Ws {\n  display: flex;\n  align-items: center;\n  gap: var(--size-100);\n}\n\n.ListInput-module_multi-option-contents__-3Cmm {\n  display: flex;\n  align-items: center;\n  gap: var(--size-400);\n}\n\n.ListInput-module_single-option-contents__p07Jq {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1 1 0%;\n}\n\n.ListInput-module_section-header__phjoX {\n  display: flex;\n  align-items: center;\n  gap: var(--size-400);\n  color: var(--color-gray-500);\n}\n\n.ListInput-module_no-data__dtVdv {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--size-300);\n  color: var(--color-gray-300);\n}\n\n.ListInput-module_divider__7bCEk {\n  border-top: 1px solid var(--color-gray-100);\n  margin: var(--size-200) var(--size-400);\n}\n\n.ListInput-module_indent-0__ExTut {\n  padding-left: 0;\n}\n\n.ListInput-module_indent-select-all__snEYm {\n  padding-left: var(--size-400);\n}\n\n.ListInput-module_indent-1__E43-A {\n  padding-left: 2.5rem;\n}\n\n.ListInput-module_indent-2__sDDqL {\n  padding-left: 5rem;\n}\n\n.ListInput-module_indent-3__MbgeY {\n  padding-left: 7.5rem;\n}\n\n.ListInput-module_expand__c502e {\n  margin: calc(-1 * var(--size-200)) 0;\n}\n\n.ListInput-module_hidden__jNgwV {\n  visibility: hidden;\n}\n\n.ListInput-module_icon-stub__H7IAU {\n  width: var(--size-400);\n  height: var(--size-400);\n}\n\n.ListInput-module_list-top-padding__U9ZF0 {\n  padding-top: var(--list-padding);\n}\n\n.ListInput-module_list-bottom-padding__N44oi {\n  padding-bottom: var(--list-padding);\n}\n\n.ListInput-module_no-overscroll__TMRQA {\n  overscroll-behavior: contain;\n}";
var styles$1 = {"variable-container":"ListInput-module_variable-container__RsTM2","list-container":"ListInput-module_list-container__Z5H1A","select":"ListInput-module_select__ef7iY","content":"ListInput-module_content__cKeKP","checkbox":"ListInput-module_checkbox__33SdG","content-label":"ListInput-module_content-label__ZxnHP","placeholder":"ListInput-module_placeholder__NVK0L","search-input":"ListInput-module_search-input__wLIN8","end":"ListInput-module_end__bWATY","list-menu":"ListInput-module_list-menu__Ro9NZ","non-windowed":"ListInput-module_non-windowed__nQLXy","windowed-list-menu":"ListInput-module_windowed-list-menu__xFiCD","option":"ListInput-module_option__5bZZD","no-data":"ListInput-module_no-data__dtVdv","section-header":"ListInput-module_section-header__phjoX","disabled":"ListInput-module_disabled__JH8C7","active":"ListInput-module_active__lT3YO","selected":"ListInput-module_selected__Ja-cC","option-wrapper":"ListInput-module_option-wrapper__Xx5Ws","multi-option-contents":"ListInput-module_multi-option-contents__-3Cmm","single-option-contents":"ListInput-module_single-option-contents__p07Jq","divider":"ListInput-module_divider__7bCEk","indent-0":"ListInput-module_indent-0__ExTut","indent-select-all":"ListInput-module_indent-select-all__snEYm","indent-1":"ListInput-module_indent-1__E43-A","indent-2":"ListInput-module_indent-2__sDDqL","indent-3":"ListInput-module_indent-3__MbgeY","expand":"ListInput-module_expand__c502e","hidden":"ListInput-module_hidden__jNgwV","icon-stub":"ListInput-module_icon-stub__H7IAU","list-top-padding":"ListInput-module_list-top-padding__U9ZF0","list-bottom-padding":"ListInput-module_list-bottom-padding__N44oi","no-overscroll":"ListInput-module_no-overscroll__TMRQA"};
styleInject(css_248z$2);

const CSSVariableContext = /*#__PURE__*/createContext({
  variableContainer: null
});
function CSSVariableProvider(props) {
  const [element, setElement] = useState(null);
  return /*#__PURE__*/jsx(CSSVariableContext.Provider, {
    value: {
      variableContainer: element
    },
    children: /*#__PURE__*/jsx("div", {
      ref: setElement,
      className: styles$1['variable-container'],
      children: props.children
    })
  });
}

const TagContext = /*#__PURE__*/createContext({
  tagKey: ''
});
function TagProvider(props) {
  return /*#__PURE__*/jsx(TagContext.Provider, {
    value: props,
    children: props.children
  });
}

var css_248z$1 = ".Inputs-module_font__J00tF {\n  font-family: inherit;\n  font-size: 1rem;\n  letter-spacing: var(--letter-spacing-16);\n  line-height: 1.5;\n  color: var(--color-neutral);\n}\n\n.Inputs-module_tnum__Mq9pd {\n  font-feature-settings: \"kern\" 1, \"tnum\" 1;\n}\n\n.Inputs-module_start__AevMi {\n  text-align: left;\n}\n\n.Inputs-module_end__aal-- {\n  text-align: right;\n}\n\n.Inputs-module_padding__TJAsU {\n  padding: 0.625rem;\n}\n\n.Inputs-module_container__AHdny {\n  color: var(--color-neutral-800);\n  display: flex;\n  background-color: var(--color-neutral-0);\n  border-radius: var(--border-radius-default);\n  border: 1px solid var(--color-gray-400);\n  transition: 30ms ease border;\n  width: 100%;\n}\n\n.Inputs-module_container__AHdny::-moz-placeholder, .Inputs-module_container__AHdny ::-moz-placeholder {\n  font-family: inherit;\n  font-size: 1rem;\n  letter-spacing: var(--letter-spacing-16);\n  line-height: 1;\n  color: var(--color-neutral-500);\n}\n\n.Inputs-module_container__AHdny::placeholder,\n.Inputs-module_container__AHdny ::placeholder {\n  font-family: inherit;\n  font-size: 1rem;\n  letter-spacing: var(--letter-spacing-16);\n  line-height: 1;\n  color: var(--color-neutral-500);\n}\n\n:disabled .Inputs-module_container__AHdny,\n.Inputs-module_container__AHdny:disabled,\n.Inputs-module_container__AHdny.Inputs-module_disabled__xLCOT {\n  opacity: 0.4;\n  background-color: var(--color-gray-50);\n  pointer-events: none;\n}\n\n.Inputs-module_container__AHdny:hover:not(:disabled) {\n  border-color: var(--color-gray-500);\n}\n\n.Inputs-module_container__AHdny:focus,\n.Inputs-module_container__AHdny.Inputs-module_default__-5bLO:focus {\n  border-color: var(--color-blue-100);\n}\n\n.Inputs-module_container__AHdny[focus-within],\n.Inputs-module_container__AHdny.Inputs-module_focus-visible__U7r-R {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_container__AHdny:focus-within,\n.Inputs-module_container__AHdny.Inputs-module_focus-visible__U7r-R {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_container__AHdny[focus-within],\n.Inputs-module_container__AHdny.Inputs-module_focus-visible__U7r-R {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_container__AHdny[focus-within],\n.Inputs-module_container__AHdny:focus-visible {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_container__AHdny:focus-within,\n.Inputs-module_container__AHdny:focus-visible {\n  outline: 2px solid var(--color-primary-500);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs {\n  border-color: var(--color-danger-500);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs:hover {\n  border-color: var(--color-danger-600);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs:focus,\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs[focus-within] {\n  border-color: var(--color-danger-100);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs:focus,\n.Inputs-module_container__AHdny.Inputs-module_danger__rB8Cs:focus-within {\n  border-color: var(--color-danger-100);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_warn__qnugJ {\n  border-color: var(--color-warn-500);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_warn__qnugJ:hover {\n  border-color: var(--color-warn-600);\n}\n\n.Inputs-module_container__AHdny.Inputs-module_warn__qnugJ:focus {\n  border-color: var(--color-warn-100);\n}\n\n.Inputs-module_container__AHdny::-webkit-calendar-picker-indicator,\n.Inputs-module_container__AHdny ::-webkit-calendar-picker-indicator {\n  margin: 0;\n  padding: 0;\n}\n\n.Inputs-module_appearance-none__Y-wWG {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.Inputs-module_select__Fu1JJ {\n  border: 0;\n  background: none;\n}";
var inputStyles = {"font":"Inputs-module_font__J00tF","tnum":"Inputs-module_tnum__Mq9pd","start":"Inputs-module_start__AevMi","end":"Inputs-module_end__aal--","padding":"Inputs-module_padding__TJAsU","container":"Inputs-module_container__AHdny","disabled":"Inputs-module_disabled__xLCOT","default":"Inputs-module_default__-5bLO","focus-visible":"Inputs-module_focus-visible__U7r-R","danger":"Inputs-module_danger__rB8Cs","warn":"Inputs-module_warn__qnugJ","appearance-none":"Inputs-module_appearance-none__Y-wWG","select":"Inputs-module_select__Fu1JJ"};
styleInject(css_248z$1);

function NoData(props) {
  const {
    loadingState,
    onSearch,
    search
  } = props;
  const {
    formatMessage,
    formatReactMessage
  } = useMessageFormatter(messages$1);
  switch (loadingState) {
    case 'loading':
      return /*#__PURE__*/jsx("div", {
        className: styles$1['no-data'],
        children: /*#__PURE__*/jsx(Text, {
          children: search ? formatReactMessage('Searching for <q>{search}</q>', {
            search,
            q: chunk => /*#__PURE__*/jsx("q", {
              children: chunk
            })
          }) : formatMessage('Searching...')
        })
      });
    case 'failure':
      return /*#__PURE__*/jsxs("div", {
        className: styles$1['no-data'],
        children: [/*#__PURE__*/jsx(Text, {
          children: formatMessage('There was a problem completing your search')
        }), /*#__PURE__*/jsx(Button, {
          size: "small",
          onClick: () => onSearch === null || onSearch === void 0 ? void 0 : onSearch(search),
          children: formatMessage('Try again')
        })]
      });
    default:
      if (search) {
        return /*#__PURE__*/jsx("div", {
          className: styles$1['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            })
          })
        });
      } else {
        return /*#__PURE__*/jsx("div", {
          className: styles$1['no-data'],
          children: /*#__PURE__*/jsx(Text, {
            children: search ? formatReactMessage('No results for <q>{search}</q>', {
              search,
              q: chunk => /*#__PURE__*/jsx("q", {
                children: chunk
              })
            }) : formatMessage('No results')
          })
        });
      }
  }
}

function List(props) {
  const {
    activeId,
    children,
    className: callerClassName,
    disabled,
    id,
    isWindowed,
    listId,
    loadingState,
    name,
    placeholder,
    preventOverscroll,
    search,
    selectedLabel,
    value,
    variant = 'default',
    onBlur,
    onFocus,
    onSearch,
    onSearchInput,
    onSearchKeyDown
  } = props;
  const {
    tagKey,
    tag
  } = useContext(TagContext);
  const searchRef = useRef(null);
  const containerClassName = classNames('dsx-component', styles$1['list-container'], callerClassName);
  const searchInputClassName = classNames(styles$1['select'], inputStyles['container'], inputStyles['font'], inputStyles['padding'], inputStyles[variant], disabled && inputStyles['disabled']);
  const listClassname = classNames('dsx-component', styles$1['list-menu'], !isWindowed && styles$1['non-windowed'], !isWindowed && preventOverscroll && styles$1['no-overscroll']);
  function handleListClick() {
    var _searchRef$current;
    (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 ? void 0 : _searchRef$current.focus();
  }
  const contentLabel = selectedLabel !== null && selectedLabel !== void 0 ? selectedLabel : placeholder;
  const contentLabelClassName = classNames(styles$1['content-label'], (open || selectedLabel == null) && styles$1['placeholder']);

  // Windowed list tag needs to be applied to a different element
  const listTag = {
    ["".concat(tagKey, "--list")]: !isWindowed ? tag : undefined
  };
  return /*#__PURE__*/jsxs("div", {
    className: containerClassName,
    children: [/*#__PURE__*/jsxs("div", {
      className: searchInputClassName,
      onClick: handleListClick,
      [tagKey]: tag,
      children: [/*#__PURE__*/jsx("input", {
        id: id,
        name: name,
        type: "hidden",
        value: value
      }), /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdSearch,
        size: "size-500"
      }), /*#__PURE__*/jsxs("div", {
        className: styles$1['content'],
        children: [!search && /*#__PURE__*/jsx("div", {
          className: contentLabelClassName,
          children: contentLabel
        }), /*#__PURE__*/jsx("input", {
          "aria-activedescendant": activeId,
          "aria-autocomplete": "list",
          "aria-controls": listId,
          autoCorrect: "off",
          className: classNames(styles$1['search-input'], inputStyles['font']),
          type: "text",
          ref: searchRef,
          role: "combobox",
          value: search,
          onBlur: onBlur,
          onFocus: onFocus,
          onInput: onSearchInput,
          onKeyDown: onSearchKeyDown,
          ["".concat(tagKey, "--search")]: tag
        })]
      }), loadingState === 'loading' && /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: DsxLoadingSpinner,
        size: "size-500",
        className: styles$1['end']
      })]
    }), /*#__PURE__*/jsx("div", {
      id: listId,
      className: listClassname,
      role: "listbox",
      ...listTag,
      children: children || /*#__PURE__*/jsx(NoData, {
        loadingState: loadingState,
        search: search,
        onSearch: onSearch
      })
    })]
  });
}

function MultiItem(props) {
  const {
    activeValue,
    option,
    id,
    value,
    onSelect
  } = props;
  const {
    tag,
    tagKey
  } = useContext(TagContext);
  const itemTag = {
    ["".concat(tagKey, "--option")]: tag && "".concat(tag, "--").concat(option.value)
  };
  const active = option.value === activeValue;
  const selected = value === null || value === void 0 ? void 0 : value.includes(option.value);
  const className = classNames(styles$1['option'], styles$1['multi-option-contents'], option.disabled && styles$1['disabled'], active && styles$1['active'], selected && styles$1['selected']);
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [active]);
  function handleClick() {
    if (!option.disabled) {
      onSelect(option.value);
    }
  }
  let checkboxIcon = MdCheckBoxOutlineBlank;
  if (option.indeterminate) checkboxIcon = MdIndeterminateCheckBox;else if (selected) checkboxIcon = MdCheckBox;
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    ...itemTag,
    onClick: handleClick,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      className: styles$1['checkbox'],
      icon: checkboxIcon,
      size: "size-400"
    }), option.label]
  }, option.value);
}

/* The number of options to move the selection by when pressing page up/down. */
const pageSize = 7;
/**
 * Translates keyboard events into semantic selection actions.
 */
function getActionFromKeyboardEvent(event) {
  const {
    key,
    altKey
  } = event;
  switch (key) {
    case 'Enter':
      return 'select';
    case 'ArrowUp':
      return altKey ? 'select' : 'previous';
    case 'ArrowDown':
      return altKey ? 'select' : 'next';
    case 'PageUp':
      return 'pageup';
    case 'PageDown':
      return 'pagedown';
    default:
      return null;
  }
}

/**
 * Given a set of options, an active value, and a keyboard navigation action,
 * determine the value of the next selected option.
 *
 * When no value is active, the operation is performed relative to the index
 * preceding all options.
 *
 * Optionally this may take in a set of extra values which are considered to be
 * special option values that precede the normal select options.
 */
function navigateOptions(params) {
  const {
    action,
    options,
    extraValues,
    activeValue
  } = params;
  switch (action) {
    case 'previous':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -1,
        wrap: true
      });
    case 'next':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: 1,
        wrap: true
      });
    case 'pageup':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: -pageSize,
        wrap: false
      });
    case 'pagedown':
      return navigateOptionsByAmount({
        options,
        extraValues,
        activeValue,
        dIndex: pageSize,
        wrap: false
      });
  }
}
function navigateOptionsByAmount(params) {
  const {
    options,
    extraValues = [],
    activeValue,
    dIndex,
    wrap
  } = params;
  const focusableOptions = options.filter(option => !option.disabled);
  const minIndex = -extraValues.length;
  const maxIndex = focusableOptions.length - 1;
  let index = extraValues.indexOf(activeValue);
  if (index !== -1) {
    index = minIndex + index;
  } else {
    index = focusableOptions.findIndex(option => option.value === activeValue);
    if (index === -1) {
      index = minIndex - 1;
    }
  }
  index += dIndex;
  if (index < minIndex) {
    if (wrap) {
      index = maxIndex;
    } else {
      index = minIndex;
    }
  } else if (index > maxIndex) {
    if (wrap) {
      index = minIndex;
    } else {
      index = maxIndex;
    }
  }
  return index < 0 ? extraValues[index - minIndex] : focusableOptions[index].value;
}

const selectAllValue = Symbol('dsx-list-select-all');
/* The default implementation for the `searchFn` prop. */
function defaultSearchFn(options, search) {
  return options.filter(option => option.label.toUpperCase().includes(search.trim().toUpperCase()));
}
function defaultMultiSummary(selectedOptions, formatMessage) {
  if (selectedOptions.length === 1) {
    return selectedOptions[0].label;
  }
  if (selectedOptions.length > 1) {
    return formatMessage('{count} selected', {
      count: selectedOptions.length
    });
  }
}
function useList(props) {
  const {
    options,
    extraValues,
    searchFn = defaultSearchFn,
    searchMode = 'local',
    filterOptions = () => true,
    onSearch,
    onOptionSelect,
    onExtraValueSelect
  } = props;
  const uid = useUniqueId();
  const [search, setSearch] = useState('');

  /* The value of the active option (the option focused via keyboard) */
  const [activeValue, setActiveValue] = useState(null);
  const filteredOptions = useMemo(() => searchMode === 'local' ? searchFn(options, search) : options, [searchMode, options, search, searchFn]).filter(filterOptions);
  const groupedOptions = useMemo(() => filteredOptions.reduce((groups, option) => {
    const {
      header
    } = option;
    if (!groups.length) {
      return [{
        header,
        options: [option]
      }];
    }
    const {
      header: previousHeader,
      options: previousOptions
    } = groups.at(-1);
    if (header === previousHeader) {
      previousOptions.push(option);
    } else {
      groups.push({
        header,
        options: [option]
      });
    }
    return groups;
  }, []), [filteredOptions]);
  const activeOption = filteredOptions.find(option => option.value === activeValue);
  function handleSearchInput(event) {
    const value = event.currentTarget.value;
    setSearch(value);
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
  }
  function handleSearchKeyDown(event) {
    const action = getActionFromKeyboardEvent(event);
    switch (action) {
      case 'select':
        if (activeValue != null) {
          if (typeof activeValue === 'string') onOptionSelect(activeValue);else onExtraValueSelect === null || onExtraValueSelect === void 0 ? void 0 : onExtraValueSelect(activeValue);
        }
        event.preventDefault();
        break;
      case 'previous':
      case 'next':
      case 'pageup':
      case 'pagedown':
        if (filteredOptions.length > 0) {
          setActiveValue(navigateOptions({
            action,
            options: filteredOptions,
            extraValues,
            activeValue
          }));
        }
        event.preventDefault();
        break;
    }
  }
  return {
    uid,
    open,
    search,
    activeValue,
    setActiveValue,
    filteredOptions,
    groupedOptions,
    activeOption,
    onSearchInput: handleSearchInput,
    onSearchKeyDown: handleSearchKeyDown
  };
}
function isListOption(option) {
  return 'value' in option;
}
function isSelectAllOption(option) {
  return 'selectAllFn' in option;
}
function isHeaderOption(option) {
  return !isListOption(option) && 'header' in option;
}

function MultiSelectAllItem(props) {
  const {
    activeValue,
    id,
    selected,
    label,
    onSelect
  } = props;
  const {
    tagKey,
    tag
  } = useContext(TagContext);
  const selectAllTag = {
    ["".concat(tagKey, "--option--select-all")]: tag
  };
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const active = activeValue === selectAllValue;
  const className = classNames(styles$1['option'], styles$1['multi-option-contents'], active && styles$1['active'], selected && styles$1['selected']);
  const checkIcon = selected ? MdCheckBox : MdCheckBoxOutlineBlank;
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [active]);
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    ...selectAllTag,
    onClick: onSelect,
    children: [/*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: checkIcon,
      size: "size-400",
      className: styles$1['checkbox']
    }), label !== null && label !== void 0 ? label : formatMessage('Select all')]
  });
}

function SectionHeader(props) {
  const {
    header
  } = props;
  const {
    tag,
    tagKey
  } = useContext(TagContext);
  const sectionHeaderTag = {
    ["".concat(tagKey, "--list--section-header")]: tag && "".concat(tag, "--").concat(header)
  };
  return /*#__PURE__*/jsx("div", {
    className: styles$1['section-header'],
    ...sectionHeaderTag,
    children: header
  });
}

function Content(props) {
  const {
    groupedOptions,
    hasAllSelected,
    activeValue,
    id,
    value,
    onOptionSelect,
    selectAll
  } = props;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!!selectAll && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(MultiSelectAllItem, {
        activeValue: activeValue,
        label: selectAll.label,
        selected: hasAllSelected,
        id: "".concat(id, "-option--select-all"),
        onSelect: selectAll.onSelectAll
      }), /*#__PURE__*/jsx("div", {
        className: styles$1['divider']
      })]
    }), groupedOptions.map((_ref, index) => {
      let {
        header,
        options
      } = _ref;
      return /*#__PURE__*/jsxs(Fragment$1, {
        children: [!!header && /*#__PURE__*/jsx(SectionHeader, {
          header: header
        }), options.map(option => /*#__PURE__*/jsx(MultiItem, {
          activeValue: activeValue,
          option: option,
          id: "".concat(id, "-option-").concat(option.value),
          value: value,
          onSelect: onOptionSelect
        }, option.value))]
      }, "".concat(header, "~").concat(index));
    })]
  });
}

const ListHeightContext = /*#__PURE__*/createContext({
  listHeight: 0,
  setListHeight: () => {}
});
function ListHeightProvider(props) {
  const [listHeight, setListHeight] = useState(0);
  return /*#__PURE__*/jsx(ListHeightContext.Provider, {
    value: {
      listHeight,
      setListHeight
    },
    children: props.children
  });
}

function useThemeVariable(variableName) {
  const {
    variableContainer
  } = useContext(CSSVariableContext);
  const variableContainerRef = useMemo(() => ({
    current: variableContainer
  }), [variableContainer]);
  return useThemeVariable$1(variableName, variableContainerRef);
}

function useWindowedListStyle() {
  const {
    listHeight
  } = useContext(ListHeightContext);
  const listPadding = useThemeVariable('list-padding');
  const listMaxHeight = useThemeVariable('list-max-height');
  const contentStyle = useMemo(() => {
    const updatedListHeight = listHeight ? "calc(".concat(listHeight, "px + (2 * ").concat(listPadding, "))") : "".concat(listMaxHeight);
    return {
      height: updatedListHeight
    };
  }, [listHeight, listMaxHeight, listPadding]);
  return {
    contentStyle
  };
}

function BottomPadding() {
  return /*#__PURE__*/jsx("div", {
    className: styles$1['list-bottom-padding']
  });
}

function TopPadding() {
  return /*#__PURE__*/jsx("div", {
    className: styles$1['list-top-padding']
  });
}

const WindowedList = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    setListHeight
  } = useContext(ListHeightContext);
  const {
    tag,
    tagKey
  } = useContext(TagContext);
  const listTag = {
    ["".concat(tagKey, "--list")]: tag
  };
  const [listRef, setListRef] = useState(null);
  const getListRef = useCallback(containerRef => {
    setListRef(containerRef);
    if (typeof ref === 'function') {
      ref(containerRef);
    } else if (ref) {
      ref.current = containerRef;
    }
  }, [ref]);
  useEffect(() => {
    if (listRef) {
      setListHeight(listRef.offsetHeight);
    }
  });
  return /*#__PURE__*/jsx("div", {
    ...props,
    ref: getListRef,
    ...listTag,
    children: props.children
  });
});

function renderOption(option, props) {
  const {
    activeValue,
    hasAllSelected,
    id,
    value,
    onOptionSelect
  } = props;
  if (isSelectAllOption(option)) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(MultiSelectAllItem, {
        activeValue: activeValue,
        selected: hasAllSelected,
        id: "".concat(id, "-option--select-all"),
        onSelect: option.selectAllFn,
        label: option.label
      }), /*#__PURE__*/jsx("div", {
        className: styles$1['divider']
      })]
    });
  } else if (isHeaderOption(option)) {
    return /*#__PURE__*/jsx(SectionHeader, {
      header: option.header
    });
  } else if (isListOption(option)) {
    return /*#__PURE__*/jsx(MultiItem, {
      activeValue: activeValue,
      option: option,
      id: "".concat(id, "-option-").concat(option.value),
      value: value,
      onSelect: onOptionSelect
    }, option.value);
  }
}

// A single line option has a height of 44px. Providing this to Virtuoso will
// optimize the rendering of the list and remove some of the scrolling jank.
const DEFAULT_OPTION_HEIGHT = 44;
function InnerWindowedContent(props) {
  const {
    groupedOptions,
    selectAll,
    preventOverscroll
  } = props;
  const virtuosoRef = useRef(null);
  const {
    onSelectAll,
    label
  } = selectAll !== null && selectAll !== void 0 ? selectAll : {};
  const {
    contentStyle
  } = useWindowedListStyle();
  const flattedOptions = useMemo(() => {
    const flattened = groupedOptions.flatMap(_ref => {
      let {
        header,
        options
      } = _ref;
      return header ? [{
        header
      }, ...options] : options;
    });
    if (onSelectAll) flattened.unshift({
      selectAllFn: onSelectAll,
      label
    });
    return flattened;
  }, [groupedOptions, label, onSelectAll]);
  const renderItemContent = useCallback((_, option) => renderOption(option, props), [props]);
  const className = classNames(styles$1['windowed-list-menu'], preventOverscroll && styles$1['no-overscroll']);
  useEffect(() => {
    var _virtuosoRef$current;
    const activeIndex = flattedOptions.findIndex(option => isListOption(option) && option.value === props.activeValue || isSelectAllOption(option) && props.activeValue === selectAllValue);
    if (activeIndex < 0) return;
    (_virtuosoRef$current = virtuosoRef.current) === null || _virtuosoRef$current === void 0 ? void 0 : _virtuosoRef$current.scrollToIndex({
      index: activeIndex,
      behavior: 'smooth',
      align: 'center'
    });
  }, [flattedOptions, props.activeValue]);
  return /*#__PURE__*/jsx(Virtuoso, {
    className: className,
    ref: virtuosoRef,
    style: contentStyle,
    data: flattedOptions,
    itemContent: renderItemContent,
    defaultItemHeight: DEFAULT_OPTION_HEIGHT,
    components: {
      Header: TopPadding,
      Footer: BottomPadding,
      List: WindowedList
    }
  });
}
function WindowedContent(props) {
  return /*#__PURE__*/jsx(ListHeightProvider, {
    children: /*#__PURE__*/jsx(InnerWindowedContent, {
      ...props
    })
  });
}

/**
 * A list input with filterable options which supports selection of multiple options.
 */
function ListInput(props) {
  var _renderSummary, _renderSummary2;
  // Resources for developing custom combo boxes:
  // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
  // https://www.24a11y.com/2019/select-your-poison/
  const {
    className: callerClassName,
    disabled,
    id,
    loadingState,
    name,
    options,
    placeholder,
    isWindowed = false,
    preventOverscroll,
    renderSummary,
    tag,
    value,
    variant = 'default',
    onBlur,
    onChange,
    onFocus,
    onSearch,
    selectAll
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const extraValues = selectAll ? [selectAllValue] : undefined;
  const {
    activeOption,
    activeValue,
    filteredOptions,
    groupedOptions,
    search,
    uid,
    onSearchInput,
    onSearchKeyDown
  } = useList({
    ...props,
    onOptionSelect: handleOptionSelect,
    extraValues,
    onExtraValueSelect: selectAll === null || selectAll === void 0 ? void 0 : selectAll.onSelectAll
  });
  function handleOptionSelect(optionValue) {
    if (value == null) {
      onChange([optionValue]);
    } else if (value.includes(optionValue)) {
      onChange(value.filter(v => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  }
  const selectedOptions = options.filter(option => value === null || value === void 0 ? void 0 : value.includes(option.value));
  const selectedLabel = (_renderSummary = renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary(value)) !== null && _renderSummary !== void 0 ? _renderSummary : defaultMultiSummary(selectedOptions, formatMessage);
  const activeLabelOrPlaceholder = activeOption != null && activeValue !== selectAllValue ? (_renderSummary2 = renderSummary === null || renderSummary === void 0 ? void 0 : renderSummary([activeValue])) !== null && _renderSummary2 !== void 0 ? _renderSummary2 : activeOption === null || activeOption === void 0 ? void 0 : activeOption.label : placeholder;
  const hasAllSelected = selectedOptions.length === options.length;
  let activeId;
  if (activeValue === selectAllValue) {
    activeId = "".concat(uid, "-option--select-all");
  } else if (activeValue != null) {
    activeId = "".concat(uid, "-option-").concat(activeValue);
  }
  const ContentWrapper = isWindowed ? WindowedContent : Content;
  const tagKey = 'data-dsx--list-input';
  return /*#__PURE__*/jsx(CSSVariableProvider, {
    children: /*#__PURE__*/jsx(TagProvider, {
      tagKey: tagKey,
      tag: tag,
      children: /*#__PURE__*/jsx(List, {
        activeId: activeId,
        className: callerClassName,
        disabled: disabled,
        id: id,
        isWindowed: isWindowed,
        listId: "".concat(uid, "-list"),
        loadingState: loadingState,
        name: name,
        placeholder: activeLabelOrPlaceholder,
        preventOverscroll: preventOverscroll,
        search: search,
        selectedLabel: selectedLabel,
        value: JSON.stringify(value),
        variant: variant,
        onBlur: onBlur,
        onFocus: onFocus,
        onSearch: onSearch,
        onSearchInput: onSearchInput,
        onSearchKeyDown: onSearchKeyDown,
        children: filteredOptions.length > 0 && /*#__PURE__*/jsx(ContentWrapper, {
          groupedOptions: groupedOptions,
          activeValue: activeValue,
          hasAllSelected: hasAllSelected,
          id: uid,
          value: value,
          onOptionSelect: handleOptionSelect,
          selectAll: selectAll,
          preventOverscroll: preventOverscroll
        })
      })
    })
  });
}

// Constants derived from new FDA standards
// https://www.fda.gov/food/new-nutrition-facts-label/daily-value-new-nutrition-and-supplement-facts-labels#referenceguide

const dailyValues = {
  totalCarbohydrates: {
    value: 275,
    unit: 'g'
  },
  cholesterol: {
    value: 300,
    unit: 'mg'
  },
  totalFat: {
    value: 78,
    unit: 'g'
  },
  saturatedFat: {
    value: 20,
    unit: 'g'
  },
  transFat: {
    unit: 'g'
  },
  sodium: {
    value: 2300,
    unit: 'mg'
  },
  dietaryFiber: {
    value: 28,
    unit: 'g'
  },
  addedSugars: {
    value: 50,
    unit: 'g'
  },
  sugars: {
    unit: 'g'
  },
  protein: {
    unit: 'g',
    value: 50
  },
  vitaminD: {
    unit: 'mcg',
    value: 20
  },
  calcium: {
    unit: 'mg',
    value: 1300
  },
  iron: {
    unit: 'mg',
    value: 18
  },
  potassium: {
    unit: 'mg',
    value: 4700
  }
};
const dvPercentMessage = 'The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.';

// Conversions derived from new FDA standards (Appendix H)
// https://www.fda.gov/files/food/published/Food-Labeling-Guide-%28PDF%29.pdf

function roundToNearest(input, nearest) {
  return (Math.round(input / nearest) * nearest).toString();
}
function getCalories(value) {
  if (value < 5) return '0';
  if (value < 50) return roundToNearest(value, 5);
  return roundToNearest(value, 10);
}
function getFats(value) {
  if (value < 0.5) return '0';
  if (value < 5) return roundToNearest(value, 0.5);
  return roundToNearest(value, 1);
}
function getCholesterol(value) {
  if (value < 2) return '0';
  if (value < 5) return 'less than 5 ';
  return roundToNearest(value, 5);
}
function getSodiumPotassium(value) {
  if (value < 5) return '0';
  if (value < 140) return roundToNearest(value, 5);
  return roundToNearest(value, 10);
}
function getCarbsFibersSugars(value) {
  if (value < 0.5) return '0';
  if (value < 1) return 'less than 1 ';
  return roundToNearest(value, 1);
}
function getProtien(value) {
  if (value < 0.5) return '0';
  if (value < 1) return 'less than 1 ';
  return roundToNearest(value, 1);
}
function getVitaminMineral(value) {
  return roundToNearest(value, 1);
}
function formatValueWithUnit(props) {
  const {
    value,
    unit,
    conversion
  } = props;
  if (value === null || value === undefined || isNaN(value)) {
    return 'N/A';
  }
  if (conversion) {
    return conversion(value) + unit;
  }
  return value.toString() + unit;
}
function formatDailyValuePercent(props) {
  const {
    value,
    dvMax,
    dvPercent
  } = props;
  if (typeof dvPercent === 'number') {
    const percentage = dvPercent.toFixed(0);
    return "".concat(percentage, "%");
  }
  if (value === null || value === undefined || isNaN(value)) {
    return 'N/A';
  }
  if (dvMax === null || dvMax === undefined || isNaN(dvMax)) {
    return 'N/A';
  }
  const percentage = (value / dvMax * 100).toFixed(0);
  return "".concat(percentage, "%");
}

var css_248z = "@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&family=Archivo:wght@400;900&display=swap');\n\n/* utils */\n\n.nutrition-label-module_fixed-width__oGm4w {\n\twidth: 20rem;\n}\n\n.nutrition-label-module_bold__zMG9s {\n\tfont-weight: 900;\n}\n\n.nutrition-label-module_extra-bold__acOGr {\n\tfont-family: 'Archivo Black', sans-serif;\n}\n\n.nutrition-label-module_nowrap__ET6p7 {\n\twhite-space: nowrap;\n}\n\n.nutrition-label-module_width-100__Cvil0 {\n\twidth: 100%;\n}\n\n.nutrition-label-module_heavy-divider__qu16A {\n\tborder-bottom: 0.75rem solid var(--color-neutral-900-static);\n}\n\n.nutrition-label-module_medium-divider__Lk-99 {\n\tborder-bottom: 0.333rem solid var(--color-neutral-900-static);\n}\n\n.nutrition-label-module_light-divider__4iSwy {\n\tborder-bottom: 2px solid var(--color-neutral-900-static);\n}\n\n.nutrition-label-module_column-200__b12xY {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--size-200);\n}\n\n.nutrition-label-module_row-100__1ckRp {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: var(--size-100);\n}\n\n/* sections */\n\n.nutrition-label-module_nutrition-label__5te0r {\n\tfont-family: 'Archivo', sans-serif;\n\tcolor: var(--color-neutral-900-static);\n}\n\n.nutrition-label-module_nutrition-label__5te0r.nutrition-label-module_split__sGi9v {\n\tflex-direction: row;\n}\n\n.nutrition-label-module_primary-section__NxMtd {\n\tpadding: calc(var(--size-100) + var(--size-50));\n\tborder: 3px solid var(--color-neutral-900-static);\n\tbackground-color: var(--color-neutral-0-static);\n}\n\n.nutrition-label-module_serving-size-section__71b9e {\n\tpadding: var(--size-100) 0;\n}\n\n.nutrition-label-module_serving-size__g88wu {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: baseline;\n}\n\n/* TODO(chriswil): hacky */\n.nutrition-label-module_serving-size__g88wu input {\n\tborder: 2px solid black !important;\n\tborder-radius: 0 !important;\n\tbackground-color: var(--color-neutral-0-static) !important;\n\tcolor: var(--color-neutral-900-static) !important;\n}\n.nutrition-label-module_serving-size__g88wu input {\n\tpadding: 0 var(--size-100);\n\tmax-width: var(--size-800);\n}\n\n.nutrition-label-module_nutrition-facts__Lfiog {\n\tpadding-bottom: var(--size-100);\n\tfont-size: 2.25rem;\n\tline-height: 1;\n}\n\n.nutrition-label-module_calories-section__QoEfI {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tline-height: 1.1;\n}\n\n.nutrition-label-module_calories-label__--qWr {\n\tfont-size: 1.5rem;\n}\n\n.nutrition-label-module_calories-count__EnVB0 {\n\tfont-size: 3rem;\n}\n\n.nutrition-label-module_dv-header-line__Uz4OA {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.nutrition-label-module_nutrition-line__w7-gx {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tborder-top: 1px solid var(--color-neutral-900-static);\n}\n\n.nutrition-label-module_secondary-section-container__P7GHf {\n\tfont-size: 0.75rem;\n}\n\n.nutrition-label-module_secondary-section__5cnhg {\n\tbackground-color: var(--color-neutral-0-static);\n\tborder: 0.2rem solid var(--color-neutral-900-static);\n\tpadding: calc(var(--size-100) + var(--size-50));\n}\n\n.nutrition-label-module_secondary-label__KNwF- {\n\ttext-transform: uppercase;\n\tmargin-right: var(--size-100);\n\tfont-weight: 900;\n}\n\n.nutrition-label-module_nutrition-line__w7-gx dd {\n\tmargin: 0;\n}\n\n.nutrition-label-module_indent__OuUkU {\n\tpadding-left: 1.5rem;\n}\n\n.nutrition-label-module_added-sugars__NwcrH {\n\tmargin-left: 3rem;\n}\n\n.nutrition-label-module_dv-disclaimer__IaUaV {\n\tdisplay: flex;\n\tgap: var(--size-100);\n\tfont-size: 0.75rem;\n\tmargin-top: var(--size-100);\n}\n";
var styles = {"fixed-width":"nutrition-label-module_fixed-width__oGm4w","bold":"nutrition-label-module_bold__zMG9s","extra-bold":"nutrition-label-module_extra-bold__acOGr","nowrap":"nutrition-label-module_nowrap__ET6p7","width-100":"nutrition-label-module_width-100__Cvil0","heavy-divider":"nutrition-label-module_heavy-divider__qu16A","medium-divider":"nutrition-label-module_medium-divider__Lk-99","light-divider":"nutrition-label-module_light-divider__4iSwy","column-200":"nutrition-label-module_column-200__b12xY","row-100":"nutrition-label-module_row-100__1ckRp","nutrition-label":"nutrition-label-module_nutrition-label__5te0r","split":"nutrition-label-module_split__sGi9v","primary-section":"nutrition-label-module_primary-section__NxMtd","serving-size-section":"nutrition-label-module_serving-size-section__71b9e","serving-size":"nutrition-label-module_serving-size__g88wu","nutrition-facts":"nutrition-label-module_nutrition-facts__Lfiog","calories-section":"nutrition-label-module_calories-section__QoEfI","calories-label":"nutrition-label-module_calories-label__--qWr","calories-count":"nutrition-label-module_calories-count__EnVB0","dv-header-line":"nutrition-label-module_dv-header-line__Uz4OA","nutrition-line":"nutrition-label-module_nutrition-line__w7-gx","secondary-section-container":"nutrition-label-module_secondary-section-container__P7GHf","secondary-section":"nutrition-label-module_secondary-section__5cnhg","secondary-label":"nutrition-label-module_secondary-label__KNwF-","indent":"nutrition-label-module_indent__OuUkU","added-sugars":"nutrition-label-module_added-sugars__NwcrH","dv-disclaimer":"nutrition-label-module_dv-disclaimer__IaUaV"};
styleInject(css_248z);

function NutritionLabel(props) {
  const {
    className: callerClassName,
    nutrition,
    tag,
    layout = 'single'
  } = props;
  const {
    valueCalories,
    valueTotalCarb,
    valueCholesterol,
    valueDisclaimer,
    valueTotalFat,
    ingredientList,
    containsList,
    mayContainsList,
    freeFromList,
    dietTypeList,
    claimsList,
    servingSize,
    valueProteins,
    percentProteins,
    valueSatFat,
    valueSodium,
    valueSugars,
    valueTransFat,
    valueFibers,
    valueAddedSugars,
    valueVitaminD,
    valueCalcium,
    valueIron,
    valuePotassium
  } = nutrition;
  const [servingQuantity, setServingQuantity] = useState(1);
  const handleServingQuantityChange = useCallback(value => {
    const newQuantity = Number(value);
    setServingQuantity(newQuantity >= 0 ? newQuantity : 0);
  }, [setServingQuantity]);
  const primarySectionEl = /*#__PURE__*/jsxs("div", {
    className: classNames(styles['fixed-width'], styles['primary-section']),
    children: [/*#__PURE__*/jsx("div", {
      className: classNames(styles['extra-bold'], styles['nutrition-facts'], styles['light-divider']),
      children: "Nutrition Facts"
    }), /*#__PURE__*/jsxs("div", {
      className: classNames(styles['serving-size-section'], styles['heavy-divider']),
      children: [servingSize && /*#__PURE__*/jsxs("div", {
        className: styles['serving-size'],
        children: [/*#__PURE__*/jsx("span", {
          children: "Serving size"
        }), /*#__PURE__*/jsx("span", {
          itemProp: "servingSize",
          children: servingSize
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: styles['serving-size'],
        children: [/*#__PURE__*/jsx("span", {
          className: classNames(styles['bold'], styles['width-100']),
          children: "Serving quantity"
        }), /*#__PURE__*/jsx(NumberInput, {
          value: servingQuantity.toString(),
          onChange: handleServingQuantityChange
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: classNames(styles['calories-section'], styles['extra-bold'], styles['medium-divider']),
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("div", {
          className: styles['nowrap'],
          children: "Amount per serving"
        }), /*#__PURE__*/jsx("div", {
          className: styles['calories-label'],
          children: "Calories"
        })]
      }), /*#__PURE__*/jsx("span", {
        className: styles['calories-count'],
        itemProp: "calories",
        children: valueCalories === undefined ? 'N/A' : getCalories(servingQuantity * valueCalories)
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: styles['heavy-divider'],
      children: [/*#__PURE__*/jsx("div", {
        className: classNames(styles['dv-header-line'], styles['bold']),
        children: "% Daily Value*"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Total Fat",
        unit: dailyValues.totalFat.unit,
        value: valueTotalFat === undefined ? undefined : servingQuantity * valueTotalFat,
        conversion: getFats,
        dvMax: dailyValues.totalFat.value,
        itemProp: "fatContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Saturated Fat",
        bold: false,
        unit: dailyValues.saturatedFat.unit,
        value: valueSatFat === undefined ? undefined : servingQuantity * valueSatFat,
        conversion: getFats,
        dvMax: dailyValues.saturatedFat.value,
        indent: true,
        itemProp: "saturatedFatContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: /*#__PURE__*/jsxs("span", {
          children: [/*#__PURE__*/jsx("em", {
            children: "Trans"
          }), " Fat"]
        }),
        bold: false,
        unit: dailyValues.transFat.unit,
        value: valueTransFat === undefined ? undefined : servingQuantity * valueTransFat,
        conversion: getFats,
        indent: true,
        itemProp: "transFatContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Cholesterol",
        unit: dailyValues.cholesterol.unit,
        value: valueCholesterol === undefined ? undefined : servingQuantity * valueCholesterol,
        conversion: getCholesterol,
        dvMax: dailyValues.cholesterol.value,
        itemProp: "cholesterolContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Sodium",
        unit: dailyValues.sodium.unit,
        value: valueSodium === undefined ? undefined : servingQuantity * valueSodium,
        conversion: getSodiumPotassium,
        dvMax: dailyValues.sodium.value,
        itemProp: "sodiumContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Total Carbohydrates",
        unit: dailyValues.totalCarbohydrates.unit,
        value: valueTotalCarb === undefined ? undefined : servingQuantity * valueTotalCarb,
        conversion: getCarbsFibersSugars,
        dvMax: dailyValues.totalCarbohydrates.value,
        itemProp: "carbohydrateContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Dietary Fiber",
        bold: false,
        unit: dailyValues.dietaryFiber.unit,
        value: valueFibers === undefined ? undefined : servingQuantity * valueFibers,
        conversion: getCarbsFibersSugars,
        dvMax: dailyValues.dietaryFiber.value,
        indent: true,
        itemProp: "fiberContent"
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Total Sugars",
        bold: false,
        unit: dailyValues.sugars.unit,
        value: valueSugars === undefined ? undefined : servingQuantity * valueSugars,
        conversion: getCarbsFibersSugars,
        indent: true,
        itemProp: "sugarContent"
      }), /*#__PURE__*/jsx(AddedSugarsLine, {
        unit: dailyValues.addedSugars.unit,
        value: valueAddedSugars === undefined ? undefined : servingQuantity * valueAddedSugars,
        conversion: getCarbsFibersSugars,
        dvMax: dailyValues.addedSugars.value
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Protein",
        unit: dailyValues.protein.unit,
        value: valueProteins === undefined ? undefined : servingQuantity * valueProteins,
        dvPercent: percentProteins,
        conversion: getProtien,
        itemProp: "proteinContent"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: styles['medium-divider'],
      children: [/*#__PURE__*/jsx(NutritionLine, {
        label: "Vitamin D",
        unit: dailyValues.vitaminD.unit,
        value: valueVitaminD === undefined ? undefined : servingQuantity * valueVitaminD,
        conversion: getVitaminMineral,
        dvMax: dailyValues.vitaminD.value
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Calcium",
        unit: dailyValues.calcium.unit,
        value: valueCalcium === undefined ? undefined : servingQuantity * valueCalcium,
        conversion: getVitaminMineral,
        dvMax: dailyValues.calcium.value
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Iron",
        unit: dailyValues.iron.unit,
        value: valueIron === undefined ? undefined : servingQuantity * valueIron,
        conversion: getVitaminMineral,
        dvMax: dailyValues.iron.value
      }), /*#__PURE__*/jsx(NutritionLine, {
        label: "Potassium",
        unit: dailyValues.potassium.unit,
        value: valuePotassium === undefined ? undefined : servingQuantity * valuePotassium,
        conversion: getSodiumPotassium,
        dvMax: dailyValues.potassium.value
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: styles['dv-disclaimer'],
      children: [/*#__PURE__*/jsx("div", {
        children: "*"
      }), /*#__PURE__*/jsx("div", {
        children: dvPercentMessage
      })]
    })]
  });
  const secondarySectionEl = /*#__PURE__*/jsxs("div", {
    className: classNames(styles['fixed-width'], styles['column-200'], styles['secondary-section-container']),
    children: [/*#__PURE__*/jsxs("div", {
      className: classNames(styles['secondary-section'], styles['column-200']),
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("span", {
          className: styles['secondary-label'],
          children: "Ingredients:"
        }), ingredientList ? ingredientList : 'N/A']
      }), containsList && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("span", {
          className: styles['secondary-label'],
          children: "Contains:"
        }), containsList]
      }), mayContainsList && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("span", {
          className: styles['secondary-label'],
          children: "May Contain:"
        }), mayContainsList]
      }), freeFromList && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("span", {
          className: styles['secondary-label'],
          children: "Free From:"
        }), freeFromList]
      })]
    }), dietTypeList && /*#__PURE__*/jsxs("div", {
      className: styles['secondary-section'],
      children: [/*#__PURE__*/jsx("span", {
        className: styles['secondary-label'],
        children: "Diet Type:"
      }), dietTypeList]
    }), claimsList && /*#__PURE__*/jsxs("div", {
      className: styles['secondary-section'],
      children: [/*#__PURE__*/jsx("span", {
        className: styles['secondary-label'],
        children: "Claims:"
      }), claimsList]
    }), /*#__PURE__*/jsxs("div", {
      className: classNames(styles['secondary-section'], styles['column-200']),
      children: [valueDisclaimer && /*#__PURE__*/jsx("div", {
        children: valueDisclaimer
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("span", {
          className: styles['secondary-label'],
          children: "IMPORTANT DISCLAIMER:"
        }), ' ', "Values labeled as 'N/A' are not provided by the manufacturer. These values are unknown."]
      })]
    })]
  });
  return /*#__PURE__*/jsxs("div", {
    className: classNames(callerClassName, styles['nutrition-label'], styles['column-200'], layout === 'split' && styles['split']),
    itemScope: true,
    itemType: "http://schema.org/NutritionInformation",
    "data-contrib--nutrition-label": tag,
    children: [primarySectionEl, secondarySectionEl]
  });
}
function NutritionLine(props) {
  const {
    label,
    dvPercent,
    dvMax,
    indent,
    itemProp,
    bold = true
  } = props;
  return /*#__PURE__*/jsxs("div", {
    className: classNames(styles['nutrition-line'], indent && styles['indent']),
    children: [/*#__PURE__*/jsxs("div", {
      className: styles['row-100'],
      children: [/*#__PURE__*/jsx("dt", {
        className: classNames(bold && styles['bold']),
        children: label
      }), /*#__PURE__*/jsx("dd", {
        itemProp: itemProp,
        children: formatValueWithUnit(props)
      })]
    }), (dvMax || dvPercent) && /*#__PURE__*/jsx("span", {
      className: styles.bold,
      children: formatDailyValuePercent(props)
    })]
  });
}
function AddedSugarsLine(props) {
  const {
    dvMax
  } = props;
  return /*#__PURE__*/jsxs("div", {
    className: classNames(styles['nutrition-line'], styles['added-sugars']),
    children: [/*#__PURE__*/jsxs("span", {
      children: ["Includes ", formatValueWithUnit(props), " Added Sugars"]
    }), dvMax && /*#__PURE__*/jsx("span", {
      children: formatDailyValuePercent(props)
    })]
  });
}

export { ActionBar, BarChart, ChatInterface, CollapsibleElement, CurveType$1 as CurveType, DataTable, GraphAlign$1 as GraphAlign, HighlightAmount$1 as HighlightAmount, KeyValuePairs, LineDataType$1 as LineDataType, LineGraph, ListInput, MessageDataType, MessageOrigin, NutritionLabel, PieChart, StrokeType$1 as StrokeType, VisualizationType };
